webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05646235_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(345);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05646235_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1c301e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(347);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1c301e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f00d4ef6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(344);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f00d4ef6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a826dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__ = __webpack_require__(375);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a826dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignCarousel_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0eaaaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignCarousel_vue__ = __webpack_require__(377);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0eaaaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerStatistics_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d122c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerStatistics_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerStatistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35d122c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerStatistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App"
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HomeDefault__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HomeMatchDay__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_HomeAfterMatch__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HomeLiveMatch__ = __webpack_require__(383);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    HomeDefault: __WEBPACK_IMPORTED_MODULE_3__components_HomeDefault__["a" /* default */],
    HomeMatchDay: __WEBPACK_IMPORTED_MODULE_4__components_HomeMatchDay__["a" /* default */],
    HomeAfterMatch: __WEBPACK_IMPORTED_MODULE_5__components_HomeAfterMatch__["a" /* default */],
    HomeLiveMatch: __WEBPACK_IMPORTED_MODULE_6__components_HomeLiveMatch__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Header",
  props: ["title", "hideMore"],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Footer",
  methods: {
    toggleMenu: function toggleMenu() {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").hasClass("menu-open")) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").removeClass("menu-open");
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").addClass("menu-open");
      }
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Menu",
  methods: {
    toggleMenu: function toggleMenu() {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").hasClass("menu-open")) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").removeClass("menu-open");
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").addClass("menu-open");
      }
    },
    signOut: function signOut() {
      localStorage.removeItem("user");
      this.$store.state.user = null;
      this.$router.push({ name: "Home" });
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MatchVS__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Leader__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HomeDefault",
  props: ["title"],
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    MatchVS: __WEBPACK_IMPORTED_MODULE_3__components_MatchVS__["a" /* default */],
    Leader: __WEBPACK_IMPORTED_MODULE_4__components_Leader__["a" /* default */]
  },
  data: function data() {
    return {
      currentDate: Date.now(),
      moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a,
      news: [],
      campaigns: [],
      matches: [],
      stats: [],
      data: {
        dateTime: new Date('30 May 2021 21:30 UTC+3')
      }
    };
  },

  methods: {
    getNews: function getNews(slug) {
      var _this = this;

      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get("/haber/detay?slug=" + slug).then(function (res) {
        _this.$store.state.loading = false;
        _this.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug: slug }
        });
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.$refs.matchCarousel.navigateTo = 1;
    }, 1000);
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    /** setInterval(() => {
      this.currentDate = Date.now();
      this.dateTime = new Date('30 May 2021 21:30 UTC+3');
      var diff = this.dateTime - this.currentDate;
      var duration = moment.duration(diff, "milliseconds");
      this.duration = moment.duration(duration - 1000, "milliseconds");
    }, 1000); **/

    this.$store.state.loading = true;

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("haber").then(function (res) {
      _this3.$store.state.loading = false;

      _this3.news = res.data.headlines;
    });

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("kampanya/liste").then(function (res) {
      var data = [];
      res.data.data.map(function (item, index) {
        if (index <= 4) {
          data.push(item);
        }
      });
      _this3.campaigns = data;
    });

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("mac-listesi/homepage").then(function (res) {
      _this3.matches = res.data.data;
    });

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("istatistik/home").then(function (res) {
      var data = [];

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Sayı"
      }, res.data.hallOfFame.scorer[0]));

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Asist"
      }, res.data.hallOfFame.assister[0]));

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Ribaund"
      }, res.data.hallOfFame.rebounder[0]));

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Blok"
      }, res.data.hallOfFame.block[0]));

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Top Çalma"
      }, res.data.hallOfFame.steals[0]));

      _this3.stats = data;
    });
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatchVS_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09b72d26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatchVS_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatchVS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09b72d26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatchVS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MatchVS",
  props: ["data", "hideAll"]
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leader_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b83ee43e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Leader_vue__ = __webpack_require__(354);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b83ee43e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Leader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Leader",
  props: ["hideFloat", "hideLeader", "title", "data"],
  data: function data() {
    return {
      pageIndex: 0
    };
  },

  methods: {
    pageChanged: function pageChanged(index) {
      this.pageIndex = index;
    }
  }
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Comment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Mvp__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CampaignCarousel__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HomeMatchDay",
  props: ["title"],
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_1__components_Menu__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_2__components_Comment__["a" /* default */],
    Mvp: __WEBPACK_IMPORTED_MODULE_3__components_Mvp__["a" /* default */],
    CampaignCarousel: __WEBPACK_IMPORTED_MODULE_4__components_CampaignCarousel__["a" /* default */]
  },
  data: function data() {
    return {
      currentDate: Date.now(),
      moment: __WEBPACK_IMPORTED_MODULE_6_moment___default.a,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          },
          away: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          }
        }
      },
      activeSlide: 0,
      id: this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message: "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0,
      duration: null
    };
  },
  created: function created() {
    this.$store.state.loading = true;
  },
  beforeMount: function beforeMount() {
    var _this = this;

    setInterval(function () {
      _this.currentDate = Date.now();

      var diff = _this.data.dateTime - _this.currentDate;
      var duration = __WEBPACK_IMPORTED_MODULE_6_moment___default.a.duration(diff, "milliseconds");
      _this.duration = __WEBPACK_IMPORTED_MODULE_6_moment___default.a.duration(duration - 1000, "milliseconds");
    }, 1000);

    var data = new FormData();
    data.append("id", this.$store.state.app.match.related_campaign);

    if (this.$store.state.user != null) {
      data.append("email", this.$store.state.user.email);
      data.append("token", this.$store.state.user.token);

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("kampanya/checkin-olmus-mu", data).then(function (res) {
        _this.checked_in = res.data.checked_in;
      });
    }

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("kampanya/liste").then(function (res) {
      var data = [];
      res.data.data.map(function (item, index) {
        if (index <= 4) {
          data.push(item);
        }
      });
      _this.campaigns = data;
    });
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("istatistik/detay?id=" + this.id).then(function (res) {
      _this.data = res.data.data;
      _this.data.dateTime = res.data.data.timestamp * 1000;
      var data = [];

      res.data.data.highlights.map(function (item) {
        data.push({
          name: item.name,
          photo: item.image,
          stats: [{
            title: "Sayı",
            value: item.statistics.all.score
          }, {
            title: "Ribaund",
            value: item.statistics.all.totalRebounds
          }, {
            title: "Asist",
            value: item.statistics.all.assists
          }]
        });
      });

      _this.stats = data;

      setTimeout(function () {
        _this.$store.state.loading = false;
      }, 250);
    });

    this.getComments();
  },

  methods: {
    getNews: function getNews(slug) {
      var _this2 = this;

      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/haber/detay?slug=" + slug).then(function (res) {
        _this2.$store.state.loading = false;
        _this2.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug: slug }
        });
      });
    },
    getComments: function getComments() {
      var _this3 = this;

      var data = new FormData();
      data.append("id", this.$store.state.app.match.id);
      data.append("type", "match");
      data.append("user_token", this.$store.state.user.token);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("yorum", data).then(function (res) {
        _this3.comments = res.data.data.comments;
      });
    },
    checkIn: function checkIn() {
      var _this4 = this;

      if (this.$store.state.user == null) {
        this.$router.push({ name: "Login" });
      } else {
        this.$store.state.loading = true;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (pos) {
            var data = new FormData();
            data.append("id", _this4.$store.state.app.match.related_campaign);
            data.append("email", _this4.$store.state.user.email);
            data.append("token", _this4.$store.state.user.token);
            data.append("latitude", pos.coords.latitude);
            data.append("longitude", pos.coords.longitude);

            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("kampanya/katil", data).then(function (res) {
              _this4.$store.state.loading = false;
              if (res.data.data.status == true) {
                _this4.checked_in = true;

                _this4.$router.push({
                  name: "Success",
                  params: { data: res.data.data }
                });
              } else {
                _this4.$notify({
                  title: "Hata",
                  message: res.data.data.error,
                  type: "error"
                });
              }
            });
          }, function (error) {
            _this4.$store.state.loading = false;
            switch (error.code) {
              case error.PERMISSION_DENIED:
                _this4.$notify({
                  title: "Hata",
                  message: "Konum izni vermediğiniz için check-in yapamazsınız. Lütfen ayarlardan izin erip tekrar deneyin.",
                  type: "error"
                });
                break;
              case error.POSITION_UNAVAILABLE:
                _this4.$notify({
                  title: "Hata",
                  message: "Konum alınamadı. Telefonunuzun internet ve gps bağlantısının olduğundan emin olun.",
                  type: "error"
                });
                break;
              case error.TIMEOUT:
                _this4.$notify({
                  title: "Hata",
                  message: "Konumunuzu almamız çok uzun sürdü. Lütfen tekrar deneyin",
                  type: "error"
                });
                break;
              case error.UNKNOWN_ERROR:
                _this4.$notify({
                  title: "Hata",
                  message: "Bilinmeyen bir hata oluştur. Lütfen tekrar deneyin.",
                  type: "error"
                });
                break;
            }
          });
        }
      }
    },
    sendComment: function sendComment() {
      var _this5 = this;

      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "match");
      data.append("id", this.$store.state.app.match.id);

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("yorum/ekle", data).then(function (res) {
        if (res.data.status != true) {
          _this5.$notify({
            title: "Hata",
            message: res.data.data,
            type: "error"
          });
        } else {
          _this5.comment = null;
          _this5.getComments();
          _this5.$notify({
            title: "Başarılı",
            message: "Başarıyla yorum yapıldı.",
            type: "success"
          });
        }

        _this5.getComments();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Comment",
  props: ["data"],
  data: function data() {
    return {
      comment_id: null,
      lock: false
    };
  },

  methods: {
    showActionSheet: function showActionSheet() {
      if (!this.$store.getters.isLogged) {
        this.$router.push({ name: "Login" });
        return;
      }
      this.$iosActionSheet([{
        label: true,
        text: "Şikayet Et"
      }, {
        text: "Uygunsuz içerik",
        handle: this.complain(0)
      }, {
        text: "Reklam içeriyor",
        handle: this.complain(1)
      }, {
        text: "Vazgeç"
      }]);
    },
    complain: function complain(index, id) {
      var _this = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("comment_id", this.comment_id);
      data.append("complain_reason", index == 1 ? "Uygunsuz içerik" : "Reklam içeriyor");

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("yorum/sikayet", data).then(function (res) {
        _this.$emit("commentDeleted");
        _this.$notify({
          title: "Başarılı",
          message: res.data.message,
          type: "success"
        });
      });
    },
    getProfile: function getProfile(id) {
      var _this2 = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/profil", data).then(function (res) {
        if (res.data.status == 401) {
          _this2.$message.error(res.data.data);
          return;
        }
        _this2.$router.push({
          name: "UserProfile",
          params: {
            data: res.data.data,
            id: res.data.data.id,
            slug: res.data.data.slug
          }
        });
      });
    },
    toggleLike: function toggleLike(id) {
      var _this3 = this;

      if (this.lock == true) {
        return;
      }
      this.lock = true;
      var data = new FormData();
      data.append("comment_id", id);
      data.append("user_token", this.$store.state.user.token);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("yorum/begen", data).then(function (res) {
        setTimeout(function () {
          _this3.lock = false;
        }, 1000);
        var index = _this3.data.findIndex(function (k) {
          return k.id == id;
        });
        _this3.data[index].is_liked = res.data.like_count > _this3.data[index].like_count ? true : false;
        _this3.data[index].like_count = res.data.like_count;
      }).catch(function (err) {
        setTimeout(function () {
          _this3.lock = false;
        }, 1000);
      });
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mvp_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c310a998_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mvp_vue__ = __webpack_require__(376);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mvp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c310a998_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mvp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Mvp",
  props: ["hideFloat", "hideLeader", "title", "data"],
  data: function data() {
    return {
      pageIndex: 0
    };
  },

  methods: {
    pageChanged: function pageChanged(index) {
      this.pageIndex = index;
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CampaignCarousel",
  props: ["data"],
  data: function data() {
    return {
      pageIndex: 0
    };
  },

  methods: {
    pageChanged: function pageChanged(index) {
      this.pageIndex = index;
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeAfterMatch_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f301de86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeAfterMatch_vue__ = __webpack_require__(382);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeAfterMatch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f301de86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeAfterMatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Gallery__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Comment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Leader__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PlayerStatistics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HomeAfterMatch",
  props: ["title"],
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_4__components_Comment__["a" /* default */],
    PlayerStatistics: __WEBPACK_IMPORTED_MODULE_6__components_PlayerStatistics__["a" /* default */],
    Leader: __WEBPACK_IMPORTED_MODULE_5__components_Leader__["a" /* default */],
    Gallery: __WEBPACK_IMPORTED_MODULE_3__components_Gallery__["a" /* default */]
  },
  data: function data() {
    return {
      tab: null,
      statisticsType: "home",
      currentDate: new Date().getTime(),
      moment: __WEBPACK_IMPORTED_MODULE_8_moment___default.a,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          },
          away: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          }
        }
      },
      activeSlide: 0,
      id: this.$route.params.id || this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message: "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0
    };
  },

  methods: {
    getNews: function getNews(slug) {
      var _this = this;

      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get("/haber/detay?slug=" + slug).then(function (res) {
        _this.$store.state.loading = false;
        _this.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug: slug }
        });
      });
    },
    changeTab: function changeTab(tabName) {
      if (tabName == "Anadolu Efes") {
        this.isAnadoluEfes = true;
      } else {
        this.isAnadoluEfes = false;
      }
      this.tab = tabName;
    },
    getComments: function getComments() {
      var _this2 = this;

      var data = new FormData();
      data.append("id", this.id);
      data.append("type", "match");
      data.append("user_token", this.$store.state.user.token);
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("yorum", data).then(function (res) {
        _this2.comments = res.data.data.comments;
      });
    },
    sendComment: function sendComment() {
      var _this3 = this;

      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "match");
      data.append("id", this.id);

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("yorum/ekle", data).then(function (res) {
        if (res.data.status != true) {
          _this3.$notify({
            title: "Hata",
            message: res.data.data,
            type: "error"
          });
        } else {
          _this3.comment = null;
          _this3.getComments();
          _this3.$notify({
            title: "Başarılı",
            message: "Başarıyla yorum yapıldı.",
            type: "success"
          });
        }

        _this3.getComments();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("kampanya/liste").then(function (res) {
      _this4.campaigns = res.data.data;
    });
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get("istatistik/detay?id=" + this.id).then(function (res) {
      if (res.data.data.related.galleries.length != 0) {
        var g = [];
        res.data.data.related.galleries[0].gallery.map(function (item) {
          g.push({
            image_thumb: item.image[2].thumb_480,
            image: item.image[0].original
          });
        });

        _this4.gallery = g;
      }
      _this4.data = res.data.data;

      if (res.data.data.awayTeam.name.toLowerCase() == "anadolu efes") {
        _this4.statisticsType = "away";
      }

      var data = [];

      if (res.data.data.highlights) {
        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Sayı"
        }, res.data.data.highlights.topScorer, {
          metric: res.data.data.highlights.topScorer.score
        }));

        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Asist"
        }, res.data.data.highlights.topAssister, {
          metric: res.data.data.highlights.topAssister.score
        }));

        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Ribaund"
        }, res.data.data.highlights.topRebounder, {
          metric: res.data.data.highlights.topRebounder.score
        }));

        if (res.data.data.highlights.topStealer != undefined) {
          data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            title: "Top Çalma"
          }, res.data.data.highlights.topStealer, {
            metric: res.data.data.highlights.topStealer.score
          }));
        }

        if (res.data.data.highlights.topBlocker != undefined) {
          data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            title: "Blok"
          }, res.data.data.highlights.topBlocker, {
            metric: res.data.data.highlights.topBlocker.score
          }));
        }

        _this4.stats = data;
      } else {
        _this4.stats = [];
      }

      setTimeout(function () {
        _this4.$store.state.loading = false;
      }, 250);
    });

    this.getComments();
  },
  mounted: function mounted() {
    var _this5 = this;

    setTimeout(function () {
      _this5.$refs.newsCarousel.navigateTo = _this5.data.related.news.length - 1;
    }, 1000);
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ffedee8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__(379);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ffedee8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Gallery",
  props: ["data", "isLimited"],
  data: function data() {
    return {
      index: 0,
      modal: false,
      limited: this.isLimited
    };
  },

  methods: {
    showImage: function showImage(index) {
      this.index = index;
      this.modal = true;
    },
    pageChanged: function pageChanged(index) {
      this.index = index;
    }
  },
  computed: {
    otherImages: function otherImages() {
      var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));

      data.splice(0, 5);
      var data2 = [];

      data.map(function (item) {
        data2.push(item.image_thumb);
      });

      return data2;
    }
  },
  watch: {
    modal: function modal() {
      var _this = this;

      if (this.modal == true) {
        setTimeout(function () {
          _this.$refs.carousel.navigateTo = _this.index;
        }, 100);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()("body").addClass("modal-on");
      } else {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()("body").removeClass("modal-on");
      }
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PlayerStatistics",
  props: ["title", "isAnadoluEfes", "data"],
  components: {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Comment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Mvp__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CampaignCarousel__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PlayerStatistics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CheckIn__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HomeLiveMatch",
  props: ["title"],
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_3__components_Comment__["a" /* default */],
    Mvp: __WEBPACK_IMPORTED_MODULE_4__components_Mvp__["a" /* default */],
    CampaignCarousel: __WEBPACK_IMPORTED_MODULE_5__components_CampaignCarousel__["a" /* default */],
    PlayerStatistics: __WEBPACK_IMPORTED_MODULE_6__components_PlayerStatistics__["a" /* default */],
    CheckIn: __WEBPACK_IMPORTED_MODULE_7__components_CheckIn__["a" /* default */]
  },
  data: function data() {
    return {
      tab: null,
      statisticsType: "home",
      currentDate: new Date().getTime(),
      moment: __WEBPACK_IMPORTED_MODULE_9_moment___default.a,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          },
          away: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          }
        }
      },
      activeSlide: 0,
      id: this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message: "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0,
      match: {
        id: null,
        location: null,
        tournamentId: "",
        tournamentName: "",
        homeTeam: {
          name: "Anadolu Efes",
          logo_url: ""
        },
        awayTeam: {
          name: "",
          logo_url: ""
        },
        date: "",
        date2: "",
        status: "",
        score1: "",
        score2: "",
        timeMinute: "",
        timeSecond: ""
      }
    };
  },
  created: function created() {
    this.$store.state.loading = true;
  },
  beforeMount: function beforeMount() {
    var _this = this;

    setInterval(function () {
      _this.currentDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()()._d.getTime();
    }, 1000);

    var data = new FormData();

    __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post("kampanya/liste").then(function (res) {
      var data = [];
      res.data.data.map(function (item, index) {
        if (index <= 4) {
          data.push(item);
        }
      });
      _this.campaigns = data;
    });
    __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get("istatistik/detay?id=" + this.id).then(function (res) {
      _this.data = res.data.data;

      if (res.data.data.awayTeam.name.toLowerCase() == "anadolu efes") {
        _this.statisticsType = "away";
      }

      var data = [];

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Sayı"
      }, res.data.data.highlights.topScorer, {
        metric: res.data.data.highlights.topScorer.score
      }));

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Asist"
      }, res.data.data.highlights.topAssister, {
        metric: res.data.data.highlights.topAssister.score
      }));

      data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        title: "Ribaund"
      }, res.data.data.highlights.topRebounder, {
        metric: res.data.data.highlights.topRebounder.score
      }));

      if (res.data.data.highlights.topStealer != undefined) {
        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Top Çalma"
        }, res.data.data.highlights.topStealer, {
          metric: res.data.data.highlights.topStealer.score
        }));
      }

      if (res.data.data.highlights.topBlocker != undefined) {
        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Blok"
        }, res.data.data.highlights.topBlocker, {
          metric: res.data.data.highlights.topBlocker.score
        }));
      }

      _this.stats = data;

      setTimeout(function () {
        _this.$store.state.loading = false;
      }, 250);
    });

    __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post("istatistik/live").then(function (res) {
      _this.match = res.data.match;
    });

    setInterval(function () {
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post("istatistik/live").then(function (res) {
        _this.match = res.data.match;
      }).catch(function (err) {
        console.log(err);
      });

      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get("istatistik/detay?id=" + _this.id).then(function (res) {
        _this.data = res.data.data;
        var data = [];

        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Sayı"
        }, res.data.data.highlights.topScorer, {
          metric: res.data.data.highlights.topScorer.score
        }));

        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Asist"
        }, res.data.data.highlights.topAssister, {
          metric: res.data.data.highlights.topAssister.score
        }));

        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          title: "Ribaund"
        }, res.data.data.highlights.topRebounder, {
          metric: res.data.data.highlights.topRebounder.score
        }));

        if (res.data.data.highlights.topStealer != undefined) {
          data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            title: "Top Çalma"
          }, res.data.data.highlights.topStealer, {
            metric: res.data.data.highlights.topStealer.score
          }));
        }

        if (res.data.data.highlights.topBlocker != undefined) {
          data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            title: "Blok"
          }, res.data.data.highlights.topBlocker, {
            metric: res.data.data.highlights.topBlocker.score
          }));
        }

        _this.stats = data;

        if (res.data.data.related.galleries.length != 0) {
          var g = [];
          res.data.data.related.galleries[0].gallery.map(function (item) {
            g.push({
              image_thumb: item.image[1].thumb_480,
              image: item.image[0].original
            });
          });

          _this.gallery = g;
        }
      });
    }, 25000);

    this.getComments();
  },

  methods: {
    sendComment: function sendComment() {
      var _this2 = this;

      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "match");
      data.append("id", this.$store.state.app.match.id);

      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post("yorum/ekle", data).then(function (res) {
        if (res.data.status != true) {
          _this2.$notify({
            title: "Hata",
            message: res.data.data,
            type: "error"
          });
        } else {
          _this2.comment = null;
          _this2.getComments();
          _this2.$notify({
            title: "Başarılı",
            message: "Başarıyla yorum yapıldı.",
            type: "success"
          });
        }

        _this2.getComments();
      }).catch(function (err) {
        console.log(err);
      });
    },
    getNews: function getNews(slug) {
      var _this3 = this;

      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get("/haber/detay?slug=" + slug).then(function (res) {
        _this3.$store.state.loading = false;
        _this3.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug: slug }
        });
      });
    },
    getComments: function getComments() {
      var _this4 = this;

      var data = new FormData();
      data.append("id", this.$store.state.app.match.id);
      data.append("type", "match");
      data.append("user_token", this.$store.state.user.token);
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post("yorum", data).then(function (res) {
        _this4.comments = res.data.data.comments;
      });
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pusher_js__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pusher_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pusher_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CheckIn",
  data: function data() {
    return {
      tab: null,
      statisticsType: "home",
      currentDate: new Date().getTime(),
      moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 0,
            Q2: 0,
            Q3: 0,
            Q4: 0
          },
          away: {
            final: 0,
            Q1: 0,
            Q2: 0,
            Q3: 0,
            Q4: 0
          }
        }
      },
      activeSlide: 0,
      id: this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message: "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0,
      match: {
        id: null,
        location: null,
        tournamentId: "",
        tournamentName: "",
        homeTeam: {
          name: "Anadolu Efes",
          logo_url: ""
        },
        awayTeam: {
          name: "",
          logo_url: ""
        },
        date: "",
        date2: "",
        status: "",
        score1: "",
        score2: "",
        timeMinute: "",
        timeSecond: ""
      },
      checkInType: null,
      checkedInType: null,
      checkIns: [],
      totalCheckin: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    var pusher = new __WEBPACK_IMPORTED_MODULE_1_pusher_js___default.a(this.$store.state.pusher_staging, {
      cluster: "eu"
    });
    pusher.subscribe("live-match-checkin-" + this.$store.state.app.match.id);
    pusher.bind("live-match-checkin-event", function (data) {
      _this.checkIns.push(data);
      _this.totalCheckin += 1;
    });

    var data = new FormData();
    data.append("match_id", this.$store.state.app.match.id);
    data.append("page", 1);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/maca-checkin-yapanlar", data).then(function (res) {
      _this.checkIns = res.data.data.reverse();
      _this.totalCheckin = res.data.totalCount;
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (pos) {
        var data = new FormData();
        data.append("id", _this.$store.state.app.match.related_campaign);
        data.append("email", _this.$store.state.user.email);
        data.append("token", _this.$store.state.user.token);
        data.append("latitude", pos.coords.latitude);
        data.append("longitude", pos.coords.longitude);

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("kampanya/lokasyon-kontrolu", data).then(function (res) {
          _this.checkInType = res.data.type;
        });
      }, function (error) {
        _this.checkInType = "support";
      });
    }
    var data = new FormData();
    if (this.$store.state.app.match) {
      data.append("id", this.$store.state.app.match.related_campaign);
    }

    if (this.$store.state.user != null) {
      data.append("email", this.$store.state.user.email);
      data.append("token", this.$store.state.user.token);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("kampanya/checkin-olmus-mu", data).then(function (res) {
        _this.checked_in = res.data.checked_in;
        _this.checkedInType = res.data.type;
      });
    }
  },

  methods: {
    checkIn: function checkIn() {
      var _this2 = this;

      if (this.$store.state.user == null) {
        this.$router.push({ name: "Login" });
      } else {
        this.$store.state.loading = true;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (pos) {
            var data = new FormData();
            data.append("id", _this2.$store.state.app.match.related_campaign);
            data.append("email", _this2.$store.state.user.email);
            data.append("token", _this2.$store.state.user.token);
            data.append("latitude", pos.coords.latitude);
            data.append("longitude", pos.coords.longitude);

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("kampanya/katil", data).then(function (res) {
              _this2.$store.state.loading = false;
              if (res.data.data.status == true) {
                _this2.checked_in = true;

                _this2.$router.push({
                  name: "Success",
                  params: { data: res.data.data }
                });
              } else {
                _this2.$notify({
                  title: "Hata",
                  message: res.data.data.error,
                  type: "error"
                });
              }
            });
          }, function (error) {
            _this2.$store.state.loading = false;
            switch (error.code) {
              case error.PERMISSION_DENIED:
                _this2.$notify({
                  title: "Hata",
                  message: "Konum izni vermediğiniz için check-in yapamazsınız. Lütfen ayarlardan izin erip tekrar deneyin.",
                  type: "error"
                });
                break;
              case error.POSITION_UNAVAILABLE:
                _this2.$notify({
                  title: "Hata",
                  message: "Konum alınamadı. Telefonunuzun internet ve gps bağlantısının olduğundan emin olun.",
                  type: "error"
                });
                break;
              case error.TIMEOUT:
                _this2.$notify({
                  title: "Hata",
                  message: "Konumunuzu almamız çok uzun sürdü. Lütfen tekrar deneyin",
                  type: "error"
                });
                break;
              case error.UNKNOWN_ERROR:
                _this2.$notify({
                  title: "Hata",
                  message: "Bilinmeyen bir hata oluştur. Lütfen tekrar deneyin.",
                  type: "error"
                });
                break;
            }
          });
        }
      }
    },
    addNew: function addNew() {
      this.checkIns.push({
        first_name: "A",
        last_name: "B",
        avatarUrl: "default",
        id: new Date().getTime()
      });
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "News",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("haber?sayfa=" + 1).then(function (res) {
      _this.$store.state.news = _this.$store.state.news.concat(res.data.data);
    });
  },
  data: function data() {
    return {
      filter: {
        page: 1
      },
      items: [],
      more: true,
      loading: true
    };
  },

  methods: {
    getData: function getData($state) {
      var _this2 = this;

      this.loading = true;
      this.filter.page += 1;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("haber?sayfa=" + this.filter.page).then(function (res) {
        if (res.data.data.length == 0) {
          $state.complete();
        } else {
          $state.loaded();
          _this2.$store.state.news = _this2.$store.state.news.concat(res.data.data);
        }
      });
    },
    getNews: function getNews(slug) {
      var _this3 = this;

      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/haber/detay?slug=" + slug).then(function (res) {
        _this3.$store.state.loading = false;
        _this3.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug: slug }
        });
      });
    }
  }
});

/***/ }),
/* 257 */,
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Comment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PlayerStatistics__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_masonry_gallery__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_masonry_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_masonry_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NewsDetail",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_3__components_Comment__["a" /* default */],
    PlayerStatistics: __WEBPACK_IMPORTED_MODULE_4__components_PlayerStatistics__["a" /* default */],
    VueMasonryGallery: __WEBPACK_IMPORTED_MODULE_6_vue_masonry_gallery___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      tab: "general",
      statisticsType: "home",
      data: this.$route.params.data,
      comments: [],
      comment: null,
      activeStat: "home",
      modalIsVisible: false,
      modalContent: "",
      modalSlug: "",
      imgs: [],
      group: 0
    };
  },

  methods: {
    changeTab: function changeTab(tabName) {
      this.tab = tabName;
    },
    changeStatistics: function changeStatistics(team) {
      this.statisticsType = team;
    },
    getComments: function getComments() {
      var _this = this;

      var data = new FormData();
      data.append("id", this.$route.params.slug);
      //data.append("user_token", this.$store.state.user.token);
      data.append("type", "news");

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("yorum", data).then(function (res) {
        _this.comments = res.data.data.comments;
      }).catch(function (err) {});
    },
    sendComment: function sendComment() {
      var _this2 = this;

      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "news");
      data.append("id", this.$route.params.slug);

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post("yorum/ekle", data).then(function (res) {
        if (res.data.status != true) {
          _this2.$notify({
            title: "Hata",
            message: res.data.data,
            type: "error"
          });
        } else {
          _this2.comment = null;
          _this2.getComments();
          _this2.$notify({
            title: "Başarılı",
            message: "Başarıyla yorum yapıldı.",
            type: "success"
          });
        }

        _this2.getComments();
      }).catch(function (err) {
        console.log(err);
      });
    },
    onShare: function onShare() {
      this.$openShare("https://www.anadoluefessk.org/foto-galeri/" + this.data.content.find(function (k) {
        return k.type == "gallery";
      }).slug, this.data.title);
    },
    clickFn: function clickFn(event, _ref) {
      var index = _ref.index,
          value = _ref.value;

      event.preventDefault();
      // if srcBig is set use it as href, if not then use href
      var href = this.images[index].href;
      this.modalIsVisible = true;
      this.modalContent = this.images[index].href;
      /**
      if (event.target.tagName.toLowerCase() == "img") {
        console.log("img clicked", index, value);
      }
       */
    },
    closeModal: function closeModal() {
      this.modalIsVisible = false;
    },
    getData: function getData() {
      console.log('scroll disabled.');
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.data == undefined) {
      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get("/haber/detay?slug=" + this.$route.params.slug).then(function (res) {

        _this3.data = res.data.data;
        _this3.getComments();
        _this3.$store.state.loading = false;

        if (res.data.data.content.some(function (k) {
          return k.type == "matchstat";
        })) {
          if (res.data.data.content.find(function (k) {
            return k.type == "matchstat";
          }).content.away.name.toLowerCase() == "anadolu efes") {
            _this3.statisticsType = "away";
          }
        }
      });
    } else {
      if (this.data.content.some(function (k) {
        return k.type == "matchstat";
      })) {
        if (this.data.content.find(function (k) {
          return k.type == "matchstat";
        }).content.away.name.toLowerCase() == "anadolu efes") {
          this.statisticsType = "away";
        }
      }
    }
  },

  computed: {
    images: function images() {
      var imgs = [];

      if (this.data.content.find(function (k) {
        return k.type == "gallery";
      })) {
        this.data.content.find(function (k) {
          return k.type == "gallery";
        }).content.map(function (item) {
          imgs.push({
            href: item.image[1].thumb_960,
            src: item.image[2].thumb_256,
            slug: item.slug
          });
        });
      }

      return imgs;
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: ["closeModal", "content", "slug"],
  methods: {}
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Gallery__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GalleryDetail",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    Gallery: __WEBPACK_IMPORTED_MODULE_3__components_Gallery__["a" /* default */]
  },
  data: function data() {
    return {
      data: {
        slug: this.$route.params.slug
      }
    };
  },

  methods: {
    onShare: function onShare() {
      this.$openShare("https://www.anadoluefessk.org/foto-galeri/" + this.data.slug, this.data.title);
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("foto-galeri/detay?slug=" + this.$route.params.slug).then(function (res) {
      _this.data = res.data.data;
    });
  },

  computed: {
    images: function images() {
      var imgs = [];

      this.data.content.map(function (item) {
        imgs.push({
          image: item.image.original,
          image_thumb: item.image.image_480
        });
      });

      return imgs;
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SinanErdem",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "News",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("video?sayfa=" + 1).then(function (res) {
      _this.$store.state.videos = _this.$store.state.videos.concat(res.data.data);
    });
  },
  data: function data() {
    return {
      filter: {
        page: 1
      },
      items: [],
      more: true,
      loading: true
    };
  },

  methods: {
    getData: function getData($state) {
      var _this2 = this;

      this.loading = true;
      this.filter.page += 1;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("video?sayfa=" + this.filter.page).then(function (res) {
        if (res.data.data.length == 0) {
          $state.complete();
        } else {
          $state.loaded();
          _this2.$store.state.videos = _this2.$store.state.videos.concat(res.data.data);
        }
      });
    },
    getVideo: function getVideo(slug) {
      var _this3 = this;

      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/video/detay?slug=" + slug).then(function (res) {
        _this3.$store.state.loading = false;
        _this3.$router.push({
          name: "BasketDetail",
          params: { data: res.data.data, slug: slug }
        });
      });
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Comment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BasketDetail",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_3__components_Comment__["a" /* default */]
  },
  data: function data() {
    return {
      data: this.$route.params.data,
      comments: [],
      comment: null
    };
  },
  created: function created() {
    var _this = this;

    this.getComments();
    if (this.$route.params.data == undefined) {
      this.$store.state.loading = true;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("video/detay?slug=" + this.$route.params.slug).then(function (res) {
        _this.$store.state.loading = false;
        _this.data = res.data.data;
      });
    }
  },

  methods: {
    getComments: function getComments() {
      var _this2 = this;

      var data = new FormData();
      data.append("id", this.$route.params.slug);
      data.append("user_token", this.$store.state.user.token);
      data.append("type", "video");

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("yorum", data).then(function (res) {
        _this2.comments = res.data.data.comments;
      }).catch(function (err) {});
    },
    sendComment: function sendComment() {
      var _this3 = this;

      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "video");
      data.append("id", this.$route.params.slug);

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("yorum/ekle", data).then(function (res) {
        if (res.data.status != true) {
          _this3.$notify({
            title: "Hata",
            message: res.data.data,
            type: "error"
          });
        } else {
          _this3.comment = null;
          _this3.getComments();
          _this3.$notify({
            title: "Başarılı",
            message: res.data.data,
            type: "success"
          });
        }

        _this3.getComments();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  computed: {
    getVideoId: function getVideoId() {
      if (this.data == undefined) {
        return null;
      } else {
        var x = JSON.parse(this.data.content);
        return x.ID;
      }
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FanClub",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("kampanya/liste").then(function (res) {
      _this.$store.state.campaigns = res.data.data;
    });
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DownloadApp__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FanClubDetail",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    DownloadApp: __WEBPACK_IMPORTED_MODULE_3__components_DownloadApp__["a" /* default */]
  },
  data: function data() {
    return {
      locationInfo: false,
      confirmation: false,
      data: this.$route.params.data
    };
  },

  methods: {
    confirmationToggle: function confirmationToggle() {
      this.confirmation = !this.confirmation;
    },
    toggleLocationInfo: function toggleLocationInfo() {
      this.locationInfo = !this.locationInfo;
    },
    confirmCampaign: function confirmCampaign() {
      this.$router.push({ name: "FanClubSuccess" });
    }
  },
  created: function created() {
    var _this = this;

    if (this.data == undefined) {
      this.$store.state.loading = true;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("kampanya/liste").then(function (res) {
        _this.data = res.data.data.find(function (k) {
          return k.id == _this.$route.params.slug;
        });
        _this.$store.state.loading = false;
      });
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DownloadApp"
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FanClubSuccess",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MatchVS__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Ticket",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    MatchVS: __WEBPACK_IMPORTED_MODULE_3__components_MatchVS__["a" /* default */]
  },
  data: function data() {
    return {
      tickets: [],
      packages: [],
      combines: [],
      activeTab: 0,
      index: 0
    };
  },

  methods: {
    pageChange: function pageChange(index) {
      this.index = index;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$store.state.loading = true;

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("biletler").then(function (res) {
      _this.tickets = res.data.data.matches;
      _this.packages = res.data.data.package;
      _this.combines = res.data.data.combine;

      _this.$store.state.loading = false;
    });
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PointActions__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MyActions__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserActions__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Account",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    PointActions: __WEBPACK_IMPORTED_MODULE_3__components_PointActions__["a" /* default */],
    MyActions: __WEBPACK_IMPORTED_MODULE_4__components_MyActions__["a" /* default */],
    UserActions: __WEBPACK_IMPORTED_MODULE_5__components_UserActions__["a" /* default */]
  },
  data: function data() {
    return {
      tab: "account",
      tab2: "accountActivities",
      followers: [],
      followings: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get("uyelik/hesap?token=" + this.$store.state.user.token).then(function (res) {
      _this.$store.state.user = res.data.data;
    });

    var data = new FormData();
    data.append("user_token", this.$store.state.user.token);

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("sosyal/takip-edenler", data).then(function (res) {
      _this.followers = res.data.data;
    });

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("sosyal/takip-ettiklerim", data).then(function (res) {
      _this.followings = res.data.data;
    });
  },

  methods: {
    changeTab: function changeTab(tabName) {
      this.tab = tabName;
    },
    changeTab2: function changeTab2(tabName) {
      this.tab2 = tabName;
    },
    follow: function follow(item, tab) {
      var _this2 = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("following_user_id", item.id);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("sosyal/takip-et", data).then(function (res) {
        if (res.data.status != 200) {
          _this2.$message.error(res.data.data);
          return;
        }
        if (tab == "following") {
          var index = _this2.followings.findIndex(function (k) {
            return k.id == item.id;
          });
          _this2.followings[index].is_following = true;
        } else {
          var index = _this2.followers.findIndex(function (k) {
            return k.id == item.id;
          });
          _this2.followers[index].is_following = true;
        }
      });
    },
    unfollow: function unfollow(item, tab) {
      var _this3 = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("following_user_id", item.id);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("sosyal/takipten-cikar", data).then(function (res) {
        if (tab == "following") {
          var index = _this3.followings.findIndex(function (k) {
            return k.id == item.id;
          });
          _this3.followings[index].is_following = false;
        } else {
          var index = _this3.followers.findIndex(function (k) {
            return k.id == item.id;
          });
          _this3.followers[index].is_following = false;
        }
      });
    },
    toggleFollow: function toggleFollow(item, tab) {
      if (item.is_following) {
        this.unfollow(item, tab);
      } else {
        this.follow(item, tab);
      }
    },
    getProfile: function getProfile(id) {
      var _this4 = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("sosyal/profil", data).then(function (res) {
        if (res.data.status == 401) {
          _this4.$message.error(res.data.data);
          return;
        }
        _this4.$router.push({
          name: "UserProfile",
          params: { data: res.data.data, id: res.data.data.id }
        });
      });
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.user;
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PointActions",
  data: function data() {
    return {
      page: 0,
      items: [],
      limit: true
    };
  },
  beforeMount: function beforeMount() {
    this.getdata();
  },

  methods: {
    getdata: function getdata() {
      var _this = this;

      this.$store.state.loading = true;
      this.page += 1;

      var data = new FormData();
      data.append("token", this.$store.state.user.token);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("uyelik/profil-gecmisi", data).then(function (res) {
        _this.$store.state.loading = false;
        _this.items = res.data.data;
      });
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MyActions",
  data: function data() {
    return {
      page: 0,
      items: [],
      limit: true
    };
  },
  beforeMount: function beforeMount() {
    this.getdata();
    var self = this;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on("click", "#MyActions .handle_link", function () {
      var index = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr("id");
      self.handleLink(self.items[index]);
    });
  },

  methods: {
    getdata: function getdata() {
      var _this = this;

      this.$store.state.loading = true;
      this.page += 1;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("page", this.page);
      data.append("page_count", 5);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/aksiyonlarim", data).then(function (res) {
        _this.$store.state.loading = false;
        _this.items = _this.items.concat(res.data.data);
      });
    },
    handleLink: function handleLink(item) {
      var _this2 = this;

      if (item.relation_type == "user") {
        this.getProfile(item.relation_id);
      }

      if (item.relation_type == "news") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("haber/detay?slug=" + item.relation_id).then(function (res) {
          _this2.$router.push({
            name: "NewsDetail",
            params: { data: res.data.data, slug: item.relation_id }
          });
        });
      }

      if (item.relation_type == "video") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("video/detay?slug=" + item.relation_id).then(function (res) {
          _this2.$router.push({
            name: "BasketDetail",
            params: { data: res.data.data, slug: res.data.data.slug }
          });
        });
      }

      if (item.relation_type == "match") {
        this.$router.push({
          name: "HomeAfterMatch",
          params: { id: item.relation_id }
        });
      }
    },
    getProfile: function getProfile(id) {
      var _this3 = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/profil", data).then(function (res) {
        if (res.data.status == 401) {
          Alert.alert("Hata", res.data.data);
          return;
        }
        _this3.$router.push({
          name: "UserProfile",
          params: {
            data: res.data.data,
            id: res.data.data.id,
            slug: res.data.data.slug
          }
        });
      });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MyActions",
  data: function data() {
    return {
      page: 0,
      items: [],
      limit: true
    };
  },
  beforeMount: function beforeMount() {
    this.getdata();

    var self = this;

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on("click", "#UserActions .handle_link", function () {
      var index = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr("id");

      self.handleLink(self.items[index]);
    });
  },

  methods: {
    getdata: function getdata() {
      var _this = this;

      this.$store.state.loading = true;
      this.page += 1;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("page", this.page);
      data.append("page_count", 5);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/komsularin-aksiyonlari", data).then(function (res) {
        _this.$store.state.loading = false;
        _this.items = _this.items.concat(res.data.data);
      });
    },
    handleLink: function handleLink(item) {
      var _this2 = this;

      if (item.relation_type == "user") {
        this.getProfile(item.relation_id);
      }

      if (item.relation_type == "news") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("haber/detay?slug=" + item.relation_id).then(function (res) {
          _this2.$router.push({
            name: "NewsDetail",
            params: { data: res.data.data, slug: item.relation_id }
          });
        });
      }

      if (item.relation_type == "video") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("video/detay?slug=" + item.relation_id).then(function (res) {
          _this2.$router.push({
            name: "BasketDetail",
            params: { data: res.data.data, slug: res.data.data.slug }
          });
        });
      }

      if (item.relation_type == "match") {
        this.$router.push({
          name: "HomeAfterMatch",
          params: { id: item.relation_id }
        });
      }
    },
    getProfile: function getProfile(id) {
      var _this3 = this;

      var data = new FormData();
      data.append("user_token", this.$store.state.user.token);
      data.append("user_id", id);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/profil", data).then(function (res) {
        if (res.data.status == 401) {
          Alert.alert("Hata", res.data.data);
          return;
        }
        _this3.$router.push({
          name: "UserProfile",
          params: {
            data: res.data.data,
            id: res.data.data.id,
            slug: res.data.data.slug
          }
        });
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserActionsProfile__ = __webpack_require__(432);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Profile",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_2__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_3__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */],
    UserActionsProfile: __WEBPACK_IMPORTED_MODULE_5__components_UserActionsProfile__["a" /* default */]
  },
  data: function data() {
    return {
      id: this.$route.params.id,
      data: this.$route.params.data
    };
  },

  methods: {
    toggleFollow: function toggleFollow() {
      var _this = this;

      if (this.data.is_following) {
        var data = new FormData();
        data.append("user_token", this.$store.state.user.token);
        data.append("following_user_id", this.id);
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("sosyal/takipten-cikar", data).then(function (res) {
          if (res.data.status == 200) {
            _this.data.is_following = false;
          } else {
            _this.$message.error(res.data.data);
          }
        });
      } else {
        var data = new FormData();
        data.append("user_token", this.$store.state.user.token);
        data.append("following_user_id", this.id);
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("sosyal/takip-et", data).then(function (res) {
          if (res.data.status == 200) {
            _this.data.is_following = true;
          } else {
            _this.$message.error(res.data.data);
          }
        });
      }
    },
    goLogin: function goLogin() {
      localStorage.setItem("redir", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        params: { id: this.$route.params.id, slug: this.$route.params.slug },
        name: "Profile"
      }));
      this.$router.push({ name: "Login" });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (this.data == undefined) {
      this.$store.state.loading = true;

      var data = new FormData();
      data.append("user_token", this.$store.getters.isLogged ? this.$store.state.user.token : "");
      data.append("user_id", this.id);
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("sosyal/profil", data).then(function (res) {
        _this2.$store.state.loading = false;
        if (res.data.status == 401) {
          _this2.$message.error(res.data.data);
          _this2.$router.go(-1);
          return;
        }
        _this2.data = res.data.data;
      });
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UserActionsProfile",
  props: ["id"],
  data: function data() {
    return {
      page: 0,
      items: [],
      limit: true
    };
  },
  beforeMount: function beforeMount() {
    this.getdata();
    var self = this;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on("click", "#MyActions2 .handle_link", function () {
      var index = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).attr("id");
      self.handleLink(self.items[index]);
    });
  },

  methods: {
    getdata: function getdata() {
      var _this = this;

      this.$store.state.loading = true;
      this.page += 1;

      var data = new FormData();
      data.append("user_token", this.$store.getters.isLogged ? this.$store.state.user.token : "");
      data.append("page", this.page);
      data.append("page_count", 5);
      data.append("user_id", this.id);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/kullanici-aksiyonlari", data).then(function (res) {
        _this.$store.state.loading = false;
        _this.items = _this.items.concat(res.data.data);
      }).catch(function () {
        _this.$store.state.loading = false;
      });
    },
    handleLink: function handleLink(item) {
      var _this2 = this;

      if (item.relation_type == "user") {
        this.getProfile(item.relation_id);
      }

      if (item.relation_type == "news") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("haber/detay?slug=" + item.relation_id).then(function (res) {
          _this2.$router.push({
            name: "NewsDetail",
            params: { data: res.data.data, slug: item.relation_id }
          });
        });
      }

      if (item.relation_type == "video") {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("video/detay?slug=" + item.relation_id).then(function (res) {
          _this2.$router.push({
            name: "BasketDetail",
            params: { data: res.data.data, slug: res.data.data.slug }
          });
        });
      }

      if (item.relation_type == "match") {
        this.$router.push({
          name: "HomeAfterMatch",
          params: { id: item.relation_id }
        });
      }
    },
    getProfile: function getProfile(id) {
      var _this3 = this;

      var data = new FormData();
      data.append("user_token", this.$store.getters.isLogged ? this.$store.state.user.token : "");
      data.append("user_id", id);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("sosyal/profil", data).then(function (res) {
        if (res.data.status == 401) {
          Alert.alert("Hata", res.data.data);
          return;
        }
        _this3.$router.push({
          name: "UserProfile",
          params: {
            data: res.data.data,
            id: res.data.data.id,
            slug: res.data.data.slug
          }
        });
      });
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AccountSettings",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_4__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      email: null,
      password: null,
      error: null,
      activation_required: false
    };
  },

  methods: {
    sendCode: function sendCode() {
      var _this = this;

      var data = new FormData();
      data.append("email", this.email);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("uyelik/aktivasyon-gonder", data).then(function (res) {
        if (res.data.status == 200) {
          _this.$message.success(res.data.message);
        } else {
          _this.$message.error(res.data.message);
        }
      });
    },
    login: function login() {
      var _this2 = this;

      this.error = null;

      var data = new FormData();
      data.append("email", this.email);
      data.append("password", this.password);

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("uyelik/giris", data).then(function (res) {
        if (res.data.StatusCode == 200) {
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("uyelik/hesap?token=" + res.data.Data.token).then(function (res2) {
            _this2.$store.state.user = res2.data.data;

            _this2.$store.commit("setUser", res2.data.data);

            localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res2.data.data));

            var redir = localStorage.getItem("redir");

            if (redir === null) {
              _this2.$router.push({ name: "Home" });
            } else {
              var redir = JSON.parse(redir);
              localStorage.removeItem("redir");
              _this2.$router.push({
                name: redir.name,
                params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, redir.params)
              });
            }
          });
        } else {
          _this2.error = res.data.Data[0];
          _this2.activation_required = res.data.activation_required;
        }
      }).catch(function (err) {});
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ForgotPassword",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      email: null
    };
  },

  methods: {
    send: function send() {
      var _this = this;

      var data = new FormData();
      data.append("email", this.email);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("uyelik/sifremi-unuttum", data).then(function (res) {
        if (res.data.error) {
          _this.$notify({
            title: "Hata",
            message: res.data.error,
            type: "error"
          });
        } else {
          _this.$notify({
            title: "Hata",
            message: res.data.message,
            type: "success"
          });
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    if (this.$route.query.email != null) {
      this.$router.replace({
        name: "ChangePassword",
        params: this.$route.query,
        query: this.$route.query
      });
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Help",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      data: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("statik/sss").then(function (res) {
      var x = res.data.pwa == undefined ? res.data.android : res.data.pwa;

      x.map(function (item, index) {
        x[index].open = index == 0 ? true : false;
      });

      _this.data = x;
    });
  },

  methods: {
    toggle: function toggle(index) {
      this.data[index].open = !this.data[index].open;
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Register",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_4__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */]
  },
  directives: { mask: __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__["mask"] },
  data: function data() {
    return {
      form: {
        register_name: null,
        register_surname: null,
        register_mail: null,
        register_pass: null,
        register_pass_retry: null,
        select_gender: null,
        register_birthday: null,
        register_phone: null,
        register_tckn: null,
        allowEmail: false,
        allowSms: false,
        cityId: null,
        district: null,
        career: null,
        term: false,
        permission: false
      },
      genders: [{
        title: "Erkek",
        value: 1
      }, {
        title: "Kadın",
        value: 2
      }, {
        title: "Belirtmek İstemiyorum",
        value: 0
      }],
      cities: [],
      districts: [],
      termModal: false,
      professionList: [],
      term: null
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get("statik/il-listesi?country_id=190").then(function (res) {
      _this.cities = res.data;
    });

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("statik/meslek-listesi").then(function (res) {
      _this.professionList = res.data;
    });

    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("statik/kullanim-sartlari").then(function (res) {
      _this.term = res.data.data;
    });
  },

  methods: {
    getDistrict: function getDistrict() {
      var _this2 = this;

      var data = new FormData();
      data.append("cityId", this.form.cityId);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("statik/ilce-listesi", data).then(function (res) {
        _this2.districts = res.data;
      });
    },
    register: function register() {
      var _this3 = this;

      var data = new FormData();

      data.append("mystr", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.form, {
        register_birthday: this.form.register_birthday,

        register_tckn: this.form.register_tckn.replace(" ", "").replace(" ", "").replace(" ", "").replace(" ", "").replace(" ", ""),
        register_phone: this.form.register_phone.replace("(", "").replace(")", "").replace(" ", "").replace(" ", "").replace(" ", "").replace(" ", "").replace(" ", "")
      })));

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post("uyelik/kayit", data).then(function (res) {
        if (res.data.StatusCode == 200) {
          _this3.$notify({
            title: "Kayıt Başarılı",
            message: "Üyeliğiniz başarıyla oluşturulmuştur. Lütfen e-posta adresine gönderilen yönergeleri izleyerek üyeliğinizi aktif edin. Aktif ettikten sonra giriş yapabilirsiniz.",
            type: "success"
          });

          _this3.$router.push({ name: "Activate" });
        } else {
          _this3.$notify({
            title: "Hata",
            message: res.data.Message,
            type: "error"
          });
        }
      }).catch(function (err) {});
    }
  },
  watch: {
    "form.cityId": function formCityId() {
      this.getDistrict();
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MatchVSFixture__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Fixture",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    MatchVSFixture: __WEBPACK_IMPORTED_MODULE_3__components_MatchVSFixture__["a" /* default */]
  },
  data: function data() {
    return {
      tab: "future"
    };
  },

  methods: {
    changeTab: function changeTab(tabName) {
      this.tab = tabName;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("mac-listesi/fikstur").then(function (res) {
      _this.$store.state.matches = res.data.data;
    });
  },

  computed: {
    data: function data() {
      return this.tab == "future" ? this.$store.state.matches.filter(function (k) {
        return k.isFinished == false;
      }) : this.$store.state.matches.filter(function (k) {
        return k.isFinished == true;
      }).reverse();
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MatchVS",
  props: ["data", "hideAll"]
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CheckInSuccess",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__glidejs_glide__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Team",
  components: {
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */]
  },
  data: function data() {
    return {
      data: null,
      activeItem: 0,
      moment: __WEBPACK_IMPORTED_MODULE_5_moment___default.a
    };
  },

  methods: {
    goProfile: function goProfile(id) {
      var _this = this;

      this.$store.state.loading = true;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("takim/oyuncu?player=" + id).then(function (res) {
        _this.$store.state.loading = false;

        _this.$router.push({
          name: "Player",
          params: { slug: res.data.data.slug, data: res.data.data }
        });
      });
    },
    pageChanged: function pageChanged(index) {
      this.activeItem = index;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("takim").then(function (res) {
      _this2.data = res.data.data;
      setTimeout(function () {
        _this2.topCarousel = new __WEBPACK_IMPORTED_MODULE_4__glidejs_glide__["a" /* default */]("#topcarousel", {
          peek: { before: 0, after: 70 }
        }).mount();

        _this2.bottomCarousel = new __WEBPACK_IMPORTED_MODULE_4__glidejs_glide__["a" /* default */]("#bottomcarousel", {
          peek: { before: 0, after: 70 }
        }).mount();

        _this2.topCarousel.on(["move.after", "run"], function () {
          _this2.activeItem = _this2.topCarousel.index;
        });
      });
    });
  },

  watch: {
    activeItem: function activeItem() {
      var _this3 = this;

      if (this.activeItem == 0) {
        setTimeout(function () {
          _this3.bottomCarousel = new __WEBPACK_IMPORTED_MODULE_4__glidejs_glide__["a" /* default */]("#bottomcarousel", {
            peek: { before: 0, after: 70 }
          }).mount();
        }, 200);
      }
    }
  }
});

/***/ }),
/* 284 */,
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Player",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      tab: "career",
      slug: this.$route.params.slug,
      data: this.$route.params.data,
      moment: __WEBPACK_IMPORTED_MODULE_4_moment___default.a,
      index: 0
    };
  },

  methods: {
    changeTab: function changeTab(tabName) {
      this.tab = tabName;
    },
    pageChanged: function pageChanged(index) {
      this.index = index;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (this.data == undefined) {
      this.$store.state.loading = true;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("takim/oyuncu?player=" + this.slug).then(function (res) {
        _this.$store.state.loading = false;

        _this.data = res.data.data;
      });
    }
  },

  computed: {
    getStats: function getStats() {
      return [this.data.stats.all, this.data.stats.euroleague, this.data.stats.tbl, this.data.stats.turkishcup];
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__glidejs_glide__ = __webpack_require__(284);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Statistics",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      data: [],
      activeItem: 0,
      topCarousel: null,
      bottomCarousel: null,
      tab: 0
    };
  },

  methods: {},
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("istatistik/index").then(function (res) {
      _this.data = [res.data.all, res.data.tael, res.data.bsl, res.data.sttk];

      setTimeout(function () {
        _this.topCarousel = new __WEBPACK_IMPORTED_MODULE_4__glidejs_glide__["a" /* default */]("#topcarousel", {
          peek: { before: 0, after: 70 }
        }).mount();

        _this.topCarousel.on(["move.after"], function () {
          _this.activeItem = _this.topCarousel.index;
        });
      }, 1000);
    });
  },

  computed: {
    item: function item() {
      return this.data[this.activeItem];
    },
    getScores: function getScores() {
      return [{
        title: "1.P",
        home: this.item.stats.scoreAverages.Q1.team,
        away: this.item.stats.scoreAverages.Q1.rivals
      }, {
        title: "2.P",
        home: this.item.stats.scoreAverages.Q2.team,
        away: this.item.stats.scoreAverages.Q2.rivals
      }, {
        title: "3.P",
        home: this.item.stats.scoreAverages.Q3.team,
        away: this.item.stats.scoreAverages.Q3.rivals
      }, {
        title: "4.P",
        home: this.item.stats.scoreAverages.Q4.team,
        away: this.item.stats.scoreAverages.Q4.rivals
      }];
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Success"
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Activate",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      message: null,
      status: 0,
      email: this.$route.query.email,
      token: this.$route.query.code
    };
  },

  methods: {
    activate: function activate() {
      var _this = this;

      this.message = "Üyeliğiniz Aktive Ediliyor...";
      var data = new FormData();
      data.append("email", this.email);
      data.append("confirmation_code", this.token);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("uyelik/aktive-et", data).then(function (res) {
        _this.message = res.data.message;
        _this.status = res.data.status;
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (this.email == undefined || this.token == undefined) {} else {
      this.message = "Üyeliğiniz Aktive Ediliyor...";
      var data = new FormData();
      data.append("email", this.email);
      data.append("confirmation_code", this.token);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("uyelik/aktive-et", data).then(function (res) {
        _this2.message = res.data.message;
        _this2.status = res.data.status;
      });
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Activate",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_2__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_3__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      cities: [],
      subjects: [],
      form: {
        email: this.$store.state.user != null ? this.$store.state.user.email : "",
        subject: "",
        firstname: this.$store.state.user != null ? this.$store.state.user.first_name : "",
        lastname: this.$store.state.user != null ? this.$store.state.user.last_name : "",
        message: "",
        phone: this.$store.state.user != null ? this.$store.state.user.phone_gsm : "",
        city: this.$store.state.user != null ? this.$store.state.user.city : ""
      },
      errors: []
    };
  },

  methods: {
    send: function send() {
      var _this = this;

      this.errors = [];
      var data = new FormData();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).map(function (item, index) {
        data.append(item, _this.form[item]);
      });

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("iletisim", data).then(function (res) {
        if (res.data.type == "error") {
          alert(res.data.message);
          _this.errors = res.data.message;
        } else {
          alert(res.data.message);
          _this.$router.back();
        }
      }).catch(function (err) {
        alert("Sunucu Hatasi");
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("statik/il-listesi").then(function (res) {
      _this2.cities = res.data;
    });

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("statik/iletisim-konu").then(function (res) {
      _this2.subjects = res.data;
    });
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Activate",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  data: function data() {
    return {
      message: null,
      status: 0,
      email: this.$route.query.email,
      token: this.$route.query.code,
      password: null
    };
  },

  methods: {
    activate: function activate() {
      var _this = this;

      this.message = "Şifreniz Yenileniyor...";
      var data = new FormData();
      data.append("email", this.email);
      data.append("code", this.token);
      data.append("password", this.password);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("uyelik/parola-guncelle", data).then(function (res) {
        _this.message = res.data.error || res.data.message;
        _this.status = res.data.status;
      }).catch(function (err) {
        _this.message = "Şifre yenileme kodunuz hatalı veya süresi dolmuş.";
        _this.status = false;
      });
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Caylak",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SosyalSorumlulukProjeleri",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Menu__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GuvenlikKamerasiAydinlatmaMetni",
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_2__components_Menu__["a" /* default */],
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_handlers__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_helpers__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_methods__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_preparations__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_settings__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_throttle__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_watchers__ = __webpack_require__(498);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Agile',

	mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_handlers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_methods__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_preparations__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_settings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_throttle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_watchers__["a" /* default */]],

	data: function data() {
		return {
			autoplayInterval: null,
			autoplayRemaining: null,
			autoplayStartTimestamp: null,
			autoplayTimeout: null,
			currentSlide: null,
			dragDistance: 0,
			dragStartX: 0,
			dragStartY: 0,
			isAutoplayPaused: false,
			isMouseDown: false,
			slides: [],
			slidesClonedAfter: [],
			slidesClonedBefore: [],
			isSSR: typeof window === 'undefined',
			transitionDelay: 0,
			translateX: 0,
			widthWindow: 0,
			widthContainer: 0
		};
	},


	computed: {
		breakpoints: function breakpoints() {
			return !this.initialSettings.responsive ? [] : this.initialSettings.responsive.map(function (item) {
				return item.breakpoint;
			});
		},

		canGoToPrev: function canGoToPrev() {
			return this.settings.infinite || this.currentSlide > 0;
		},

		canGoToNext: function canGoToNext() {
			return this.settings.infinite || this.currentSlide < this.countSlides - 1;
		},

		countSlides: function countSlides() {
			return this.isSSR ? this.htmlCollectionToArray(this.$slots.default).length : this.slides.length;
		},

		countSlidesAll: function countSlidesAll() {
			return this.slidesAll.length;
		},

		currentBreakpoint: function currentBreakpoint() {
			var _this = this;

			var breakpoints = this.breakpoints.map(function (item) {
				return item;
			}).reverse();
			return this.initialSettings.mobileFirst ? breakpoints.find(function (item) {
				return item < _this.widthWindow;
			}) || 0 : breakpoints.find(function (item) {
				return item > _this.widthWindow;
			}) || null;
		},

		marginX: function marginX() {
			if (this.settings.unagile) {
				return 0;
			}

			var marginX = this.slidesCloned ? this.countSlides * this.widthSlide : 0;

			// Center mode margin
			if (this.settings.centerMode) {
				marginX -= (Math.floor(this.settings.slidesToShow / 2) - +(this.settings.slidesToShow % 2 === 0)) * this.widthSlide;
			}

			return this.settings.rtl ? marginX : -1 * marginX;
		},

		slidesCloned: function slidesCloned() {
			return !this.settings.unagile && !this.settings.fade && this.settings.infinite;
		},

		slidesAll: function slidesAll() {
			return this.slidesCloned ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.slidesClonedBefore), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.slides), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.slidesClonedAfter)) : this.slides;
		},

		widthSlide: function widthSlide() {
			return !this.settings.unagile ? this.widthContainer / this.settings.slidesToShow : 'auto';
		}
	},

	mounted: function mounted() {
		// Windows resize listener
		window.addEventListener('resize', this.getWidth);

		// Mouse and touch events
		this.$refs.track.addEventListener('touchstart', this.handleMouseDown);
		this.$refs.track.addEventListener('touchend', this.handleMouseUp);
		this.$refs.track.addEventListener('touchmove', this.handleMouseMove);
		this.$refs.track.addEventListener('mousedown', this.handleMouseDown);
		this.$refs.track.addEventListener('mouseup', this.handleMouseUp);
		this.$refs.track.addEventListener('mousemove', this.handleMouseMove);

		// Init
		this.isSSR = false;
		this.reload();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.getWidth);

		this.$refs.track.removeEventListener('touchstart', this.handleMouseDown);
		this.$refs.track.removeEventListener('touchend', this.handleMouseUp);
		this.$refs.track.removeEventListener('touchmove', this.handleMouseMove);
		this.$refs.track.removeEventListener('mousedown', this.handleMouseDown);
		this.$refs.track.removeEventListener('mouseup', this.handleMouseUp);
		this.$refs.track.removeEventListener('mousemove', this.handleMouseMove);

		this.disableAutoPlay();
	},


	methods: {
		// Return current breakpoint
		getCurrentBreakpoint: function getCurrentBreakpoint() {
			return this.currentBreakpoint;
		},


		// Return settings for current breakpoint
		getCurrentSettings: function getCurrentSettings() {
			return this.settings;
		},


		// Return current slide index
		getCurrentSlide: function getCurrentSlide() {
			return this.currentSlide;
		},


		// Return initial settings
		getInitialSettings: function getInitialSettings() {
			return this.initialSettings;
		},


		// Go to slide
		goTo: function goTo(n) {
			var _this2 = this;

			var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var asNav = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

			// Break goTo() if unagile is active
			if (this.settings.unagile) {
				return false;
			}

			if (!asNav) {
				this.settings.asNavFor.forEach(function (carousel) {
					if (carousel) {
						carousel.goTo(n, transition, true);
					}
				});
			}

			var slideNextReal = n;

			if (transition) {
				if (this.settings.infinite && n < 0) {
					slideNextReal = this.countSlides - 1;
				} else if (n >= this.countSlides) {
					slideNextReal = 0;
				}

				this.$emit('before-change', { currentSlide: this.currentSlide, nextSlide: slideNextReal });

				this.currentSlide = slideNextReal;

				if (n !== slideNextReal) {
					setTimeout(function () {
						_this2.goTo(slideNextReal, false);
					}, this.settings.speed);
				}
			}

			var translateX = !this.settings.fade ? n * this.widthSlide * this.settings.slidesToScroll : 0;
			this.transitionDelay = transition ? this.speed : 0;

			if (this.infinite || this.currentSlide + this.slidesToShow <= this.countSlides) {
				this.translateX = this.settings.rtl ? translateX : -1 * translateX;
			}
		},


		// Go to next slide
		goToNext: function goToNext() {
			if (this.canGoToNext) {
				this.goTo(this.currentSlide + 1);
			}
		},


		// Go to previous slide
		goToPrev: function goToPrev() {
			if (this.canGoToPrev) {
				this.goTo(this.currentSlide - 1);
			}
		},


		// Reload carousel
		reload: function reload() {
			this.getWidth();
			this.prepareSlides();
			this.prepareCarousel();
			this.toggleFade();
			this.toggleAutoPlay();
		}
	}
});

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_less_bootstrap_css__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_less_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_less_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_agile__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CampaignCarousel__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_toast_mobile__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_toast_mobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_toast_mobile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_page_transition__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_ios_actionsheet__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_ios_actionsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_ios_actionsheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_analytics__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_analytics__);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_analytics___default.a, {
  id: "UA-6392645-20",
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_ios_actionsheet___default.a);
__WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default.a.locale("tr");

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_page_transition__["default"]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component("CampaignCarousel", __WEBPACK_IMPORTED_MODULE_12__components_CampaignCarousel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_carousel___default.a);

//axios.defaults.baseURL = "https://devapi.anadoluefessk.org/api";
__WEBPACK_IMPORTED_MODULE_10_axios___default.a.defaults.baseURL = "https://api.anadoluefessk.org/api";
__WEBPACK_IMPORTED_MODULE_10_axios___default.a.defaults.headers.post["Content-Type"] = "multipart/form-data";

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_agile__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$openShare = function (url, title) {
  window.vm.$iosActionSheet([{
    label: true,
    text: "Sosyal Medyada Paylaş"
  }, {
    text: "Facebook",
    handle: function handle() {
      window.vm.$share("facebook", url, title);
    }
  }, {
    text: "Twitter",
    handle: function handle() {
      window.vm.$share("twitter", url, title);
    }
  }, {
    text: "Vazgeç"
  }]);
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$buy = function (link) {
  window.open(link, "_blank");
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$share = function (platform, url, title) {
  var u = "";

  switch (platform) {
    case "facebook":
      u = "https://www.facebook.com/sharer.php?u=" + url + "&t=" + title;
      break;
    case "twitter":
      u = "https://twitter.com/intent/tweet?url=" + url + "&text=" + title;
      break;
    default:
      break;
  }

  window.open(u, "_blank").focus();
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$dateString = function (date) {
  return __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default()(date).format("D MMMM YYYY");
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$dateTime = function (date) {
  return __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default()(date).format("D MMMM YYYY, HH:mm");
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$matchDate = function (date) {
  __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default.a.locale('tr');
  var date2 = __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default()(date);
  if (date2.isValid()) {
    return __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default()(date2).format("D MMMM YYYY, HH:mm");
  } else {
    if (date != null) {
      return date;
    }
    return "Tarih ve saat daha sonra açıklanacaktır";
  }
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$fromNow = function (date) {
  return __WEBPACK_IMPORTED_MODULE_17_moment_min_moment_with_locales___default.a.utc(date).add(-20, "seconds").local().fromNow();
};

var store = new __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].Store({
  state: {
    menu: false,
    app: {
      match: null
    },
    user: null,
    ads: [],
    pusher: "3583da5c119ae8a29938",
    pusher_staging: "ded6ad2911f267abc111",
    modalImages: [],
    baseImageURL: "https://www.anadoluefessk.org/",
    loading: false,
    news: [],
    campaigns: [],
    matches: [],
    videos: []
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  getters: {
    isLogged: function isLogged(state) {
      return state.user != null;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
window.vm = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] },
  store: store,
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var user;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post("statik/version").then(function (res) {
                _this.$store.state.app = res.data;
                global.modalImages = [];

                global.user = null;

                for (var i = 1; i < 17; i++) {
                  _this.$store.state.modalImages.push(_this.$store.state.baseImageURL + "img/player/" + _this.$store.state.app.yearslug + "/mobile-fistbump/" + i + ".jpg");
                }
              });

              user = localStorage.getItem("user");


              __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post("reklam").then(function (res) {
                _this.$store.state.ads = res.data;
              });

              if (user === null) {
                //this.$router.push({ name: "Login" });
              } else {
                _this.$store.state.user = JSON.parse(user);

                __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get("uyelik/hesap?token=" + _this.$store.state.user.token).then(function (res) {
                  if (res.data.status != 401) {
                    _this.$store.state.user = res.data.data;

                    localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.data.data));

                    //this.$router.push({ name: "Home" });
                  } else {
                    _this.$store.state.user = null;
                    localStorage.removeItem("user");
                    //this.$router.push({ name: "Login" });
                  }
                });
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_8_jquery___default()("body").hasClass("menu-open")) {
    __WEBPACK_IMPORTED_MODULE_8_jquery___default()("body").removeClass("menu-open");
  }
  next();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2bbeebc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(337)
  __webpack_require__(339)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2bbeebc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */,
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.state.loading),expression:"$store.state.loading"}],staticStyle:{"min-height":"100vh"},attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_News__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_NewsDetail__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_GalleryDetail__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SinanErdem__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Basket__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_BasketDetail__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_FanClub__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_FanClubDetail__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_FanClubSuccess__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Ticket__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Account__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Profile__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_AccountSettings__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Login__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_ForgotPassword__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Help__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Register__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Fixture__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_CheckInSuccess__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Team__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Player__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Statistics__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_Success__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_HomeAfterMatch__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_Activate__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_Contact__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_ChangePassword__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Caylak__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_SosyalSorumlulukProjeleri__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_GuvenlikKamerasiAydinlatmaMetni__ = __webpack_require__(478);


































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: "/haberler",
    name: "News",
    component: __WEBPACK_IMPORTED_MODULE_3__pages_News__["a" /* default */]
  }, {
    path: "/haber/:slug",
    name: "NewsDetail",
    component: __WEBPACK_IMPORTED_MODULE_4__pages_NewsDetail__["a" /* default */],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 };
    }
  }, {
    path: "/fan-club",
    name: "FanClub",
    component: __WEBPACK_IMPORTED_MODULE_9__pages_FanClub__["a" /* default */]
  }, {
    path: "/takim/anadolu-efes",
    name: "Team",
    component: __WEBPACK_IMPORTED_MODULE_22__pages_Team__["a" /* default */]
  }, {
    path: "/istatistik",
    name: "Statistics",
    component: __WEBPACK_IMPORTED_MODULE_24__pages_Statistics__["a" /* default */]
  }, {
    path: "/takim/oyuncu/:slug",
    name: "Player",
    component: __WEBPACK_IMPORTED_MODULE_23__pages_Player__["a" /* default */]
  }, {
    path: "/fan-club-detay/:slug",
    name: "FanClubDetail",
    component: __WEBPACK_IMPORTED_MODULE_10__pages_FanClubDetail__["a" /* default */]
  }, {
    path: "/fan-club-tebrikler",
    name: "FanClubSuccess",
    component: __WEBPACK_IMPORTED_MODULE_11__pages_FanClubSuccess__["a" /* default */]
  }, {
    path: "/success",
    name: "Success",
    component: __WEBPACK_IMPORTED_MODULE_25__pages_Success__["a" /* default */]
  }, {
    path: "/check-in",
    name: "CheckInSuccess",
    component: __WEBPACK_IMPORTED_MODULE_21__pages_CheckInSuccess__["a" /* default */]
  }, {
    path: "/basket-tv",
    name: "Basket",
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Basket__["a" /* default */]
  }, {
    path: "/video/:slug",
    name: "BasketDetail",
    component: __WEBPACK_IMPORTED_MODULE_8__pages_BasketDetail__["a" /* default */]
  }, {
    path: "/fikstur",
    name: "Fixture",
    component: __WEBPACK_IMPORTED_MODULE_20__pages_Fixture__["a" /* default */]
  }, {
    path: "/kulup/sinan-erdem-spor-salonu",
    name: "SinanErdem",
    component: __WEBPACK_IMPORTED_MODULE_6__pages_SinanErdem__["a" /* default */]
  }, {
    path: "/kulup/caylak",
    name: "Caylak",
    component: __WEBPACK_IMPORTED_MODULE_30__pages_Caylak__["a" /* default */]
  }, {
    path: "/kulup/sosyal-sorumluluk-projeleri",
    name: "SosyalSorumlulukProjeleri",
    component: __WEBPACK_IMPORTED_MODULE_31__pages_SosyalSorumlulukProjeleri__["a" /* default */]
  }, {
    path: "/guvenlik-kamerasi-aydinlatma-metni",
    name: "GuvenlikKamerasiAydinlatmaMetni",
    component: __WEBPACK_IMPORTED_MODULE_32__pages_GuvenlikKamerasiAydinlatmaMetni__["a" /* default */]
  }, {
    path: "/yardim",
    name: "Help",
    component: __WEBPACK_IMPORTED_MODULE_18__pages_Help__["a" /* default */]
  }, {
    path: "/biletler",
    name: "Ticket",
    component: __WEBPACK_IMPORTED_MODULE_12__pages_Ticket__["a" /* default */]
  }, {
    path: "/hesabim",
    name: "Account",
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Account__["a" /* default */]
  }, {
    path: "/uyelik/guncelle",
    name: "AccountSettings",
    component: __WEBPACK_IMPORTED_MODULE_15__pages_AccountSettings__["a" /* default */]
  }, {
    path: "/uyelik/giris",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_16__pages_Login__["a" /* default */]
  }, {
    path: "/uyelik/kayit",
    name: "Register",
    component: __WEBPACK_IMPORTED_MODULE_19__pages_Register__["a" /* default */]
  }, {
    path: "/uyelik/parola-yenile",
    name: "ForgotPassword",
    component: __WEBPACK_IMPORTED_MODULE_17__pages_ForgotPassword__["a" /* default */]
  }, {
    path: "/fikstur/mac/:id",
    name: "HomeAfterMatch",
    component: __WEBPACK_IMPORTED_MODULE_26__components_HomeAfterMatch__["a" /* default */]
  }, {
    path: "/uyelik/aktivasyon",
    name: "Activate",
    component: __WEBPACK_IMPORTED_MODULE_27__pages_Activate__["a" /* default */]
  }, {
    path: "/fan-club/uye/:id/:slug",
    name: "UserProfile",
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Profile__["a" /* default */]
  }, {
    path: "/foto-galeri/:slug",
    name: "GalleryDetail",
    component: __WEBPACK_IMPORTED_MODULE_5__pages_GalleryDetail__["a" /* default */]
  }, {
    path: "/iletisim",
    name: "Contact",
    component: __WEBPACK_IMPORTED_MODULE_28__pages_Contact__["a" /* default */]
  }, {
    path: "/uyelik/parola-degistir",
    name: "ChangePassword",
    component: __WEBPACK_IMPORTED_MODULE_29__pages_ChangePassword__["a" /* default */]
  }]
}));

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33399888_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(394);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33399888_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row menurow"},[_c('div',{staticClass:"col-2"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{staticClass:"pt-4 pb-4",attrs:{"src":"/static/img/back-arrow.svg"}})])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('h1',{staticClass:"page-title text-center"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[(_vm.hideMore != false)?_c('a',{attrs:{"href":""}},[_c('img',{staticClass:"pt-4 pb-4",attrs:{"src":"/static/img/menu-dot.svg"}})]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-area align-bottom w-100"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2 text-center"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('img',{staticClass:"pt-4",attrs:{"src":"/static/img/match-icon.svg"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_c('router-link',{attrs:{"to":{ name: 'FanClub' }}},[_c('img',{staticClass:"pt-4",attrs:{"src":"/static/img/fan-icon.svg"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-4 text-center"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('img',{staticClass:"footer-logo pb-2",attrs:{"src":"/static/img/bottom-logo.svg"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_c('router-link',{attrs:{"to":{ name: _vm.$store.getters.isLogged ? 'Account' : 'Login' }}},[_c('img',{staticClass:"pt-4",attrs:{"src":"/static/img/user-icon.svg"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_c('a',{on:{"click":_vm.toggleMenu}},[_c('img',{staticClass:"pt-4",attrs:{"src":"/static/img/menu-icon.svg"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"menu-close text-right",staticStyle:{"height":"45px","display":"flex","align-items":"center","justify-content":"flex-end"},on:{"click":_vm.toggleMenu}},[_vm._m(0)]),_vm._v(" "),_c('ul',{staticStyle:{"height":"calc(100vh - 90px)","overflow":"hidden","overflow-y":"auto","border-top":"1px solid rgb(0, 28, 78)","border-bottom":"1px solid rgb(0, 28, 78)"}},[_c('li',[_c('router-link',{attrs:{"to":{name: 'Home'}}},[_vm._v("Anasayfa")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'News'}}},[_vm._v("Haberler")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Fixture'}}},[_vm._v("Maç Takvimi")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Ticket'}}},[_vm._v("Bilet ve Kombine")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'FanClub'}}},[_vm._v("Anadolu Efes Fan Club")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'SosyalSorumlulukProjeleri'}}},[_vm._v("Sosyal Sorumluluk Projeleri")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Team'}}},[_vm._v("Takım Kadrosu")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Statistics'}}},[_vm._v("Takım İstatistikleri")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Basket'}}},[_vm._v("Anadolu Efes TV")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'SinanErdem'}}},[_vm._v("Salona Nasıl Gidilir?")])],1),_vm._v(" "),(_vm.$store.getters.isLogged)?_c('li',[_c('router-link',{attrs:{"to":{name: 'Account'}}},[_vm._v("Profilim")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Help'}}},[_vm._v("Yardım")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Contact'}}},[_vm._v("İletişim")])],1)]),_vm._v(" "),(_vm.$store.getters.isLogged)?_c('div',{staticClass:"log-out fs-14 fc-1 font-weight-bold text-right mr-3",staticStyle:{"padding-top":"0","height":"45px","display":"flex","align-items":"center","justify-content":"flex-end"},on:{"click":function($event){return _vm.signOut();}}},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-right.svg"}}),_vm._v("Çıkış Yap\n  ")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isLogged == false)?_c('div',{staticClass:"log-out fs-14 fc-1 font-weight-bold text-right mr-3",staticStyle:{"padding-top":"0","height":"45px","display":"flex","align-items":"center","justify-content":"flex-end"}},[_c('div',{staticStyle:{"margin-right":"25px"},on:{"click":function($event){return _vm.$router.push({name: 'Login'})}}},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-right.svg"}}),_vm._v("Giriş Yap\n    ")]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.$router.push({name: 'Register'})}}},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-right.svg"}}),_vm._v("Kayıt Ol\n    ")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"mr-3",attrs:{"src":"/static/img/close-icon.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeDefault_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79409bf9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeDefault_vue__ = __webpack_require__(373);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeDefault_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79409bf9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeDefault_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box text-center p-3"},[_c('h1',{staticClass:"fs-14 fc-6"},[_vm._v(_vm._s(_vm.data.isFinished === true ? _vm.data.league || _vm.data.league_name : _vm.$matchDate(_vm.data.dateTime)))]),_vm._v(" "),_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.data.court || _vm.data.court_name)+" "+_vm._s(_vm.data.tv != null && _vm.data.tv != "" ? " - " + _vm.data.tv : null))]),_vm._v(" "),_c('div',{staticClass:"team-band"},[_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.data.homeTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2",staticStyle:{"line-height":"14px","height":"42px"}},[_vm._v(_vm._s(_vm.data.homeTeam.name))])])]),_vm._v(" "),_c('div',{staticClass:"skor",staticStyle:{"width":"100px"}},[_c('div',{staticClass:"detail"},[_c('p',{staticClass:"hour"},[_vm._v(_vm._s(_vm.data.homeTeam.score)+" : "+_vm._s(_vm.data.awayTeam.score))])])]),_vm._v(" "),_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.data.awayTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2",staticStyle:{"line-height":"14px","height":"42px"}},[_vm._v(_vm._s(_vm.data.awayTeam.name))])])])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters bg-2 bb-1 bt-1"},[(_vm.data.isFinished == true)?_c('div',{staticClass:"block-link text-center pt-3 pb-3",staticStyle:{"display":"flex","flex":"1","align-items":"center","justify-content":"center"},on:{"click":function($event){return _vm.$router.push({name: 'HomeAfterMatch', params: {id: _vm.data.id}})}}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.data.ticketLink != '' && _vm.data.ticketLink != null && _vm.data.isFinished == false)?_c('div',{staticClass:"block-link text-center pt-3 pb-3",staticStyle:{"display":"flex","flex":"1","align-items":"center","justify-content":"center"}},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('a',{staticClass:"fc-1",attrs:{"target":"_blank","href":_vm.data.ticket_link == undefined ? _vm.data.ticketLink : _vm.data.ticket_link}},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v(" Maça Bilet Al\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.hideAll == undefined)?_c('div',{staticClass:"block-link text-center pt-3 pb-3",staticStyle:{"display":"flex","flex":"1","align-items":"center","justify-content":"center"},on:{"click":function($event){return _vm.$router.push({name: 'Fixture'})}}},[_vm._m(1)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v("\n        Maç Detayına Git\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/two-dot.svg"}}),_vm._v(" Tüm Maçları Göster\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header bb-1"},[_c('h1',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.data[_vm.pageIndex].title)+" "+_vm._s(_vm.hideLeader == undefined ? ' Lideri' : ''))]),_vm._v(" "),_c('div',{staticClass:"slider-dots text-center float-right mt-20"},_vm._l((_vm.data),function(i,index){return _c('span',{key:index,class:index == _vm.pageIndex ? 'active' : ''})}),0)]),_vm._v(" "),_c('div',{staticClass:"box-body pb-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":false},on:{"pageChange":_vm.pageChanged}},_vm._l((_vm.data),function(item,index){return _c('slide',{key:item.slug + '_' + index},[_c('div',{staticClass:"player"},[_c('div',{staticClass:"row",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"col-3 p-0"},[_c('div',{staticClass:"player-image"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.$store.state.baseImageURL + '/img/player/' + _vm.$store.state.app.yearslug + '/' + item.jerseyNo + '/face.webp'}})])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('h1',{staticClass:"player-title fs-12 fc-6 pt-2"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"fs-32 fc-1"},[_vm._v("\n                      "+_vm._s(_vm.hideFloat == undefined ? parseFloat(item.metric).toFixed(1) : item.metric)+"\n                      "),_c('span',{staticClass:"fs-12"},[_vm._v(_vm._s(item.title)+" "+_vm._s(_vm.hideLeader == undefined ? ' Lideri' : ''))])])])])])])])])}),1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 101,
	"./af.js": 101,
	"./ar": 102,
	"./ar-dz": 103,
	"./ar-dz.js": 103,
	"./ar-kw": 104,
	"./ar-kw.js": 104,
	"./ar-ly": 105,
	"./ar-ly.js": 105,
	"./ar-ma": 106,
	"./ar-ma.js": 106,
	"./ar-sa": 107,
	"./ar-sa.js": 107,
	"./ar-tn": 108,
	"./ar-tn.js": 108,
	"./ar.js": 102,
	"./az": 109,
	"./az.js": 109,
	"./be": 110,
	"./be.js": 110,
	"./bg": 111,
	"./bg.js": 111,
	"./bm": 112,
	"./bm.js": 112,
	"./bn": 113,
	"./bn-bd": 114,
	"./bn-bd.js": 114,
	"./bn.js": 113,
	"./bo": 115,
	"./bo.js": 115,
	"./br": 116,
	"./br.js": 116,
	"./bs": 117,
	"./bs.js": 117,
	"./ca": 118,
	"./ca.js": 118,
	"./cs": 119,
	"./cs.js": 119,
	"./cv": 120,
	"./cv.js": 120,
	"./cy": 121,
	"./cy.js": 121,
	"./da": 122,
	"./da.js": 122,
	"./de": 123,
	"./de-at": 124,
	"./de-at.js": 124,
	"./de-ch": 125,
	"./de-ch.js": 125,
	"./de.js": 123,
	"./dv": 126,
	"./dv.js": 126,
	"./el": 127,
	"./el.js": 127,
	"./en-au": 128,
	"./en-au.js": 128,
	"./en-ca": 129,
	"./en-ca.js": 129,
	"./en-gb": 130,
	"./en-gb.js": 130,
	"./en-ie": 131,
	"./en-ie.js": 131,
	"./en-il": 132,
	"./en-il.js": 132,
	"./en-in": 133,
	"./en-in.js": 133,
	"./en-nz": 134,
	"./en-nz.js": 134,
	"./en-sg": 135,
	"./en-sg.js": 135,
	"./eo": 136,
	"./eo.js": 136,
	"./es": 137,
	"./es-do": 138,
	"./es-do.js": 138,
	"./es-mx": 139,
	"./es-mx.js": 139,
	"./es-us": 140,
	"./es-us.js": 140,
	"./es.js": 137,
	"./et": 141,
	"./et.js": 141,
	"./eu": 142,
	"./eu.js": 142,
	"./fa": 143,
	"./fa.js": 143,
	"./fi": 144,
	"./fi.js": 144,
	"./fil": 145,
	"./fil.js": 145,
	"./fo": 146,
	"./fo.js": 146,
	"./fr": 147,
	"./fr-ca": 148,
	"./fr-ca.js": 148,
	"./fr-ch": 149,
	"./fr-ch.js": 149,
	"./fr.js": 147,
	"./fy": 150,
	"./fy.js": 150,
	"./ga": 151,
	"./ga.js": 151,
	"./gd": 152,
	"./gd.js": 152,
	"./gl": 153,
	"./gl.js": 153,
	"./gom-deva": 154,
	"./gom-deva.js": 154,
	"./gom-latn": 155,
	"./gom-latn.js": 155,
	"./gu": 156,
	"./gu.js": 156,
	"./he": 157,
	"./he.js": 157,
	"./hi": 158,
	"./hi.js": 158,
	"./hr": 159,
	"./hr.js": 159,
	"./hu": 160,
	"./hu.js": 160,
	"./hy-am": 161,
	"./hy-am.js": 161,
	"./id": 162,
	"./id.js": 162,
	"./is": 163,
	"./is.js": 163,
	"./it": 164,
	"./it-ch": 165,
	"./it-ch.js": 165,
	"./it.js": 164,
	"./ja": 166,
	"./ja.js": 166,
	"./jv": 167,
	"./jv.js": 167,
	"./ka": 168,
	"./ka.js": 168,
	"./kk": 169,
	"./kk.js": 169,
	"./km": 170,
	"./km.js": 170,
	"./kn": 171,
	"./kn.js": 171,
	"./ko": 172,
	"./ko.js": 172,
	"./ku": 173,
	"./ku.js": 173,
	"./ky": 174,
	"./ky.js": 174,
	"./lb": 175,
	"./lb.js": 175,
	"./lo": 176,
	"./lo.js": 176,
	"./lt": 177,
	"./lt.js": 177,
	"./lv": 178,
	"./lv.js": 178,
	"./me": 179,
	"./me.js": 179,
	"./mi": 180,
	"./mi.js": 180,
	"./mk": 181,
	"./mk.js": 181,
	"./ml": 182,
	"./ml.js": 182,
	"./mn": 183,
	"./mn.js": 183,
	"./mr": 184,
	"./mr.js": 184,
	"./ms": 185,
	"./ms-my": 186,
	"./ms-my.js": 186,
	"./ms.js": 185,
	"./mt": 187,
	"./mt.js": 187,
	"./my": 188,
	"./my.js": 188,
	"./nb": 189,
	"./nb.js": 189,
	"./ne": 190,
	"./ne.js": 190,
	"./nl": 191,
	"./nl-be": 192,
	"./nl-be.js": 192,
	"./nl.js": 191,
	"./nn": 193,
	"./nn.js": 193,
	"./oc-lnc": 194,
	"./oc-lnc.js": 194,
	"./pa-in": 195,
	"./pa-in.js": 195,
	"./pl": 196,
	"./pl.js": 196,
	"./pt": 197,
	"./pt-br": 198,
	"./pt-br.js": 198,
	"./pt.js": 197,
	"./ro": 199,
	"./ro.js": 199,
	"./ru": 200,
	"./ru.js": 200,
	"./sd": 201,
	"./sd.js": 201,
	"./se": 202,
	"./se.js": 202,
	"./si": 203,
	"./si.js": 203,
	"./sk": 204,
	"./sk.js": 204,
	"./sl": 205,
	"./sl.js": 205,
	"./sq": 206,
	"./sq.js": 206,
	"./sr": 207,
	"./sr-cyrl": 208,
	"./sr-cyrl.js": 208,
	"./sr.js": 207,
	"./ss": 209,
	"./ss.js": 209,
	"./sv": 210,
	"./sv.js": 210,
	"./sw": 211,
	"./sw.js": 211,
	"./ta": 212,
	"./ta.js": 212,
	"./te": 213,
	"./te.js": 213,
	"./tet": 214,
	"./tet.js": 214,
	"./tg": 215,
	"./tg.js": 215,
	"./th": 216,
	"./th.js": 216,
	"./tk": 217,
	"./tk.js": 217,
	"./tl-ph": 218,
	"./tl-ph.js": 218,
	"./tlh": 219,
	"./tlh.js": 219,
	"./tr": 220,
	"./tr.js": 220,
	"./tzl": 221,
	"./tzl.js": 221,
	"./tzm": 222,
	"./tzm-latn": 223,
	"./tzm-latn.js": 223,
	"./tzm.js": 222,
	"./ug-cn": 224,
	"./ug-cn.js": 224,
	"./uk": 225,
	"./uk.js": 225,
	"./ur": 226,
	"./ur.js": 226,
	"./uz": 227,
	"./uz-latn": 228,
	"./uz-latn.js": 228,
	"./uz.js": 227,
	"./vi": 229,
	"./vi.js": 229,
	"./x-pseudo": 230,
	"./x-pseudo.js": 230,
	"./yo": 231,
	"./yo.js": 231,
	"./zh-cn": 232,
	"./zh-cn.js": 232,
	"./zh-hk": 233,
	"./zh-hk.js": 233,
	"./zh-mo": 234,
	"./zh-mo.js": 234,
	"./zh-tw": 235,
	"./zh-tw.js": 235
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 355;

/***/ }),
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pagination pagination-absolute"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0 mb-2"},[_c('carousel',{attrs:{"perPage":1,"paginationActiveColor":"#fff","paginationColor":"rgba(255,255,255,.43)"}},_vm._l((_vm.news),function(item){return _c('slide',{key:item.slug},[_c('div',{staticClass:"slider-box position-relative",on:{"click":function($event){_vm.getNews(item.link.replace('/haber/', ''))}}},[_c('img',{staticClass:"w-100 slider-image",attrs:{"src":_vm.$store.state.baseImageURL + item.image}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute z-9"},[_vm._v(_vm._s(item.title))])])])}),1)],1),_vm._v(" "),_c('div',{staticClass:"w-100 pagination pagination-relative col-12"},[_c('carousel',{ref:"matchCarousel",attrs:{"perPage":1}},_vm._l((_vm.matches),function(item){return _c('slide',{key:item.id},[_c('div',{staticClass:"w-100"},[_c('MatchVS',{attrs:{"data":item}})],1)])}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 text-center pt-3 pb-3"},[(!_vm.$store.getters.isLogged)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.push({name: 'Login'})}}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.$store.state.ads.nofanclub.srcUrl,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isLogged)?_c('div',[_c('iframe',{staticStyle:{"width":"100%"},style:('height: calc(' + (parseInt(_vm.$store.state.ads.home.height.replace('%', ''))) + 'vw)'),attrs:{"src":_vm.$store.state.ads.home.srcUrl}})]):_vm._e()]),_vm._v(" "),_c('CampaignCarousel',{attrs:{"data":_vm.campaigns}}),_vm._v(" "),_c('Leader',{attrs:{"data":_vm.stats}})],1)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeMatchDay_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23228170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeMatchDay_vue__ = __webpack_require__(378);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeMatchDay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23228170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeMatchDay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-box"},[_c('div',{staticClass:"comment-list"},[(_vm.data.length == 0)?_c('div',{staticStyle:{"padding":"15px 0px"}},[_c('p',{staticClass:"text-center"},[_vm._v("Henüz hiç yorum yapılmamış")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('div',{key:item.id,staticClass:"comment-block"},[_c('div',{staticClass:"comment-image"},[_c('img',{staticClass:"w-100 rounded-circle",staticStyle:{"width":"42px","height":"42px","border-radius":"50%"},attrs:{"src":item.user.avatar_url},on:{"click":function($event){return _vm.getProfile(item.user.id)}}})]),_vm._v(" "),_c('div',{staticClass:"comment-area"},[_c('div',{staticClass:"comment-top clearfix"},[_c('a',{staticClass:"float-left fc-1 fs-2 font-weight-bold",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.getProfile(item.user.id)}}},[_vm._v(_vm._s(item.user.name))]),_vm._v(" "),_c('p',{staticClass:"text-secondary text-center float-right fc-3 fs-11"},[_vm._v("\n            "+_vm._s(_vm.$fromNow(item.date.date))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"comment-body"},[_c('p',[_vm._v(_vm._s(item.comment))])]),_vm._v(" "),_c('div',{staticClass:"comment-bottom text-right",staticStyle:{"display":"flex","align-items":"center","flex-direction":"row","justify-content":"space-between"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center"}},[_c('a',{class:item.is_liked ? 'liked' : '',staticStyle:{"width":"50px","height":"40px","display":"flex","align-items":"center","justify-content":"center","font-size":"20px","color":"#333"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.toggleLike(item.id)}}},[_c('i',{staticClass:"ion-md-thumbs-up"})]),_vm._v(" "),_c('a',{staticStyle:{"color":"#333","height":"40px","font-size":"13px","display":"flex","align-items":"center","justify-content":"center"},attrs:{"href":"javascript:;"}},[_c('span',[_vm._v(_vm._s(item.like_count)+" beğeni")])])]),_vm._v(" "),_c('a',{staticClass:"fc-3 fs-11 font-weight-bold",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.comment_id = item.id;
              _vm.showActionSheet();}}},[_vm._v("Şikayet Et")])])])])})],2),_vm._v(" "),(_vm.$store.getters.isLogged)?_vm._t("comment"):_vm._e(),_vm._v(" "),(_vm.$store.getters.isLogged == false)?_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}},[_c('p',{staticClass:"text-center",staticStyle:{"color":"gray","margin-top":"15px","margin-bottom":"15px"}},[_vm._v("\n      Yorum yapabilmek için giriş yapmanız gerekmektedir.\n    ")]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"fc-2",staticStyle:{"padding":"10px"},attrs:{"to":{ name: 'Login' }}},[_vm._v("Giriş Yap")]),_vm._v(" "),_c('router-link',{staticClass:"fc-2",staticStyle:{"padding":"10px"},attrs:{"to":{ name: 'Register' }}},[_vm._v("Kayıt Ol")])],1)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header bb-1"},[_c('h1',{staticClass:"fs-12 fc-3"},[_vm._v("Maçın Kritik Adamları")]),_vm._v(" "),_c('div',{staticClass:"slider-dots text-center float-right mt-20"},_vm._l((_vm.data),function(i,index){return _c('span',{key:index,class:index == _vm.pageIndex ? 'active' : ''})}),0)]),_vm._v(" "),_c('div',{staticClass:"box-body pb-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":false},on:{"pageChange":_vm.pageChanged}},_vm._l((_vm.data),function(item,index){return _c('slide',{key:item.slug + '_' + index},[_c('div',{staticClass:"player"},[_c('div',{staticClass:"row",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"col-3 p-0"},[_c('div',{staticClass:"player-image"},[_c('img',{staticClass:"w-100",attrs:{"src":item.photo != undefined ? item.photo : _vm.$store.state.baseImageURL + '/img/player/' + _vm.$store.state.app.yearslug + '/' + item.jerseyNo + '/face.webp'}})])]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('h1',{staticClass:"player-title fs-12 fc-6 pt-2"},[_vm._v(_vm._s(item.playerName || item.name))]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((item.stats),function(stat){return _c('div',{staticClass:"col-4"},[_c('h1',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(stat.title))]),_vm._v(" "),_c('h2',{staticClass:"fs-24 fc-1"},[_vm._v(_vm._s(stat.value))])])}),0)])])])])}),1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0 pagination pagination-relative"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header"},[_c('h1',{staticClass:"fs-20 fc-1"},[_vm._v("Kampanyalar")]),_vm._v(" "),_c('div',{staticClass:"slider-dots text-center float-right"},_vm._l((_vm.data),function(i,index){return _c('span',{key:index,class:index == _vm.pageIndex ? 'active' : ''})}),0)]),_vm._v(" "),_c('carousel',{attrs:{"perPage":1,"paginationEnabled":false},on:{"pageChange":_vm.pageChanged}},_vm._l((_vm.data),function(item){return _c('slide',{key:item.slug},[_c('div',{staticClass:"box-header p-0",on:{"click":function($event){return _vm.$router.push({name: 'FanClubDetail', params: {slug: item.id, data: item}})}}},[_c('img',{staticClass:"w-100",attrs:{"src":item.image}})]),_vm._v(" "),_c('div',{staticClass:"box-title bb-1",on:{"click":function($event){return _vm.$router.push({name: 'FanClubDetail', params: {slug: item.id, data: item}})}}},[_c('a',{attrs:{"href":"javascript:;"}},[_c('h1',{staticClass:"fc-2 fs-20"},[_vm._v(_vm._s(item.name))])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters bg-2 bb-1"},[_c('div',{staticClass:"col-6 br-1",on:{"click":function($event){return _vm.$router.push({name: 'FanClubDetail', params: {slug: item.id, data: item}})}}},[_c('div',{staticClass:"block-link text-center pt-3 pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v(" Kampanya Detayı\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6",on:{"click":function($event){return _vm.$router.push({name: 'FanClub'})}}},[_c('div',{staticClass:"block-link text-center pt-3 pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/four-dot.svg"}}),_vm._v(" Tüm Kampanyalar\n              ")])])])])])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pagination pagination-absolute"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[(_vm.data.related.news.length != 0)?_c('div',{staticClass:"col-12 p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationActiveColor":"#fff","paginationColor":"rgba(255,255,255,.43)"}},_vm._l((_vm.data.related.news.slice().reverse()),function(item){return _c('slide',{key:item.slug},[_c('div',{staticClass:"slider-box position-relative",on:{"click":function($event){return _vm.getNews(item.slug)}}},[_c('img',{staticClass:"w-100 slider-image",attrs:{"src":item.original}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute z-9"},[_vm._v("\n                  "+_vm._s(item.title)+"\n                ")])])])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 py-4"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"fs-10 fc-3"},[_vm._v(_vm._s(_vm.data.homeTeam.name.toLowerCase() == "anadolu efes"
                    ? _vm.data.awayTeam.name
                    : _vm.data.homeTeam.name)+"\n                maçına kalan süre:")])]),_vm._v(" "),(_vm.data.dateTime != null && _vm.duration != null)?_c('div',{staticClass:"col-7"},[_c('ul',{staticClass:"time-clock clearfix d-flex"},[_c('li',[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.duration.hours()))]),_vm._v("Saat\n                ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.duration.minutes()))]),_vm._v("Dakika\n                ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.duration.seconds()))]),_vm._v("Saniye\n                ")])])]):_vm._e(),_vm._v(" "),(_vm.data.ticket_link != null && _vm.data.ticket_link != '')?_c('div',{staticClass:"col-5"},[_c('button',{staticClass:"red-button mt-9 px-0",on:{"click":function($event){return _vm.$buy(_vm.data.ticket_link)}}},[_vm._v("\n                Maça Bilet Al!\n              ")])]):_vm._e()]),_vm._v(" "),(
              _vm.checked_in == false &&
                _vm.$store.state.app.match.related_campaign != null
            )?_c('button',{staticClass:"confirm-button mt-2",on:{"click":_vm.checkIn}},[_vm._v("\n            "+_vm._s(_vm.$store.state.user != null &&
              _vm.$store.state.app.match.related_campaign != null
                ? "Check-in"
                : "Check-in için giriş yap")+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.checked_in == true)?_c('button',{staticClass:"confirm-button mt-2",on:{"click":_vm.checkIn}},[_vm._v("\n            Check-in Yaptınız\n          ")]):_vm._e()]),_vm._v(" "),(_vm.stats.length != 0)?_c('Mvp',{attrs:{"data":_vm.stats}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 text-center pt-3 pb-3"},[(!_vm.$store.getters.isLogged)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.push({ name: 'Login' })}}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.$store.state.ads.nofanclub.srcUrl,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isLogged)?_c('div',[_c('iframe',{staticStyle:{"width":"100%"},style:('height: calc(' +
                  parseInt(_vm.$store.state.ads.home.height.replace('%', '')) +
                  'vw'),attrs:{"src":_vm.$store.state.ads.home.srcUrl}})]):_vm._e()]),_vm._v(" "),_c('CampaignCarousel',{attrs:{"data":_vm.campaigns}}),_vm._v(" "),_c('div',{staticClass:"col-12 p-0 mt-2"},[(_vm.data.previous_match != null)?_c('div',{staticClass:"item-box text-center p-3"},[_c('h1',{staticClass:"fs-14 fc-6"},[_vm._v("ÖNCEKİ MAÇ")]),_vm._v(" "),_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.data.previous_match.league)+",\n              "+_vm._s(_vm.data.previous_match.court))]),_vm._v(" "),_c('div',{staticClass:"team-band"},[_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"height":"100px"},attrs:{"src":_vm.data.previous_match.homeTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2"},[_vm._v("\n                    "+_vm._s(_vm.data.previous_match.homeTeam.name)+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"skor-final"},[_c('div',{staticClass:"detail pt-4"},[_c('p',{staticClass:"fs-14 fc-2 font-weight-bold m-0"},[_vm._v("\n                    "+_vm._s(_vm.data.previous_match.homeTeam.score)+"\n                    "),_c('span',{staticClass:"px-1"},[_vm._v(":")]),_vm._v("\n                    "+_vm._s(_vm.data.previous_match.awayTeam.score)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"perriod fs-14 fc-3 font-weight-bold"},[_vm._v("MS")])])]),_vm._v(" "),_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"height":"100px"},attrs:{"src":_vm.data.previous_match.awayTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2"},[_vm._v("\n                    "+_vm._s(_vm.data.previous_match.awayTeam.name)+"\n                  ")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row no-gutters bg-2 bb-1 bt-1",on:{"click":function($event){return _vm.$router.push({
                name: 'HomeAfterMatch',
                params: { id: _vm.data.previous_match.id }
              })}}},[_vm._m(2)]),_vm._v(" "),_c('Comment',{attrs:{"data":_vm.comments},on:{"commentDeleted":_vm.getComments},scopedSlots:_vm._u([{key:"comment",fn:function(){return [_c('div',{staticClass:"add-comment"},[_c('div',{staticClass:"comment-image"},[_c('img',{staticClass:"w-100 rounded-circle",attrs:{"src":_vm.$store.state.user.avatarUrl}})]),_vm._v(" "),_c('div',{staticClass:"comment-area"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"comment-input mt-2",attrs:{"placeholder":"Yorum Yaz"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),(_vm.comment != null && _vm.comment != '')?_c('button',{staticClass:"confirm-button",on:{"click":_vm.sendComment}},[_vm._v("\n                    Yorum Yap\n                  ")]):_vm._e()])])]},proxy:true}])})],1)],1)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"half-clock align-self-center"},[_c('span',[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"half-clock align-self-center"},[_c('span',[_vm._v(":")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 br-1"},[_c('div',{staticClass:"block-link text-center pt-3 pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/fixture-dot.svg"}}),_vm._v(" Maç\n                  Sayfasına Git\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-grid"},[(_vm.data.length == 4)?_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px","margin-right":"0","margin-left":"0"}},[_c('div',{staticClass:"col-6 pl-0",staticStyle:{"padding-right":"9px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[0].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'),on:{"click":function($event){return _vm.showImage(0)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[1].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'),on:{"click":function($event){return _vm.showImage(1)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-6 pr-0",staticStyle:{"padding-left":"9px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[2].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'),on:{"click":function($event){return _vm.showImage(2)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[3].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'),on:{"click":function($event){return _vm.showImage(3)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.data.length == 1)?_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px","margin-right":"0","margin-left":"0"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 o-hidden p-0"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[0].image_thumb +  '); background-size: cover; height: calc(100vw'),on:{"click":function($event){return _vm.showImage(0)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.data.length == 2)?_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px","margin-right":"0","margin-left":"0"}},[_c('div',{staticClass:"col-12 pl-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 o-hidden pr-0",staticStyle:{"padding-right":"9px"}},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[0].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'),on:{"click":function($event){return _vm.showImage(0)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6 o-hidden pr-0",staticStyle:{"padding-right":"9px"}},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[1].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'),on:{"click":function($event){return _vm.showImage(1)}}})])])])]):_vm._e(),_vm._v(" "),(_vm.data.length == 3)?_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px","margin-right":"0","margin-left":"0"}},[_c('div',{staticClass:"col-4 pl-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[0].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'),on:{"click":function($event){return _vm.showImage(0)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[1].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'),on:{"click":function($event){return _vm.showImage(1)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[2].image_thumb +  '); background-size: cover; height: calc(66vw)'),on:{"click":function($event){return _vm.showImage(2)}}})])])]):_vm._e(),_vm._v(" "),(_vm.data.length >=5)?_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px","margin-right":"0","margin-left":"0"}},[_c('div',{staticClass:"col-4 pl-0",staticStyle:{"padding-right":"9px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[0].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'),on:{"click":function($event){return _vm.showImage(0)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[1].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'),on:{"click":function($event){return _vm.showImage(1)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-8 pr-0",staticStyle:{"padding-left":"9px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[2].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'),on:{"click":function($event){return _vm.showImage(2)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 o-hidden"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6",staticStyle:{"padding-right":"9px"}},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[3].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'),on:{"click":function($event){return _vm.showImage(3)}}})]),_vm._v(" "),_c('div',{staticClass:"col-6",staticStyle:{"padding-left":"9px"}},[_c('div',{staticClass:"w-100",style:('background-image: url(' + _vm.data[4].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'),on:{"click":function($event){return _vm.showImage(4)}}})])])])])])]):_vm._e(),_vm._v(" "),(_vm.data.length>5 && _vm.limited == false)?_c('div',{staticClass:"row",staticStyle:{"padding":"0px 15px","margin-right":"0","margin-left":"0"}},[_c('div',{staticClass:"col-12 pl-0"},[_c('div',{staticClass:"row"},_vm._l((_vm.otherImages),function(i,index){return _c('div',{key:i,staticClass:"col-6 o-hidden pr-0",staticStyle:{"padding-right":"9px"}},[_c('div',{staticClass:"w-100",style:('background-image: url(' + i +  '); background-size: cover; height: calc(50vw - 9px)'),on:{"click":function($event){return _vm.showImage(index+5)}}})])}),0)])]):_vm._e(),_vm._v(" "),(_vm.data.length>5)?_c('div',{staticClass:"tab-box",on:{"click":function($event){_vm.limited = !_vm.limited}}},[_c('div',{staticClass:"tab-footer"},[(_vm.limited)?_c('h2',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-down.svg"}}),_vm._v("\n        Daha Fazla Göster\n      ")]):_vm._e(),_vm._v(" "),(!_vm.limited)?_c('h2',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-down.svg"}}),_vm._v("\n        Daha Az Göster\n      ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.modal)?_c('div',{staticClass:"modal modal-area photo-modal d-flex align-items-center",staticStyle:{"padding":"0","top":"0"}},[_c('div',{staticClass:"modal-top position-absolute",staticStyle:{"right":"24px","z-index":"9999"},on:{"click":function($event){_vm.modal = false}}},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body w-100"},[_c('carousel',{ref:"carousel",attrs:{"perPage":1,"paginationEnabled":false},on:{"pageChange":_vm.pageChanged}},_vm._l((_vm.data),function(i){return _c('slide',{key:i.image},[_c('div',{staticClass:"w-100",style:('background-image: url(' + i.image +  '); background-size: contain; height: calc(100vh - 90px); background-repeat: no-repeat; background-position: center')})])}),1)],1),_vm._v(" "),_c('div',{staticClass:"modal-bottom position-absolute"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2 text-center"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.$refs.carousel.navigateTo = _vm.index != 0 ? _vm.index-1 : 0}}},[_c('img',{attrs:{"src":"/static/img/popup-left.svg","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-8",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('a',{staticClass:"fs-16 fc-5",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('onShareClicked')}}},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/popup-share.svg"}}),_vm._v(" Paylaş\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.$refs.carousel.navigateTo = _vm.index != _vm.data.length ? _vm.index+1 : _vm.data.length}}},[_c('img',{attrs:{"src":"/static/img/popup-right.svg","alt":""}})])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;"}},[_c('img',{attrs:{"src":"/static/img/close-icon.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-statistics",class:_vm.isAnadoluEfes == true ? '' : 'opponent'},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_c('td',{staticClass:"first-row"},[_c('div',{staticClass:"row no-gutters player-row"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"player-image rounded-circle overflow-hidden blue-border"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.isAnadoluEfes == true ? _vm.$store.state.baseImageURL + '/img/player/' + _vm.$store.state.app.yearslug + '/' + item.jerseyNo + '/face.webp' : '/static/img/user-avatar.svg'}})]),_vm._v(" "),_c('div',{staticClass:"player-number"},[_vm._v(_vm._s(item.jerseyNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"player-name"},[_vm._v(_vm._s(item.playerName))])])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.playTime))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.score))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.twoPoints))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.threePoints))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.freeThrowPoints))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.offensiveRebounds))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.defensiveRebounds))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.totalRebounds))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.assists))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.steals))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.turnovers))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.blocks))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.fouls))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.foulsReceived))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.effPoints))])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"first-row"}),_vm._v(" "),_c('th',[_vm._v("Süre")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("S")]),_vm._v(" "),_c('th',[_vm._v("  2S  ")]),_vm._v(" "),_c('th',[_vm._v("  3S  ")]),_vm._v(" "),_c('th',[_vm._v("  SA  ")]),_vm._v(" "),_c('th',[_vm._v("OR")]),_vm._v(" "),_c('th',[_vm._v("DR")]),_vm._v(" "),_c('th',[_vm._v("R")]),_vm._v(" "),_c('th',[_vm._v("A")]),_vm._v(" "),_c('th',[_vm._v("TÇ")]),_vm._v(" "),_c('th',[_vm._v("TK")]),_vm._v(" "),_c('th',[_vm._v("B")]),_vm._v(" "),_c('th',[_vm._v("F")]),_vm._v(" "),_c('th',[_vm._v("YF")]),_vm._v(" "),_c('th',[_vm._v("VP")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pagination pagination-absolute"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[(_vm.data.related.news.length != 0)?_c('div',{staticClass:"col-12 p-0"},[_c('carousel',{ref:"newsCarousel",attrs:{"perPage":1,"paginationActiveColor":"#fff","paginationColor":"rgba(255,255,255,.43)"}},_vm._l((_vm.data.related.news),function(item){return _c('slide',{key:item.slug},[_c('div',{staticClass:"slider-box position-relative",on:{"click":function($event){return _vm.getNews(item.slug)}}},[_c('img',{staticClass:"w-100 slider-image",attrs:{"src":item.original}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute z-9"},[_vm._v(_vm._s(item.title))])])])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box text-center p-3"},[_c('h1',{staticClass:"fs-14 fc-6 rb"},[_vm._v(_vm._s(_vm.data.league))]),_vm._v(" "),_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.$dateString(_vm.data.dateTime))+", "+_vm._s(_vm.data.location))]),_vm._v(" "),_c('div',{staticClass:"team-band"},[_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.data.homeTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2"},[_vm._v(_vm._s(_vm.data.homeTeam.name))])])]),_vm._v(" "),_c('div',{staticClass:"skor-final-home"},[_c('div',{staticClass:"detail pt-4"},[_c('p',{staticClass:"fs-19 fc-2 font-weight-bold m-0"},[_vm._v("\n                    "+_vm._s(_vm.data.scores.home.final)+"\n                    "),_c('span',{staticClass:"px-1"},[_vm._v(":")]),_vm._v("\n                    "+_vm._s(_vm.data.scores.away.final)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"perriod fs-14 fc-3"},[_vm._v("MS")])])]),_vm._v(" "),_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.data.awayTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2"},[_vm._v(_vm._s(_vm.data.awayTeam.name))])])])])]),_vm._v(" "),_c('div',{staticClass:"bg-2 bb-1 bt-1"},[_c('div',{staticClass:"pl-5 pr-5"},[_c('table',{staticClass:"fs-12 fc-3 table"},[_c('tr',[_c('td',[_vm._v("T")]),_vm._v(" "),_c('td',[_vm._v("1.P")]),_vm._v(" "),_c('td',[_vm._v("2.P")]),_vm._v(" "),_c('td',[_vm._v("3.P")]),_vm._v(" "),_c('td',[_vm._v("4.P")]),_vm._v(" "),(_vm.data.scores.home.Q5)?_c('td',[_vm._v("5.P")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q6)?_c('td',[_vm._v("6.P")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q7)?_c('td',[_vm._v("7.P")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q8)?_c('td',[_vm._v("8.P")]):_vm._e()]),_vm._v(" "),_c('tr',{staticClass:"fc-1"},[_c('td',[_vm._v(_vm._s(_vm.data.homeTeam.name_prefix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q3))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q4))]),_vm._v(" "),(_vm.data.scores.home.Q5)?_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q5))]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q6)?_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q6))]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q7)?_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q7))]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q8)?_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q8))]):_vm._e()]),_vm._v(" "),_c('tr',{staticClass:"fc-2"},[_c('td',[_vm._v(_vm._s(_vm.data.awayTeam.name_prefix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q3))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q4))]),_vm._v(" "),(_vm.data.scores.away.Q5)?_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q5))]):_vm._e(),_vm._v(" "),(_vm.data.scores.away.Q6)?_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q6))]):_vm._e(),_vm._v(" "),(_vm.data.scores.away.Q7)?_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q7))]):_vm._e(),_vm._v(" "),(_vm.data.scores.away.Q8)?_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q8))]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 text-center pt-3 pb-3"},[(!_vm.$store.getters.isLogged)?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.push({name: 'Login'})}}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.$store.state.ads.nofanclub.srcUrl,"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isLogged)?_c('div',[_c('iframe',{staticStyle:{"width":"100%"},style:('height: calc(' + (parseInt(_vm.$store.state.ads.home.height.replace('%', ''))) + 'vw)'),attrs:{"src":_vm.$store.state.ads.home.srcUrl}})]):_vm._e()]),_vm._v(" "),(_vm.stats.length != 0)?_c('Leader',{attrs:{"data":_vm.stats}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 p-0",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 tab-select",class:_vm.statisticsType == 'home' ? 'active' : '',on:{"click":function($event){_vm.statisticsType = 'home'}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v(_vm._s(_vm.data.homeTeam.name))])]),_vm._v(" "),_c('div',{staticClass:"col-6 tab-select",class:_vm.statisticsType == 'away' ? 'active' : '',on:{"click":function($event){_vm.statisticsType = 'away'}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v(_vm._s(_vm.data.awayTeam.name))])])])])]),_vm._v(" "),_c('div',{staticClass:"item-box p-3",staticStyle:{"margin-top":"0px"}},[(_vm.statisticsType == 'home' && _vm.data.stats.home != null)?_c('PlayerStatistics',{attrs:{"isAnadoluEfes":_vm.data.homeTeam.name == 'Anadolu Efes',"data":_vm.data.stats.home.stats}}):_vm._e(),_vm._v(" "),(_vm.statisticsType == 'away' && _vm.data.stats.home != null)?_c('PlayerStatistics',{attrs:{"isAnadoluEfes":_vm.data.awayTeam.name == 'Anadolu Efes',"data":_vm.data.stats.away.stats}}):_vm._e()],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 w-100",staticStyle:{"position":"unset"}},[_c('Gallery',{attrs:{"isLimited":true,"data":_vm.gallery}})],1),_vm._v(" "),(_vm.data.next_match != null)?_c('div',{staticClass:"col-12 w-100"},[_c('div',{staticClass:"item-box text-center p-3"},[_c('h1',{staticClass:"fs-14 fc-6 rb"},[_c('span',{staticClass:"fc-2"},[_vm._v("Sonraki Maç:")]),_vm._v("\n          "+_vm._s(_vm.$dateString(_vm.data.next_match.dateTime))+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.data.next_match.court))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100%"},attrs:{"src":_vm.data.next_match.homeTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2"},[_vm._v(_vm._s(_vm.data.next_match.homeTeam.name))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100%"},attrs:{"src":_vm.data.next_match.awayTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2"},[_vm._v(_vm._s(_vm.data.next_match.awayTeam.name))])])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('Comment',{attrs:{"data":_vm.comments},on:{"commentDeleted":_vm.getComments},scopedSlots:_vm._u([{key:"comment",fn:function(){return [_c('div',{staticClass:"add-comment"},[_c('div',{staticClass:"comment-image"},[_c('img',{staticClass:"w-100 rounded-circle",attrs:{"src":_vm.$store.state.user.avatarUrl}})]),_vm._v(" "),_c('div',{staticClass:"comment-area"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"comment-input mt-2",attrs:{"placeholder":"Yorum Yaz"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),(_vm.comment != null && _vm.comment != '')?_c('button',{staticClass:"confirm-button",on:{"click":_vm.sendComment}},[_vm._v("Yorum Yap")]):_vm._e()])])]},proxy:true}],null,false,596467740)})],1):_vm._e()]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4"},[_c('div',{staticClass:"detail pt-4"},[_c('p',{staticClass:"hour"},[_vm._v("-:-")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters bg-2 bb-1 bt-1",staticStyle:{"display":"none"}},[_c('div',{staticClass:"col-12 br-1"},[_c('div',{staticClass:"block-link text-center pt-3 pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v(" Maça Bilet Al\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeLiveMatch_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5c3b816_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeLiveMatch_vue__ = __webpack_require__(393);
function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeLiveMatch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5c3b816_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeLiveMatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckIn_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c28aaf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckIn_vue__ = __webpack_require__(392);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79c28aaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c28aaf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 py-4"},[(
      _vm.checked_in == false &&
        _vm.$store.state.app.match &&
        _vm.$store.state.app.match.related_campaign != null
    )?_c('button',{staticClass:"confirm-button mt-2",on:{"click":_vm.checkIn}},[_vm._v("\n    "+_vm._s(_vm.$store.state.user != null &&
      _vm.$store.state.app.match &&
      _vm.$store.state.app.match.related_campaign != null
        ? _vm.checkInType == "checkin"
          ? "Check-in"
          : "Desteğini Göster"
        : "Check-in için giriş yap")+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.checked_in == true)?_c('button',{staticClass:"confirm-button mt-2"},[_vm._v("\n    "+_vm._s(_vm.checkedInType == "checkin"
        ? "Check-in Yaptınız"
        : "Desteğinizi Gösterdiniz")+"\n  ")]):_vm._e(),_vm._v(" "),_c('transition-group',{staticStyle:{"overflow":"hidden","width":"100%","display":"flex","align-items":"center","justify-content":"flex-end","margin-top":"10px"},attrs:{"name":"list-complete","tag":"div"}},_vm._l((_vm.checkIns),function(item,index){return _c('div',{key:item.id,staticClass:"list-complete-item",staticStyle:{"width":"40px","height":"40px","border-radius":"20px","margin-right":"5px"},on:{"click":_vm.addNew}},[_c('div',{staticStyle:{"width":"40px","height":"40px","border-radius":"20px","box-shadow":"0px 0px 5px rgba(0,0,0,.3)","background-size":"cover"},style:('background-image: url(' + item.avatarUrl + ')')},[(item.avatarUrl.indexOf('default') != -1)?_c('div',{staticStyle:{"background-color":"rgba(0,0,0,.6)","color":"white","font-weight":"bold","display":"flex","align-items":"center","justify-content":"center","position":"absolute","width":"40px","height":"40px","border-radius":"20px"}},[_vm._v("\n          "+_vm._s(item.first_name.charAt(0))+"."+_vm._s(item.last_name.charAt(0))+"\n        ")]):_vm._e()])])}),0),_vm._v(" "),(_vm.totalCheckin != null)?_c('div',{staticStyle:{"width":"100%","text-align":"right","margin-top":"10px"}},[_vm._v("\n    "+_vm._s(_vm.totalCheckin)+" kişi bu maçta.\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pagination pagination-absolute"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"slider-box position-relative d-flex align-items-center"},[_c('img',{staticClass:"w-100 slider-image",attrs:{"src":"/static/img/saha2.png"}}),_vm._v(" "),_c('div',{staticClass:"score-panel text-center p-3"},[_c('span',{staticClass:"fs-14 fc-5"},[_vm._v("\n                "+_vm._s(_vm.match.tournamentName)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.match.location)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"team-band"},[_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.match.homeTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-12 fc-5"},[_vm._v(_vm._s(_vm.match.homeTeam.name))])])]),_vm._v(" "),_c('div',{staticClass:"skor-live"},[_c('div',{staticClass:"detail pt-4"},[_c('p',{staticClass:"fs-22 fc-5 font-weight-bold m-0"},[_vm._v("\n                      "+_vm._s(_vm.match.score1)+"\n                      "),_c('span',{staticClass:"pl-1 pr-1"},[_vm._v(":")]),_vm._v("\n                      "+_vm._s(_vm.match.score2)+"\n                    ")]),_vm._v(" "),(_vm.match.status != 'MS')?_c('p',{staticClass:"perriod fs-14 fc-5"},[_vm._v("\n                      "+_vm._s(_vm.match.status)+". Çeyrek Kalan Süre:\n                      "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-24 rbs"},[_vm._v(_vm._s(_vm.match.timeMinute)+":"+_vm._s(_vm.match.timeSecond))])]):_vm._e(),_vm._v(" "),(_vm.match.status == 'MS')?_c('p',{staticClass:"perriod fs-14 fc-5"},[_vm._v("\n                      MAÇ SONUCU\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.match.awayTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-12 fc-5"},[_vm._v(_vm._s(_vm.match.awayTeam.name))])])])])])]),_vm._v(" "),_c('div',{staticClass:"bg-2 bb-1 bt-1"},[_c('div',{staticClass:"pl-5 pr-5"},[_c('table',{staticClass:"fs-12 fc-3 table"},[_c('tr',[_c('td',[_vm._v("T")]),_vm._v(" "),_c('td',[_vm._v("1.P")]),_vm._v(" "),_c('td',[_vm._v("2.P")]),_vm._v(" "),_c('td',[_vm._v("3.P")]),_vm._v(" "),_c('td',[_vm._v("4.P")]),_vm._v(" "),(_vm.data.scores.home.Q5)?_c('td',[_vm._v("5.P")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q6)?_c('td',[_vm._v("6.P")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q7)?_c('td',[_vm._v("7.P")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q8)?_c('td',[_vm._v("8.P")]):_vm._e()]),_vm._v(" "),_c('tr',{staticClass:"fc-1"},[_c('td',[_vm._v(_vm._s(_vm.data.homeTeam.name_prefix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q3))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.home.Q4))]),_vm._v(" "),(_vm.data.scores.home.Q5)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.home.Q5)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q6)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.home.Q6)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q7)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.home.Q7)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.data.scores.home.Q8)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.home.Q8)+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('tr',{staticClass:"fc-2"},[_c('td',[_vm._v(_vm._s(_vm.data.awayTeam.name_prefix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q3))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.data.scores.away.Q4))]),_vm._v(" "),(_vm.data.scores.away.Q5)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.away.Q5)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.data.scores.away.Q6)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.away.Q6)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.data.scores.away.Q7)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.away.Q7)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.data.scores.away.Q8)?_c('td',[_vm._v("\n                    "+_vm._s(_vm.data.scores.away.Q8)+"\n                  ")]):_vm._e()])])])])]),_vm._v(" "),_c('CheckIn'),_vm._v(" "),_c('div',{staticClass:"col-12 p-0",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 tab-select",class:_vm.statisticsType == 'home' ? 'active' : '',on:{"click":function($event){_vm.statisticsType = 'home'}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                    "+_vm._s(_vm.data.homeTeam.name)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 tab-select",class:_vm.statisticsType == 'away' ? 'active' : '',on:{"click":function($event){_vm.statisticsType = 'away'}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                    "+_vm._s(_vm.data.awayTeam.name)+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"item-box p-3",staticStyle:{"margin-top":"0px"}},[(_vm.statisticsType == 'home' && _vm.data.stats.home != null)?_c('PlayerStatistics',{attrs:{"isAnadoluEfes":_vm.data.homeTeam.name == 'Anadolu Efes',"data":_vm.data.stats.home.stats}}):_vm._e(),_vm._v(" "),(_vm.statisticsType == 'away' && _vm.data.stats.home != null)?_c('PlayerStatistics',{attrs:{"isAnadoluEfes":_vm.data.awayTeam.name == 'Anadolu Efes',"data":_vm.data.stats.away.stats}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0 mt-2"},[_c('Comment',{attrs:{"data":_vm.comments},on:{"commentDeleted":_vm.getComments},scopedSlots:_vm._u([{key:"comment",fn:function(){return [_c('div',{staticClass:"add-comment"},[_c('div',{staticClass:"comment-image"},[_c('img',{staticClass:"w-100 rounded-circle",attrs:{"src":_vm.$store.state.user.avatarUrl}})]),_vm._v(" "),_c('div',{staticClass:"comment-area"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"comment-input mt-2",attrs:{"placeholder":"Yorum Yaz"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),(_vm.comment != null && _vm.comment != '')?_c('button',{staticClass:"confirm-button",on:{"click":_vm.sendComment}},[_vm._v("\n                    Yorum Yap\n                  ")]):_vm._e()])])]},proxy:true}])})],1)],1)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.app.match == null)?_c('HomeDefault'):_vm._e(),_vm._v(" "),(_vm.$store.state.app != null && _vm.$store.state.app.match != null && _vm.$store.state.app.match.status == 'live')?_c('HomeLiveMatch'):_vm._e(),_vm._v(" "),(_vm.$store.state.app != null && _vm.$store.state.app.match != null && _vm.$store.state.app.match.status == 'finished')?_c('HomeAfterMatch'):_vm._e(),_vm._v(" "),(_vm.$store.state.app != null && _vm.$store.state.app.match != null && _vm.$store.state.app.match.status == 'waiting')?_c('HomeMatchDay'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93811612_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(396);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93811612_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"hideMore":"","title":"Haberler"}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._l((_vm.$store.state.news),function(item){return _c('div',{key:item.slug,staticClass:"col-12 p-0",on:{"click":function($event){return _vm.getNews(item.slug)}}},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('img',{staticClass:"w-100",attrs:{"src":item.thumb_960}})]),_vm._v(" "),_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(item.date))])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[(item.comment_count != 0)?_c('span',{staticClass:"fs-12 fc-3"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/comments-icon.svg"}}),_vm._v("\n                    "+_vm._s(item.comment_count)+"\n                  ")]):_vm._e()])])])])])}),_vm._v(" "),_c('infinite-loading',{on:{"infinite":_vm.getData}})],2)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsDetail_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572f7cf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsDetail_vue__ = __webpack_require__(402);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_572f7cf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1f8644e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(400);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1f8644e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lightbox-alpha animated fadeIn"},[_c('a',{staticClass:"btn-close",attrs:{"href":"#"},on:{"click":function($event){return _vm.closeModal()}}},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"lightbox-content animated"},[_c('img',{attrs:{"src":_vm.content}})]),_vm._v(" "),_c('a',{staticClass:"btn-share",attrs:{"href":"#"},on:{"click":function($event){return _vm.$openShare(
                _vm.content,
                'Anadolu Efes Spor Kulübü'
                
              )}}},[_vm._v("Paylaş")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data != undefined)?_c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"header-area bg-transparent position-absolute w-100 border-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$openShare(
                'https://www.anadoluefessk.org/haber/' + _vm.data.slug,
                _vm.data.title
              )}}},[_c('span',{staticClass:"menu-dot mt-4"})])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"slider-box position-relative"},[_c('img',{staticClass:"w-100 slider-image",attrs:{"src":_vm.data.images.original}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute z-9"},[_vm._v("\n              "+_vm._s(_vm.data.title)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"news-gra"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[(
              _vm.data.content.some(function (k) { return k.type == 'gallery'; }) ||
                _vm.data.content.some(function (k) { return k.type == 'matchstat'; })
            )?_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-4 tab-select",class:_vm.tab == 'general' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('general')}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                    Haber\n                  ")])]),_vm._v(" "),(_vm.data.content.some(function (k) { return k.type == 'gallery'; }))?_c('div',{staticClass:"col-4 tab-select",class:_vm.tab == 'gallery' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('gallery')}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                    Foto Galeri\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.data.content.some(function (k) { return k.type == 'matchstat'; }))?_c('div',{staticClass:"col-4 tab-select",class:_vm.tab == 'statistics' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('statistics')}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                    İstatistik\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.tab == 'general')?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box p-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.$dateString(_vm.data.date.date)))])])]),_vm._v(" "),_c('div',{staticClass:"content-block pt-3"},[_c('p',{staticStyle:{"font-size":"18px","margin-bottom":"10px","font-family":"Roboto Slab"},domProps:{"innerHTML":_vm._s(_vm.data.excerpt)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(
                    _vm.data.content.find(function (k) { return k.type == 'original'; }).content
                  )}})])]),_vm._v(" "),_c('Comment',{attrs:{"data":_vm.comments},on:{"commentDeleted":_vm.getComments},scopedSlots:_vm._u([{key:"comment",fn:function(){return [_c('div',{staticClass:"add-comment"},[_c('div',{staticClass:"comment-image"},[_c('img',{staticClass:"w-100 rounded-circle",attrs:{"src":_vm.$store.state.user.avatarUrl}})]),_vm._v(" "),_c('div',{staticClass:"comment-area"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"comment-input mt-2",attrs:{"placeholder":"Yorum Yaz"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),(_vm.comment != null && _vm.comment != '')?_c('button',{staticClass:"confirm-button",on:{"click":_vm.sendComment}},[_vm._v("\n                      Yorum Yap\n                    ")]):_vm._e()])])]},proxy:true}],null,false,844509724)})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.tab == 'gallery')?_c('div',{staticClass:"col-12 p-0",staticStyle:{"position":"unset","min-height":"100vh"}},[_c('vue-masonry-gallery',{attrs:{"imgsArr":_vm.images},on:{"click":_vm.clickFn,"scrollReachBottom":_vm.getData}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.tab == 'statistics')?_c('div',{staticClass:"col-12 p-0",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 tab-select",class:_vm.statisticsType == 'home' ? 'active' : '',on:{"click":function($event){_vm.statisticsType = 'home'}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                      "+_vm._s(_vm.data.content.find(function (k) { return k.type == "matchstat"; }).content
                          .home.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 tab-select",class:_vm.statisticsType == 'away' ? 'active' : '',on:{"click":function($event){_vm.statisticsType = 'away'}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''},[_vm._v("\n                      "+_vm._s(_vm.data.content.find(function (k) { return k.type == "matchstat"; }).content
                          .away.name)+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"item-box p-3",staticStyle:{"margin-top":"0px"}},[(_vm.statisticsType == 'home')?_c('PlayerStatistics',{attrs:{"isAnadoluEfes":_vm.data.content.find(function (k) { return k.type == 'matchstat'; }).content.home
                    .name == 'Anadolu Efes',"data":_vm.data.content.find(function (k) { return k.type == 'matchstat'; }).content.home
                    .stats}}):_vm._e(),_vm._v(" "),(_vm.statisticsType == 'away')?_c('PlayerStatistics',{attrs:{"isAnadoluEfes":_vm.data.content.find(function (k) { return k.type == 'matchstat'; }).content.away
                    .name == 'Anadolu Efes',"data":_vm.data.content.find(function (k) { return k.type == 'matchstat'; }).content.away
                    .stats}}):_vm._e()],1)]):_vm._e()])],1)])]),_vm._v(" "),_c('Footer'),_vm._v(" "),(_vm.modalIsVisible)?_c('modal',{attrs:{"closeModal":_vm.closeModal,"content":_vm.modalContent,"slug":_vm.modalSlug}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryDetail_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6879fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryDetail_vue__ = __webpack_require__(404);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6879fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.title)?_c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"header-area bg-transparent position-absolute w-100 border-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$openShare('https://www.anadoluefessk.org/foto-galeri/' + _vm.data.slug, _vm.data.title)}}},[_c('span',{staticClass:"menu-dot mt-4"})])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"slider-box position-relative"},[_c('img',{staticClass:"w-100 slider-image",attrs:{"src":_vm.data.featured_image.image_960}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute z-9"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"news-gra"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"col-12 p-0",staticStyle:{"margin-top":"20px","position":"unset"}},[_c('Gallery',{attrs:{"isLimited":false,"data":_vm.images},on:{"onShareClicked":_vm.onShare}})],1)])],1)])]),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SinanErdem_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8e1dfa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SinanErdem_vue__ = __webpack_require__(406);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SinanErdem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d8e1dfa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SinanErdem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"content-block py-3"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 p-0 pt-3"},[_c('button',{staticClass:"confirm-button",on:{"click":function($event){return _vm.$buy('http://maps.google.com/maps?q=40.9886324,28.8517036')}}},[_vm._v("BENİ MAÇA GÖTÜR!")])])])])])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-box position-relative row",staticStyle:{"z-index":"99"}},[_c('div',{staticClass:"header-area position-absolute w-100 bg-transparent border-0 fc-5",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"#"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"-15px","margin-right":"-15px","position":"relative"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/sinanerdem.png"}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute",staticStyle:{"z-index":"9999","bottom":"20px","left":"20px"}},[_vm._v("\n          Sinan Erdem\n          Spor Salonu\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n              Metrobüsten Şirinevler durağında inip, Ataköy tarafından\n              çıkış yaparak, kısa bir yürüyüşle salona ulaşabilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Yenikapı - Atatürk Havalimanı (M1A) Metro hattında,\n              Ataköy durağında inip kısa bir yürüyüşle salona\n              ulaşabilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Ataköy Marmaray istasyonunda inip, kısa bir\n              yürüyüş ile salona ulaşabilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Kadıköy ve Bostancı’dan Deniz Otobüsü ile Bakırköy’e\n              gelerek bu noktadan kısa bir taksi yolculuğu ile salona\n              ulaşabilirsin ya da MR20 otobüsünü kullanarak salona\n              gelebilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Ya da;")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basket_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58002513_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basket_vue__ = __webpack_require__(408);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58002513_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"hideMore":"","title":"Anadolu Efes TV"}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._l((_vm.$store.state.videos),function(item){return _c('div',{key:item.slug,staticClass:"col-12 p-0",on:{"click":function($event){return _vm.getVideo(item.slug)}}},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('img',{staticClass:"w-100",attrs:{"src":item.images.big}})]),_vm._v(" "),_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v(_vm._s(item.title))])])])])}),_vm._v(" "),_c('infinite-loading',{on:{"infinite":_vm.getData}})],2)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasketDetail_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eadfb5a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasketDetail_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BasketDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eadfb5a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasketDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data != undefined)?_c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"Anadolu Efes TV"}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box mt-3"},[_c('div',{staticClass:"box-title"},[_c('a',{attrs:{"href":"#"}},[_c('h1',{staticClass:"fc-2 fs-20"},[_vm._v(_vm._s(_vm.data.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-header p-0"},[_c('iframe',{staticStyle:{"height":"250px"},attrs:{"width":"100%","src":'https://www.youtube.com/embed/' +
                    _vm.getVideoId +
                    '?autoplay=1'}})])]),_vm._v(" "),_c('Comment',{attrs:{"data":_vm.comments},on:{"commentDeleted":_vm.getComments},scopedSlots:_vm._u([{key:"comment",fn:function(){return [_c('div',{staticClass:"add-comment"},[_c('div',{staticClass:"comment-image"},[_c('img',{staticClass:"w-100 rounded-circle",attrs:{"src":_vm.$store.state.user.avatarUrl}})]),_vm._v(" "),_c('div',{staticClass:"comment-area"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comment),expression:"comment"}],staticClass:"comment-input mt-2",attrs:{"placeholder":"Yorum Yaz"},domProps:{"value":(_vm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comment=$event.target.value}}}),_vm._v(" "),(_vm.comment != null && _vm.comment != '')?_c('button',{staticClass:"confirm-button",on:{"click":_vm.sendComment}},[_vm._v("\n                    Yorum Yap\n                  ")]):_vm._e()])])]},proxy:true}],null,false,589196444)})],1)])])]),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FanClub_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a2f406_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FanClub_vue__ = __webpack_require__(412);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FanClub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a2f406_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FanClub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"hideMore":"","title":"Anadolu Efes Fan Club Kampanyaları"}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.$store.state.campaigns),function(item){return _c('div',{key:item.id,staticClass:"col-12 p-0",on:{"click":function($event){return _vm.$router.push({name: 'FanClubDetail', params: {data: item, slug: item.id}})}}},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('img',{staticClass:"w-100",attrs:{"src":item.image}})]),_vm._v(" "),_c('div',{staticClass:"box-title p-0"},[_c('h1',{staticClass:"fc-2 fs-20 bb-1 p-g"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_vm._m(0,true)])])])}),0)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"fc-1 fs-14 pt-2 pb-2"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v("\n                  Kampanya Detayı\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FanClubDetail_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01af7cb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FanClubDetail_vue__ = __webpack_require__(416);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FanClubDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01af7cb2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FanClubDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadApp_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98aab9f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadApp_vue__ = __webpack_require__(415);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98aab9f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 w-100",staticStyle:{"padding-top":"20px"}},[_c('h3',{staticClass:"text-center fc-2"},[_vm._v("\n    Kampanyalara Katılmak İçin\n    "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fc-1",staticStyle:{"font-size":"145%"}},[_vm._v("Uygulamayı İndirin")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-top":"10px"}},[_c('a',{attrs:{"target":"_blank","href":"https://play.google.com/store/apps/details?id=com.creasoup.aeskfancard"}},[_c('img',{staticStyle:{"height":"45px"},attrs:{"src":"https://play.google.com/intl/en_us/badges/images/badge_new.png"}})]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://apps.apple.com/tr/app/anadolu-efes-spor-kul%C3%BCb%C3%BC/id1050153694?l=tr#?platform=iphone"}},[_c('img',{staticStyle:{"height":"45px"},attrs:{"src":"https://developer.apple.com/app-store/marketing/guidelines/images/badge-example-preferred.png"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data != undefined)?_c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),(_vm.confirmation)?_c('div',{staticClass:"modal-area d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"modal-box align-self-center text-center"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"confirm-button",on:{"click":function($event){return _vm.confirmCampaign();}}},[_vm._v("Evet Eminim")]),_vm._v(" "),_c('button',{staticClass:"ignore-button",on:{"click":function($event){return _vm.confirmationToggle();}}},[_vm._v("Vazgeç")])])]):_vm._e(),_vm._v(" "),(_vm.locationInfo)?_c('div',{staticClass:"modal-area d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"modal-box align-self-center"},[_c('h1',{staticClass:"fs-16 fc-2 mb-2"},[_vm._v("Kampanyaya katılabilmek için konum izni vermen gerekmektedir.")]),_vm._v(" "),_c('button',{staticClass:"confirm-button"},[_vm._v("Ayarlar")]),_vm._v(" "),_c('button',{staticClass:"ignore-button",on:{"click":function($event){return _vm.toggleLocationInfo();}}},[_vm._v("Kapat")])])]):_vm._e(),_vm._v(" "),_c('Header',{attrs:{"hideMore":"","title":"Anadolu Efes Fan Club Kampanyaları"}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.data.image}})]),_vm._v(" "),_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20"},[_vm._v(_vm._s(_vm.data.name))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.description)}}),_vm._v(" "),_c('DownloadApp'),_vm._v(" "),( false)?_c('div',{staticClass:"best-offer no-gutters row"},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e()],1),_vm._v(" "),( false)?_c('div',{staticClass:"action-timer no-gutters row"},[_vm._m(3),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),( false)?_c('div',{staticClass:"auction-actions no-gutters row d-flex align-items-center"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-6 p-0"},[_c('button',{staticClass:"confirm-button",on:{"click":function($event){return _vm.toggleLocationInfo();}}},[_vm._v("Katıl")])])]):_vm._e(),_vm._v(" "),( false)?_c('div',{staticClass:"auction-actions no-gutters row d-flex align-items-center"},[_c('div',{staticClass:"col-12 p-0"},[_c('button',{staticClass:"confirm-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmationToggle();}}},[_vm._v("Kampanyaya Katıl")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"campain-rules"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.legal_text)}})])])])])]),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"fs-16 fc-2 mb-2"},[_vm._v("\n        Bu kampanyaya katılarak\n        "),_c('span',{staticClass:"fc-6 font-weight-bold"},[_vm._v("200 PUAN")]),_vm._v("\n        harcayacaksın emin misiniz?\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1"},[_c('img',{staticClass:"w-100 rounded-circle blue-border",attrs:{"src":"/static/demoimages/32.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-9 pl-2"},[_c('h1',{staticClass:"fs-10 fc-1"},[_vm._v("\n                    EN YÜKSEK TEKLİF\n                    "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fc-6"},[_vm._v("520 PUAN")]),_vm._v(" İLE OZAN Ç.\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('h3',[_vm._v("Açık artırma kampanyasının sonlanmasına kalan süre:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 text-right"},[_c('span',{staticClass:"timer"},[_vm._v("16:55")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 p-0"},[_c('h1',{staticClass:"fc-1 fs-20"},[_vm._v("500 Puan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FanClubSuccess_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d712c83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FanClubSuccess_vue__ = __webpack_require__(418);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FanClubSuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d712c83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FanClubSuccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"body-area pb-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0 succes-top"}),_vm._v(" "),_c('div',{staticClass:"col-12 text-center py-2 succes-bottom"},[_c('div',[_c('h1',{staticClass:"fs-22 fc-2"},[_vm._v("TEBRİKLER!")]),_vm._v(" "),_c('h2',{staticClass:"fs-18 fc-2 font-weight-normal"},[_vm._v(" Galatasaray Doğa Sigorta maçına check-in yaparak 30 puan kazandın.")]),_vm._v(" "),_c('h3',{staticClass:"fs-14 fc-2 font-weight-bold"},[_vm._v("Kalan Puanın: 999,999")]),_vm._v(" "),_c('router-link',{staticClass:"ignore-button mt-2",staticStyle:{"display":"block"},attrs:{"to":{ name: 'FanClub' }}},[_vm._v("Kampanyalara Dön")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276befa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_vue__ = __webpack_require__(420);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276befa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"Maça Bilet Al","hideMore":""}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1",staticStyle:{"padding-left":"0","padding-right":"0"}},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-4 tab-select",class:_vm.activeTab == 0 ? 'active' : '',on:{"click":function($event){_vm.activeTab = 0}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("Maça Bilet Al")])]),_vm._v(" "),_c('div',{staticClass:"col-4 tab-select",class:_vm.activeTab == 1 ? 'active' : '',on:{"click":function($event){_vm.activeTab = 1}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("Kombine")])]),_vm._v(" "),_c('div',{staticClass:"col-4 tab-select",class:_vm.activeTab == 2 ? 'active' : '',on:{"click":function($event){_vm.activeTab = 2}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("Paketler")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.activeTab == 0)?_c('div',{staticClass:"col-12 p-0"},[(_vm.tickets.length == 0)?_c('h3',{staticStyle:{"text-align":"center","padding-top":"1em"}},[_vm._v("Şu anda satışa sunulmuş bilet bulunmamaktadır.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.tickets),function(item,index){return _c('div',{key:index,staticClass:"fixture-item"},[_c('MatchVS',{attrs:{"data":item}})],1)})],2):_vm._e(),_vm._v(" "),(_vm.activeTab == 1)?_c('div',{staticClass:"col-12 p-0"},_vm._l((_vm.combines),function(item,index){return _c('div',{key:index,staticClass:"fixture-item"},[_c('h3',{staticStyle:{"text-align":"center","padding-top":"1em"}},[_vm._v("Şu anda kombine bilet satışımız bulunmamaktadır.")])])}),0):_vm._e(),_vm._v(" "),(_vm.activeTab == 2)?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"row",staticStyle:{"margin":"0"}},[(_vm.packages.length == 0)?_c('h3',{staticStyle:{"text-align":"center","padding-top":"1em","display":"block","width":"100%"}},[_vm._v("Şu anda satışa sunulmuş paket bilet bulunmamaktadır.")]):_vm._e(),_vm._v(" "),(_vm.packages.length != 0)?_c('div',{staticClass:"col-12 bg-5",staticStyle:{"height":"20px","padding":"0","display":"flex","align-items":"center","justify-content":"center"}},_vm._l((_vm.packages),function(item,i){return _c('span',{key:i,staticStyle:{"width":"5px","height":"5px","border-radius":"2.5px","margin":"0px 2px","display":"inline-block"},style:('background-color: ' + (i == _vm.index ? '#fff' : '#ddd'))})}),0):_vm._e()]),_vm._v(" "),(_vm.packages.length != 0)?_c('carousel',{attrs:{"perPage":1,"paginationEnabled":false},on:{"pageChange":_vm.pageChange}},_vm._l((_vm.packages),function(item,index){return _c('slide',{key:index},[_c('div',{staticClass:"fixture-item"},[_c('img',{staticClass:"w-100",attrs:{"src":item.image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"col-12 p-2"},[_c('p',{domProps:{"innerHTML":_vm._s(item.text)}})]),_vm._v(" "),_c('button',{staticClass:"confirm-button",on:{"click":function($event){return _vm.$buy(item.ticketLink)}}},[_vm._v("Hemen Al")])])])}),1):_vm._e()],1):_vm._e()])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a11c77de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__(430);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a11c77de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointActions_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8961c9e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointActions_vue__ = __webpack_require__(423);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8961c9e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body px-0",staticStyle:{"padding-bottom":"0"}},_vm._l((_vm.limit ? _vm.items.slice(0, 5) : _vm.items),function(item,index){return _c('div',{key:index,staticClass:"puan-line bb-1 p-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10"},[_c('h1',{staticClass:"fs-12 fc-2"},[_vm._v("\n            "+_vm._s(item.title)+"\n            "),_c('span',{staticClass:"fs-10 fc-3 d-block font-weight-normal"},[_vm._v(_vm._s(_vm.$dateTime(item.date.date)))])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('h1',{staticClass:"fs-24 fc-1"},[_vm._v(_vm._s(item.point))])]),_vm._v(" "),(item.code != null && item.code != '')?_c('div',{staticClass:"row",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"col-12 fs-10 fc-3 d-block font-weight-normal",staticStyle:{"font-size":"12px"}},[_vm._v("Kampanya Kodu: "+_vm._s(item.code))])]):_vm._e()])])}),0),_vm._v(" "),(_vm.items.length>5)?_c('div',{staticClass:"row no-gutters",on:{"click":function($event){_vm.limit = !_vm.limit}}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"block-link text-center pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",style:(_vm.limit == false ? 'transform: rotate(180deg);' : ''),attrs:{"src":"/static/img/arrow-down.svg"}}),_vm._v("\n          "+_vm._s(_vm.limit ? 'Daha Fazla Göster' : 'Daha Az Göster')+"\n        ")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header bb-1"},[_c('h1',{staticClass:"fs-12 fc-3"},[_vm._v("Puan Hareketlerim")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyActions_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea4519b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyActions_vue__ = __webpack_require__(426);
function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea4519b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box",staticStyle:{"margin-top":"0"},attrs:{"id":"MyActions"}},[_c('div',{staticClass:"box-body px-0",staticStyle:{"padding-bottom":"15px"}},[_c('ul',{staticClass:"time-line follow-profil clearfix"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"fs-12",staticStyle:{"display":"flex","margin-bottom":"10px"}},[_c('div',{staticClass:"user-image bg-5",staticStyle:{"width":"6px","height":"6px","border-radius":"3px"}}),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('div',{staticClass:"tim fs-10 fc-3 pb-1"},[_vm._v(_vm._s(_vm.$fromNow(item.action_date.date)))]),_vm._v(" "),_c('h2',{staticClass:"font-weight-normal",domProps:{"innerHTML":_vm._s(item.action_name.replace(item.highlight, '<a class=handle_link id='+index+'>' + item.highlight + '</a>'))}})])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters",staticStyle:{"margin-top":"10px"},on:{"click":_vm.getdata}},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"block-link text-center pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-down.svg"}}),_vm._v("\n          Daha Fazla Göster\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActions_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d742b1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActions_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d742b1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box",staticStyle:{"margin-top":"0"},attrs:{"id":"UserActions"}},[_c('div',{staticClass:"box-body px-0",staticStyle:{"padding-bottom":"15px"}},[_c('ul',{staticClass:"time-line follow-profil clearfix"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"fs-12",staticStyle:{"display":"flex","margin-bottom":"10px"}},[_c('div',{staticClass:"user-image",staticStyle:{"width":"30px"},on:{"click":function($event){return _vm.getProfile(item.user.id)}}},[_c('div',{style:('width: 30px; height: 30px; border-radius: 15px; background-image: url(' + item.user.avatarUrl + '); background-size: contain')})]),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('div',{staticClass:"tim fs-10 fc-3 pb-1"},[_vm._v(_vm._s(_vm.$fromNow(item.action_date.date)))]),_vm._v(" "),_c('h1',{staticClass:"fs-12 fc-1",on:{"click":function($event){return _vm.getProfile(item.user.id)}}},[_vm._v(_vm._s(item.user.name))]),_vm._v(" "),_c('h2',{staticClass:"font-weight-normal",domProps:{"innerHTML":_vm._s(item.action_name.replace(item.highlight, '<a class=handle_link id='+index+'>' + item.highlight + '</a>'))}})])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters",staticStyle:{"margin-top":"10px"},on:{"click":_vm.getdata}},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"block-link text-center pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-down.svg"}}),_vm._v("\n          Daha Fazla Göster\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"header-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"position-relative row player-career user-profile"},[_c('div',{staticClass:"mt-5 user-profile-head"},[_c('div',{staticClass:"profil-edit float-right mr-3"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$openShare('https://www.anadoluefessk.org/fan-club/uye/' + _vm.user.id + '/' + _vm.user.slug, 'Anadolu Efes Fan Club Profilime Gözatın')}}},[_c('img',{attrs:{"src":"/static/img/popup-share.svg","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"user-image"},[_c('img',{staticClass:"rounded-circle mb-3 b-4",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.user.avatarUrl,"alt":""}})]),_vm._v(" "),_c('h1',{staticClass:"fs-20 fc-5 mb-3"},[_vm._v("\n            "+_vm._s(_vm.user.first_name)+"\n            "),_c('span',{staticClass:"font-weight-normal"},[_vm._v(_vm._s(_vm.user.last_name))])]),_vm._v(" "),_c('h2',{staticClass:"fs-24 fc-1 mb-4",staticStyle:{"font-size":"17px"}},[_vm._v(_vm._s(_vm.user.checkin_count)+" Maça Katıldın, "+_vm._s(_vm.user.total_point)+" Puan Kazandın")])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-4 tab-select",class:_vm.tab == 'account' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('account')}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'account' ? 'fc-2' : 'fc-1'},[_vm._v("Profilim")])]),_vm._v(" "),_c('div',{staticClass:"col-4 tab-select",class:_vm.tab == 'follower' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('follower')}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'follower' ? 'fc-2' : 'fc-1'},[_vm._v("Takipçi")])]),_vm._v(" "),_c('div',{staticClass:"col-4 tab-select",class:_vm.tab == 'following' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('following')}}},[_c('h1',{staticClass:"fs-16",class:_vm.tab == 'following' ? 'fc-2' : 'fc-1'},[_vm._v("Takip")])])])])])]),_vm._v(" "),(_vm.tab == 'account')?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fan-no py-3"},[_c('span',{staticClass:"fs-18 fc-3"},[_vm._v("\n              Fan Club No:\n              "),_c('span',{staticClass:"fc-1"},[_vm._v(_vm._s(_vm.user.fancard))])])]),_vm._v(" "),_c('PointActions'),_vm._v(" "),(_vm.tab == 'account')?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 tab-select",class:_vm.tab2 == 'accountActivities' ? 'active' : '',on:{"click":function($event){return _vm.changeTab2('accountActivities')}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("Hareketlerim")])]),_vm._v(" "),_c('div',{staticClass:"col-6 tab-select",class:_vm.tab2 == 'followActivities' ? 'active' : '',on:{"click":function($event){return _vm.changeTab2('followActivities')}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("Takip Hareketleri")])])])])])]),_vm._v(" "),(_vm.tab2 == 'followActivities')?_c('div',{staticClass:"box-body"},[_c('UserActions')],1):_vm._e(),_vm._v(" "),(_vm.tab2 == 'accountActivities')?_c('div',{staticClass:"box-body"},[_c('MyActions')],1):_vm._e()])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.tab == 'follower')?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"profil-list"},_vm._l((_vm.followers),function(item,index){return _c('div',{key:index,staticClass:"profil-list-item row py-2 bb-1"},[_c('div',{staticClass:"col-9"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.getProfile(item)}}},[_c('div',{staticClass:"profil-detail"},[_c('div',{staticClass:"user-image"},[_c('img',{staticClass:"w-100 rounded-circle",staticStyle:{"width":"52px","height":"52px"},attrs:{"src":item.avatarUrl}})]),_vm._v(" "),_c('h1',{staticClass:"fs-21 fc-1 py-3 mx-2 float-left"},[_vm._v(_vm._s(item.full_name))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 p-0"},[_c('button',{class:item.is_following ? 'unfollow p-1 py-2' : 'follow p-1 py-2',on:{"click":function($event){return _vm.toggleFollow(item, 'follower')}}},[_vm._v(_vm._s(item.is_following ? 'Takipten Cikar' : 'Takip Et'))])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.tab == 'following')?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"profil-list"},_vm._l((_vm.followings),function(item,index){return _c('div',{key:index,staticClass:"profil-list-item row py-2 bb-1"},[_c('div',{staticClass:"col-9"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.getProfile(item.id)}}},[_c('div',{staticClass:"profil-detail"},[_c('div',{staticClass:"user-image"},[_c('img',{staticClass:"w-100 rounded-circle",staticStyle:{"width":"52px","height":"52px"},attrs:{"src":item.avatarUrl}})]),_vm._v(" "),_c('h1',{staticClass:"fs-21 fc-1 py-3 mx-2 float-left"},[_vm._v(_vm._s(item.full_name))])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 p-0"},[_c('button',{class:item.is_following ? 'unfollow p-1 py-2' : 'follow p-1 py-2',on:{"click":function($event){return _vm.toggleFollow(item, 'follower')}}},[_vm._v(_vm._s(item.is_following ? 'Takipten Cikar' : 'Takip Et'))])])])}),0)])])]):_vm._e()])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44fbf1e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(435);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44fbf1e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActionsProfile_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7db63283_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActionsProfile_vue__ = __webpack_require__(434);
function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActionsProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7db63283_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActionsProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box",staticStyle:{"margin-top":"0"},attrs:{"id":"MyActions2"}},[_c('div',{staticClass:"box-body px-0",staticStyle:{"padding-bottom":"15px"}},[_c('ul',{staticClass:"time-line follow-profil clearfix"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"fs-12",staticStyle:{"display":"flex","margin-bottom":"10px"}},[_c('div',{staticClass:"user-image bg-5",staticStyle:{"width":"6px","height":"6px","border-radius":"3px"}}),_vm._v(" "),_c('div',{staticClass:"detail"},[_c('div',{staticClass:"tim fs-10 fc-3 pb-1"},[_vm._v(_vm._s(_vm.$fromNow(item.action_date.date)))]),_vm._v(" "),_c('h2',{staticClass:"font-weight-normal",domProps:{"innerHTML":_vm._s(item.action_name.replace(item.highlight, '<a class=handle_link id='+index+'>' + item.highlight + '</a>'))}})])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters",staticStyle:{"margin-top":"10px"},on:{"click":_vm.getdata}},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"block-link text-center pb-3"},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-down.svg"}}),_vm._v("\n          Daha Fazla Göster\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data != undefined)?_c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"header-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"position-relative row player-career user-profile"},[_c('div',{staticClass:"mt-5 user-profile-head"},[_c('div',{staticClass:"user-image"},[_c('img',{staticClass:"rounded-circle mb-3 b-4",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.data.avatarUrl,"alt":""}})]),_vm._v(" "),_c('h1',{staticClass:"fs-20 fc-5 mb-3"},[_vm._v("\n            "+_vm._s(_vm.data.first_name)+"\n            "),_c('span',{staticClass:"font-weight-normal"},[_vm._v(_vm._s(_vm.data.last_name))])]),_vm._v(" "),_c('h2',{staticClass:"fs-24 fc-1 mb-4"},[_vm._v(_vm._s(_vm.data.checked_in_count)+" Maça Katıldı")])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0 text-center mt-19"},[(_vm.$store.getters.isLogged)?_c('button',{class:_vm.data.is_following ? 'follow' : 'unfollow',on:{"click":_vm.toggleFollow}},[_vm._v(_vm._s(_vm.data.is_following ? 'Takipten Çıkar' : 'Takip Et'))]):_vm._e(),_vm._v(" "),(_vm.$store.getters.isLogged == false)?_c('button',{class:_vm.data.is_following ? 'follow' : 'unfollow',on:{"click":_vm.goLogin}},[_vm._v("Takip İçin Giriş Yap")]):_vm._e()]),_vm._v(" "),(_vm.$store.getters.isLogged)?_c('div',{staticClass:"item-box w-100"},[_c('div',{staticClass:"col-12"},[_c('UserActionsProfile',{attrs:{"id":_vm.id}})],1)]):_vm._e()])])]),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f34880_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSettings_vue__ = __webpack_require__(437);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f34880_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"Ayarlar"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 offset-4 text-center mt-3"},[_c('div',{staticClass:"user-image-edit w-100"},[_c('img',{staticClass:"w-100 rounded-circle",attrs:{"src":"/static/demoimages/32.jpg"}}),_vm._v(" "),_c('div',{staticClass:"edit-photo  d-flex align-self-center justify-content-center"},[_c('img',{attrs:{"src":"/static/img/edit-photo.svg","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('div',{staticClass:"form-check radio-custom  bb-1 py-2"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck55","checked":""}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck55"}},[_vm._v("\n              Bildirimleri Kapat\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check radio-custom  bb-1 py-2"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck56"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck56"}},[_vm._v("\n              Profili Aç\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check radio-custom  bb-1 py-2"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck57"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck57"}},[_vm._v("\n              Yorumlarda Adımı Gizle\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{staticClass:"form-input",attrs:{"type":"text","placeholder":"Eski Şifre"}}),_vm._v(" "),_c('input',{staticClass:"form-input",attrs:{"type":"text","placeholder":"Şifre"}}),_vm._v(" "),_c('input',{staticClass:"form-input",attrs:{"type":"text","placeholder":"Şifre Tekrar"}})]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"confirm-button mb-5"},[_vm._v("Değiştir")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('select',{staticClass:"form-select"},[_c('option',[_vm._v("Erkek")])]),_vm._v(" "),_c('input',{staticClass:"form-input",attrs:{"type":"text","placeholder":"00/00/1818"}}),_vm._v(" "),_c('select',{staticClass:"form-select"},[_c('option',[_vm._v("İstanbul")])]),_vm._v(" "),_c('select',{staticClass:"form-select"},[_c('option',[_vm._v("Kadıköy")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"confirm-button mb-5"},[_vm._v("Değiştir")])]),_vm._v(" "),_c('div',{staticClass:"col-12 fs-14 fc-3"},[_c('div',{staticClass:"form-check checkbox-custom"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck3"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck3"}},[_vm._v("\n              Anadolu Efes Spor Kulübü’nden e-posta\n              almayı kabul ediyorum.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check checkbox-custom"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck3"}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck3"}},[_vm._v("\n              Anadolu Efes Spor Kulübü’nden e-posta\n              almayı kabul ediyorum.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"confirm-button"},[_vm._v("Değiştir")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d357f0e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(439);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d357f0e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper log-bg"},[_c('div',{staticClass:"header-area bg-transparent border-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"back-arrow mt-4"})])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area pb-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"warning fs-14 fc-6 py-2 px-3"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),(_vm.activation_required)?_c('button',{staticClass:"sign-button",on:{"click":_vm.sendCode}},[_vm._v("Yeni Kod Gönder")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"E-posta adresin"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Şifre"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('router-link',{staticClass:"opak-button d-block fc-3 pr-0",attrs:{"to":{ name: 'ForgotPassword' }}},[_vm._v("Şifremi Unuttum")])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"confirm-button",on:{"click":_vm.login}},[_vm._v("Giriş Yap")])])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","margin-top":"30px"}},[_c('div',{staticClass:"col-12 mt-0"},[_c('router-link',{staticClass:"sign-button",staticStyle:{"display":"block","text-align":"center"},attrs:{"to":{ name: 'Register' }}},[_vm._v("Üye Ol")])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('router-link',{staticClass:"opak-button fc-2",staticStyle:{"display":"block","text-align":"center"},attrs:{"to":{ name: 'Home'}}},[_vm._v("Üye Olmadan Devam Et")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-center pb-2"},[_c('img',{attrs:{"src":"/static/img/logo.png","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d170cf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(441);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d170cf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper log-bg"},[_c('div',{staticClass:"header-area bg-transparent border-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":{ name: 'Login' }}},[_c('span',{staticClass:"back-arrow mt-4"})])],1)])])]),_vm._v(" "),_c('div',{staticClass:"body-area pb-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"E-posta adresin"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"confirm-button",on:{"click":_vm.send}},[_vm._v("Hatırlat")])]),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"20px","text-align":"center"}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.push({name: 'ChangePassword'})}}},[_vm._v("Sıfırlama kodunuz varsa buraya tıklayın")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-center pb-5"},[_c('img',{attrs:{"src":"/static/img/logo.png","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f9f03e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(444);
function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f9f03e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"Yardım","hideMore":""}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index + '-' + item.open,staticClass:"col-12"},[_c('div',{staticClass:"card box-one mt-2 help-box"},[_c('div',{staticClass:"card-header pt-3 p-2 pb-3",on:{"click":function($event){return _vm.toggle(index)}}},[_c('div',{staticClass:"row ml-0 mr-0"},[_c('div',{staticClass:"col-10"},[_c('span',{staticClass:"fs-14 fc-2"},[_vm._v(_vm._s(item.question))])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('img',{class:item.open ? 'd-none' : 'd-inline',attrs:{"src":"static/img/down-arrow.svg"}}),_vm._v(" "),_c('img',{class:item.open ? 'd-inline' : 'd-none',attrs:{"src":"static/img/up-arrow.svg"}})])])]),_vm._v(" "),_c('div',{staticClass:"card-body",class:item.open ? '' : 'd-none'},[_c('div',{staticClass:"row ml-0 mr-0 p-2 pb-3"},[_c('div',{staticClass:"col-11"},[_c('p',[_vm._v(_vm._s(item.answer))])])])])])])}),0)])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39369476_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(447);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39369476_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */,
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper log-bg"},[_c('div',{staticClass:"header-area bg-transparent border-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"back-arrow mt-4"})])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area pb-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.register_mail),expression:"form.register_mail"}],staticClass:"form-input",attrs:{"type":"email","placeholder":"E-posta adresin"},domProps:{"value":(_vm.form.register_mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_mail", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.register_pass),expression:"form.register_pass"}],staticClass:"form-input",attrs:{"type":"password","placeholder":"Şifre"},domProps:{"value":(_vm.form.register_pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_pass", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.register_pass_retry),expression:"form.register_pass_retry"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Şifre Tekrar"},domProps:{"value":(_vm.form.register_pass_retry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_pass_retry", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.register_name),expression:"form.register_name"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Adın"},domProps:{"value":(_vm.form.register_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_name", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.register_surname),expression:"form.register_surname"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Soyadın"},domProps:{"value":(_vm.form.register_surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_surname", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"model",rawName:"v-model",value:(_vm.form.register_birthday),expression:"form.register_birthday"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Doğum Tarihin"},domProps:{"value":(_vm.form.register_birthday)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_birthday", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('### ### ### ##'),expression:"'### ### ### ##'"},{name:"model",rawName:"v-model",value:(_vm.form.register_tckn),expression:"form.register_tckn"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"TC Kimlik No"},domProps:{"value":(_vm.form.register_tckn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_tckn", $event.target.value)}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.select_gender),expression:"form.select_gender"}],staticClass:"form-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "select_gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Cinsiyet")]),_vm._v(" "),_vm._l((_vm.genders),function(i){return _c('option',{key:i.value,domProps:{"value":i.value}},[_vm._v(_vm._s(i.title))])})],2),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ### ## ##'),expression:"'(###) ### ## ##'"},{name:"model",rawName:"v-model",value:(_vm.form.register_phone),expression:"form.register_phone"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Cep Telefonu Numaran"},domProps:{"value":(_vm.form.register_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "register_phone", $event.target.value)}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cityId),expression:"form.cityId"}],staticClass:"form-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Yaşadığın Şehir")]),_vm._v(" "),_vm._l((_vm.cities),function(i){return _c('option',{key:i.id,domProps:{"value":i.id}},[_vm._v(_vm._s(i.name))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.district),expression:"form.district"}],staticClass:"form-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "district", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Yaşadığın İlçe")]),_vm._v(" "),_vm._l((_vm.districts),function(i){return _c('option',{key:i.id,domProps:{"value":i.id}},[_vm._v(_vm._s(i.name))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.career),expression:"form.career"}],staticClass:"form-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "career", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Meslek")]),_vm._v(" "),_vm._l((_vm.professionList),function(i){return _c('option',{key:i.id,domProps:{"value":i.name}},[_vm._v(_vm._s(i.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 fs-14 fc-3"},[_c('div',{staticClass:"form-check checkbox-custom"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.allowEmail),expression:"form.allowEmail"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"defaultCheck3"},domProps:{"value":1,"checked":Array.isArray(_vm.form.allowEmail)?_vm._i(_vm.form.allowEmail,1)>-1:(_vm.form.allowEmail)},on:{"change":function($event){var $$a=_vm.form.allowEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=1,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "allowEmail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "allowEmail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "allowEmail", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck3"}},[_vm._v("\n              Anadolu Efes Spor Kulübü’nden e-posta\n              almayı kabul ediyorum.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check checkbox-custom"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.allowSms),expression:"form.allowSms"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"defaultCheck4"},domProps:{"value":1,"checked":Array.isArray(_vm.form.allowSms)?_vm._i(_vm.form.allowSms,1)>-1:(_vm.form.allowSms)},on:{"change":function($event){var $$a=_vm.form.allowSms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=1,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "allowSms", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "allowSms", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "allowSms", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck4"}},[_vm._v("\n              Anadolu Efes Spor Kulübü’nden SMS\n              almayı kabul ediyorum.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check checkbox-custom"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.term),expression:"form.term"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"defaultCheck2"},domProps:{"value":1,"checked":Array.isArray(_vm.form.term)?_vm._i(_vm.form.term,1)>-1:(_vm.form.term)},on:{"change":function($event){var $$a=_vm.form.term,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=1,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "term", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "term", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "term", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck2"}},[_c('span',[_c('span',{staticClass:"fc-1 font-weight-bold",on:{"click":function($event){_vm.termModal = true}}},[_vm._v("Katılım koşulları")]),_vm._v("nı okudum kabul ediyorum.\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('button',{staticClass:"confirm-button",on:{"click":_vm.register}},[_vm._v("Üye Ol")])])])])]),_vm._v(" "),_c('el-dialog',{attrs:{"width":"90%","visible":_vm.termModal,"title":"Katılım koşulları"},on:{"update:visible":function($event){_vm.termModal=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.term)}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-center pb-5"},[_c('img',{attrs:{"src":"/static/img/logo.png","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"warning fs-12 fc-3 py-2 px-3"},[_vm._v("\n            Aşağıdaki formdaki bilgiler T.C kimlik kartında\n            yazıldığı şekilde doldurulmalıdır.\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fixture_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b350abb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fixture_vue__ = __webpack_require__(451);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fixture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b350abb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fixture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatchVSFixture_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f8fb142_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatchVSFixture_vue__ = __webpack_require__(450);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatchVSFixture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f8fb142_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatchVSFixture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box text-center p-3"},[_c('h1',{staticClass:"fs-14 fc-6"},[_vm._v(_vm._s(_vm.$matchDate(_vm.data.dateTime)))]),_vm._v(" "),_c('span',{staticClass:"fs-12 fc-3"},[_vm._v(_vm._s(_vm.data.league)+" - "+_vm._s(_vm.data.court || _vm.data.court_name)+" "+_vm._s(_vm.data.tv != null && _vm.data.tv != "" ? " - " + _vm.data.tv : null))]),_vm._v(" "),_c('div',{staticClass:"team-band"},[_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.data.homeTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2",staticStyle:{"line-height":"14px","height":"42px"}},[_vm._v(_vm._s(_vm.data.homeTeam.name))])])]),_vm._v(" "),_c('div',{staticClass:"skor",staticStyle:{"width":"100px"}},[_c('div',{staticClass:"detail"},[_c('p',{staticClass:"hour"},[_vm._v(_vm._s(_vm.data.homeTeam.score)+" : "+_vm._s(_vm.data.awayTeam.score))])])]),_vm._v(" "),_c('div',{staticClass:"team-block"},[_c('div',{staticClass:"team one"},[_c('img',{staticClass:"img-responsive",staticStyle:{"width":"100px"},attrs:{"src":_vm.data.awayTeam.logo_url,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"fs-14 fc-2",staticStyle:{"line-height":"14px","height":"42px"}},[_vm._v(_vm._s(_vm.data.awayTeam.name))])])])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters bg-2 bb-1 bt-1"},[(_vm.data.isFinished == true)?_c('div',{staticClass:"block-link text-center pt-3 pb-3",staticStyle:{"display":"flex","flex":"1","align-items":"center","justify-content":"center"},on:{"click":function($event){return _vm.$router.push({name: 'HomeAfterMatch', params: {id: _vm.data.id}})}}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.data.ticketLink != '' && _vm.data.ticketLink != null && _vm.data.isFinished == false)?_c('div',{staticClass:"block-link text-center pt-3 pb-3",staticStyle:{"display":"flex","flex":"1","align-items":"center","justify-content":"center"}},[_c('h1',{staticClass:"fc-1 fs-14"},[_c('a',{staticClass:"fc-1",attrs:{"target":"_blank","href":_vm.data.ticket_link == undefined ? _vm.data.ticketLink : _vm.data.ticket_link}},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v(" Maça Bilet Al\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.hideAll == undefined)?_c('div',{staticClass:"block-link text-center pt-3 pb-3",staticStyle:{"display":"flex","flex":"1","align-items":"center","justify-content":"center"},on:{"click":function($event){return _vm.$router.push({name: 'Fixture'})}}},[_vm._m(1)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/arrow-left.svg"}}),_vm._v("\n        Maç Detayına Git\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"fc-1 fs-14"},[_c('img',{staticClass:"mr-2",attrs:{"src":"/static/img/two-dot.svg"}}),_vm._v(" Tüm Maçları Göster\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"header-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{staticClass:"pt-4 pb-4",attrs:{"src":"/static/img/back-arrow.svg"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1 pr-0 pl-0"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 tab-select pt-0",class:_vm.tab == 'future' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('future')}}},[_c('h1',{staticClass:"fs-18"},[_vm._v("Gelecek Maçlar")])]),_vm._v(" "),_c('div',{staticClass:"col-6 tab-select pt-0",class:_vm.tab == 'past' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('past')}}},[_c('h1',{staticClass:"fs-18"},[_vm._v("Geçmiş Maçlar")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},_vm._l((_vm.data),function(item){return _c('MatchVSFixture',{key:item.id,attrs:{"hideAll":"","data":item}})}),1)])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInSuccess_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ccaec5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInSuccess_vue__ = __webpack_require__(453);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInSuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ccaec5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInSuccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"body-area pb-0"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0 succes-top"}),_vm._v(" "),_c('div',{staticClass:"col-12 text-center py-2 succes-bottom "},[_c('div',[_c('h1',{staticClass:"fs-22 fc-2"},[_vm._v("TEBRİKLER!")]),_vm._v(" "),_c('h2',{staticClass:"fs-18 fc-2 font-weight-normal"},[_vm._v(" Galatasaray Doğa Sigorta maçına check-in yaparak 30 puan kazandın.")]),_vm._v(" "),_c('h3',{staticClass:"fs-14 fc-2 font-weight-bold"},[_vm._v("Kalan Puanın: 999,999")]),_vm._v(" "),_c('router-link',{staticClass:"ignore-button mt-2",staticStyle:{"display":"block"},attrs:{"to":{ name: 'Home' }}},[_vm._v("Anasayfaya Dön")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e4cb4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__ = __webpack_require__(456);
function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9e4cb4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"wrapper log-bg overflow-hidden pagination pagination-relative",attrs:{"id":"playerlist"}},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"team-list d-flex section--demo-2"},[_c('div',{staticClass:"glide",attrs:{"id":"topcarousel"}},[_c('div',{staticClass:"glide__track",attrs:{"data-glide-el":"track"}},[_c('ul',{staticClass:"glide__slides"},_vm._l((_vm.data),function(item,index){return _c('li',{key:index,staticClass:"glide__slide"},[_c('div',{staticClass:"team-list-item eurolig slider-box position-relative",class:index == _vm.activeItem ? 'active' : ''},[_c('h1',{staticClass:"fs-18 fc-5"},[_vm._v("\n                        "+_vm._s(item.name)+"\n                        "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-24"},[_vm._v("Takım Kadrosu")])])])])}),0)])])])])]),_vm._v(" "),(_vm.data[_vm.activeItem].isSub == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"player-list d-flex self-end",staticStyle:{"margin-top":"0px"}},[_c('div',{staticClass:"glide",attrs:{"id":"bottomcarousel"}},[_c('div',{staticClass:"glide__track",attrs:{"data-glide-el":"track"}},[_c('ul',{staticClass:"glide__slides"},_vm._l((_vm.data[_vm.activeItem].players),function(item,index){return _c('li',{key:index,staticClass:"glide__slide"},[_c('div',{staticClass:"player-list-item col-10",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"},on:{"click":function($event){return _vm.goProfile(item.id);}}},[_c('img',{staticStyle:{"height":"57vh","z-index":"99","position":"relative","margin-bottom":"70px","border-bottom":"4px solid red"},attrs:{"src":_vm.$store.state.baseImageURL + 'img/player/' + _vm.$store.state.app.yearslug + '/' + item.jerseyNo + '/body.png'}}),_vm._v(" "),_c('div',{staticClass:"player-box text-center",staticStyle:{"position":"absolute","bottom":"0px","height":"180px","display":"flex","align-items":"center","justify-content":"center","width":"calc(100% - 50px)","padding-top":"100px","z-index":"98"}},[_c('div',{staticClass:"player-name fs-28 fc-2 rbs",staticStyle:{"margin":"0","font-size":"20px"}},[_vm._v(_vm._s(item.name))])])])])}),0)])])])])]):_vm._e(),_vm._v(" "),(_vm.data[_vm.activeItem].isSub == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"player-list-young"},_vm._l((_vm.data[_vm.activeItem].players),function(item,index){return _c('div',{key:index,staticClass:"player-block bg-2"},[_c('div',{staticClass:"player"},[_c('div',{staticClass:"text-center number-area"},[_c('h1',{staticClass:"fs-20 fc-6 form-number"},[_vm._v(_vm._s(item.jerseyNo))])]),_vm._v(" "),_c('div',{staticClass:"player-detail"},[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"fs-20 fc-2 col-12 font-weight-normal player-name"},[_vm._v("\n                      "+_vm._s(item.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"fs-11 fc-2"},[_vm._v("Pozisyon")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(item.position))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"fs-11 fc-2"},[_vm._v("Yaş")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(_vm.moment().diff(item.birthDate.date, 'years', false)))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"fs-11 fc-2"},[_vm._v("Boy")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(item.height))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('span',{staticClass:"fs-11 fc-2"},[_vm._v("Doğum Yeri")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(item.birthPlace))])])])])])])}),0)])]):_vm._e()])]),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e10b37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__(458);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e10b37_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data != undefined)?_c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"header-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"position-relative row player-career"},[_c('div',{staticClass:"header-area position-absolute w-100 bg-transparent border-0 fc-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$openShare('https://anadoluefessk.org/takim/oyuncu/' + _vm.data.slug, _vm.data.name + ' Oyuncu İstatistikleri')}}},[_c('span',{staticClass:"menu-dot mt-4"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt-5"},[_c('h1',{staticClass:"fs-32 fc-5 position-absolute font-weight-normal"},[_c('span',{staticClass:"fs-64"},[_vm._v(_vm._s(_vm.data.jerseyNo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.name.replace(' ', '<br>'))}})]),_vm._v(" "),_c('figure',{staticClass:"float-right"},[_c('div',{style:('background-image: url(' + _vm.data.images.body + '); height: 50vh; width: 100%; background-size: auto 100%;    background-position: 0 -70px;    background-repeat: no-repeat;    background-position-x: center;')})])])])])]),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-header text-center bb-1"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 tab-select",class:_vm.tab == 'career' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('career')}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("Kariyeri")])]),_vm._v(" "),_c('div',{staticClass:"col-6 tab-select",class:_vm.tab == 'statistics' ? 'active' : '',on:{"click":function($event){return _vm.changeTab('statistics')}}},[_c('h1',{staticClass:"fs-16"},[_vm._v("İstatistikleri")])])])])])]),_vm._v(" "),(_vm.tab == 'career')?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row py-3 player-block",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"position"},[_c('span',{staticClass:"fs-15 fc-2 font-weight-bold"},[_vm._v("Pozisyon")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(_vm.data.position))])]),_vm._v(" "),_c('div',{staticClass:"age"},[_c('span',{staticClass:"fs-15 fc-2 font-weight-bold"},[_vm._v("Yaş")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(_vm.moment().diff(_vm.data.unformattedBirthDate, 'years', false)))])]),_vm._v(" "),_c('div',{staticClass:"long"},[_c('span',{staticClass:"fs-15 fc-2 font-weight-bold"},[_vm._v("Boy")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(_vm.data.height))])]),_vm._v(" "),_c('div',{staticClass:"nation"},[_c('span',{staticClass:"fs-15 fc-2 font-weight-bold"},[_vm._v("Doğum Yeri")]),_vm._v(" "),_c('span',{staticClass:"fs-18 fc-1"},[_vm._v(_vm._s(_vm.data.birthPlace))])])])]):_vm._e(),_vm._v(" "),(_vm.tab == 'career')?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box p-3",staticStyle:{"margin-top":"0"}},[_c('div',{staticClass:"content-block",domProps:{"innerHTML":_vm._s(_vm.data.description)}})])]):_vm._e(),_vm._v(" "),(_vm.tab == 'statistics')?_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box p-g"},[_c('div',{staticClass:"box-header bb-1 px-0"},[_c('h1',{staticClass:"fs-18 fc-6 font-weight-normal"},[_vm._v(_vm._s(_vm.getStats[_vm.index].tournamentName))]),_vm._v(" "),_c('div',{staticClass:"slider-dots text-center float-right statistics"},_vm._l((_vm.getStats),function(item,i){return _c('span',{key:i,class:_vm.index == i ? 'active' : ''})}),0)]),_vm._v(" "),_c('carousel',{attrs:{"perPage":1},on:{"pageChange":_vm.pageChanged}},_vm._l((_vm.getStats),function(item,index){return _c('slide',{key:index},[_c('div',{staticClass:"box-body px-0"},[_c('div',{staticClass:"row bb-1 py-3 no-gutters"},[_c('div',{staticClass:"col-4 text-center"},[_c('span',{staticClass:"fs-11 fc-2 font-weight-bold d-block"},[_vm._v("Toplam Maç")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.playedMatchCount))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center"},[_c('span',{staticClass:"fs-11 fc-2 font-weight-bold d-block"},[_vm._v("Ortalama Süre")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.minutesPerGame))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center"},[_c('span',{staticClass:"fs-11 fc-2 font-weight-bold d-block"},[_vm._v("Maç Başına Sayı")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.pointsPerGame))])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters mt-2"},[_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Serbest Atış")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v("%"+_vm._s(item.freeThrow))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("2 Sayı")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v("%"+_vm._s(item.twoPoints))])]),_vm._v(" "),_c('div',{staticClass:"col-4 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("3 Sayı")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v("%"+_vm._s(item.threePoints))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Ribaunt")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.rebounds))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("S. Ribaunt")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.defensiveRebounds))])]),_vm._v(" "),_c('div',{staticClass:"col-4 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("H. Ribaunt")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.offensiveRebounds))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Asist")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.assist))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Top Çalma")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.steals))])]),_vm._v(" "),_c('div',{staticClass:"col-4 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Top Kaybı")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.turnovers))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Faul")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.fouls))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Blok")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.blocks))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Yapılan Faul")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.foulsReceived))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Verimlilik Puanı")]),_vm._v(" "),_c('span',{staticClass:"fs-32 fc-1 rbs d-block"},[_vm._v(_vm._s(item.effPoints))])])])])])}),1)],1)]):_vm._e()])])]),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63113bf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63113bf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper log-bg overflow-hidden",attrs:{"id":"aaaa"}},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"team-list d-flex section--demo-2"},[_c('div',{staticClass:"glide",attrs:{"id":"topcarousel"}},[_c('div',{staticClass:"glide__track",attrs:{"data-glide-el":"track"}},[_c('ul',{staticClass:"glide__slides"},_vm._l((_vm.data),function(item,index){return _c('li',{key:index,staticClass:"glide__slide"},[_c('div',{staticClass:"team-list-item eurolig slider-box position-relative",class:index == _vm.activeItem ? 'active' : ''},[_c('h1',{staticClass:"fs-18 fc-5"},[_vm._v("\n                        "+_vm._s(item.stats.leagueName.replace('Tüm Maçlar', 'Tüm\nMaçlar'))+"\n                        "),_c('br'),_vm._v(" "),_c('span',{staticClass:"fs-24"},[_vm._v("Takım Kadrosu")])])])])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"glide",attrs:{"id":"bottomCarousel"}},[_c('ul',{staticClass:"glide__slides"},[_c('li',{staticClass:"glide__slide"},[_c('div',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-body px-0"},[_c('div',{staticClass:"row bb-1 py-2 no-gutters"},[_c('div',{staticClass:"col-4 text-center"},[_c('span',{staticClass:"fs-11 fc-2 font-weight-bold d-block"},[_vm._v("Toplam Maç")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold rbs d-block"},[_vm._v(_vm._s(_vm.item.stats.totalGame))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center"},[_c('span',{staticClass:"fs-11 fc-2 font-weight-bold d-block"},[_vm._v("Galibiyet")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold rbs d-block"},[_vm._v(_vm._s(_vm.item.stats.totalWin))])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center"},[_c('span',{staticClass:"fs-11 fc-2 font-weight-bold d-block"},[_vm._v("Mağlubiyet")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold rbs d-block"},[_vm._v(_vm._s(_vm.item.stats.totalLoss))])])]),_vm._v(" "),_c('div',{staticClass:"score-board bb-1 py-3"},[_c('table',[_c('tbody',[_c('tr',[_c('td',[_c('span',{staticClass:"bar blue fs-24",style:('width: '+(_vm.item.stats.scoreAverages.game.team)+'%; padding-right: 5px')},[_vm._v(_vm._s(_vm.item.stats.scoreAverages.game.team))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('td',[_c('span',{staticClass:"bar grey fs-24",style:('width: '+(_vm.item.stats.scoreAverages.game.rivals)+'%; padding-left: 5px;')},[_vm._v(_vm._s(_vm.item.stats.scoreAverages.game.rivals))])])]),_vm._v(" "),_vm._l((_vm.getScores),function(ii,iindex){return _c('tr',{key:iindex},[_c('td',[_c('span',{staticClass:"bar blue fs-16",style:('width: '+(ii.home)+'%')},[_c('span',{staticStyle:{"position":"absolute","right":"5px","top":"5px"}},[_vm._v(_vm._s(ii.home))])])]),_vm._v(" "),_c('td',{staticClass:"mid"},[_c('span',[_vm._v(_vm._s(ii.title))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"bar grey fs-16",style:('width: '+(ii.away)+'%')},[_c('span',{staticStyle:{"position":"absolute","left":"5px","top":"5px"}},[_vm._v(_vm._s(ii.away))])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters mt-2"},[_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Serbest Atış")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_c('span',{staticClass:"fs-18"},[_vm._v("%")]),_vm._v("\n                          "+_vm._s(_vm.item.stats.shootAverages.freeThrow.average)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("2 Sayı")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_c('span',{staticClass:"fs-18"},[_vm._v("%")]),_vm._v("\n                          "+_vm._s(_vm.item.stats.shootAverages.twoPoint.average)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-4 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("3 Sayı")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_c('span',{staticClass:"fs-18"},[_vm._v("%")]),_vm._v("\n                          "+_vm._s(_vm.item.stats.shootAverages.threePoint.average)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("S. Ribaunt")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.defensiveRebounds))])]),_vm._v(" "),_c('div',{staticClass:"col-4 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("H. Ribaunt")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.offensiveRebounds))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Asist")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.fouls))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Top Çalma")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.assists))])]),_vm._v(" "),_c('div',{staticClass:"col-4 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Top Kaybı")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.steals))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Faul")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.turnovers))])]),_vm._v(" "),_c('div',{staticClass:"col-4 br-1 my-2 text-center"},[_c('span',{staticClass:"fs-11 fc-2 d-block"},[_vm._v("Blok")]),_vm._v(" "),_c('span',{staticClass:"fs-24 fc-1 font-weight-bold d-block"},[_vm._v(_vm._s(_vm.item.stats.seasonAverages.blocks))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"score-area mt-5"},[_c('img',{staticClass:"w-100",attrs:{"src":"static/img/saha.png"}}),_vm._v(" "),_c('div',{staticClass:"one-shot shot clearfix"},[_c('div',{staticClass:"count"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('h1',{staticClass:"fs-18"},[_vm._v("%"+_vm._s(_vm.item.stats.shootAverages.freeThrow.average))]),_vm._v(" "),_c('h2',{staticClass:"fs-12"},[_vm._v(_vm._s(_vm.item.stats.shootAverages.freeThrow.total)+" / "+_vm._s(_vm.item.stats.shootAverages.freeThrow.scored))])])]),_vm._v(" "),_c('div',{staticClass:"two-shot shot clearfix"},[_c('div',{staticClass:"count"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('h1',{staticClass:"fs-18"},[_vm._v("%"+_vm._s(_vm.item.stats.shootAverages.twoPoint.average))]),_vm._v(" "),_c('h2',{staticClass:"fs-12"},[_vm._v(_vm._s(_vm.item.stats.shootAverages.twoPoint.total)+" / "+_vm._s(_vm.item.stats.shootAverages.twoPoint.scored))])])]),_vm._v(" "),_c('div',{staticClass:"three-shot shot clearfix"},[_c('div',{staticClass:"count"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('h1',{staticClass:"fs-18"},[_vm._v("%"+_vm._s(_vm.item.stats.shootAverages.threePoint.average))]),_vm._v(" "),_c('h2',{staticClass:"fs-12"},[_vm._v(_vm._s(_vm.item.stats.shootAverages.threePoint.total)+" / "+_vm._s(_vm.item.stats.shootAverages.threePoint.scored))])])])])]),_vm._v(" "),(_vm.item.standingsInJson)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"item-box"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.item.standingsInJson),function(i,index){return _c('tr',{key:index,staticClass:"fs-12",class:i.team_name.toLowerCase() == 'anadolu efes' ? 'fc-1 font-weight-bold' : ''},[_c('td',[_c('span',{staticClass:"fs-13 fc-6"},[_vm._v(_vm._s(i.place))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.team_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.played))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.win))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.loss))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.points))])])}),0)])])]):_vm._e()])])])])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"mid"},[_c('span',[_vm._v("Maç Başına Sayı")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"fs-10 fc-6 font-weight-bold"},[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("O")]),_vm._v(" "),_c('th',[_vm._v("G")]),_vm._v(" "),_c('th',[_vm._v("M")]),_vm._v(" "),_c('th',[_vm._v("P")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_938a6c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__ = __webpack_require__(463);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_938a6c8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.$store.state.modalImages[Math.round(Math.random() * 15) + 1]}})]),_vm._v(" "),_c('div',{staticClass:"col-12 text-center py-4"},[_c('h1',{staticClass:"fs-24 fc-2"},[_vm._v("TEBRİKLER!")]),_vm._v(" "),_c('h2',{staticClass:"fs-24 fc-2 font-weight-normal"},[_vm._v(_vm._s(_vm.$route.params.data.message.replace('[PUAN]', _vm.$route.params.data.bonus && _vm.$route.params.data.bonus.value ? _vm.$route.params.data.value + ' + ' + _vm.$route.params.data.bonus.value : _vm.$route.params.data.value)))]),_vm._v(" "),_c('h3',{staticClass:"fs-16 fc-2 font-weight-bold"},[_vm._v("Fan Club Puanın: "+_vm._s(_vm.$route.params.data.user.total_point))]),_vm._v(" "),_c('button',{staticClass:"ignore-button mt-4",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Geri Dön")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a073753_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__ = __webpack_require__(465);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a073753_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"Üyelik Aktivasyonu","hideMore":""}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70",staticStyle:{"height":"-webkit-fill-available","display":"flex","flex":"1","align-items":"center","justify-content":"center","flex-direction":"column","padding":"0px 25px"}},[_c('h2',{staticClass:"text-center fc-1",class:_vm.status == 200 ? 'fc-1' : 'fc-2',staticStyle:{"margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"E-Posta"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Doğrulama Kodu"},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token=$event.target.value}}}),_vm._v(" "),(_vm.status == 200)?_c('button',{staticClass:"opak-button fc-2",on:{"click":function($event){return _vm.$router.push({name: 'Login'})}}},[_vm._v("Giriş Yap")]):_vm._e(),_vm._v(" "),(_vm.status != 200)?_c('button',{staticClass:"confirm-button",on:{"click":_vm.activate}},[_vm._v("Aktive Et")]):_vm._e()]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303f5668_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(471);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_303f5668_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"İletişim","hideMore":""}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70",staticStyle:{"min-height":"-webkit-fill-available","display":"flex","flex":"1","align-items":"center","justify-content":"center","flex-direction":"column","padding":"0px 25px","padding-bottom":"150px","padding-top":"100px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.firstname),expression:"form.firstname"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Ad"},domProps:{"value":(_vm.form.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "firstname", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.lastname),expression:"form.lastname"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Soyad"},domProps:{"value":(_vm.form.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "lastname", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"E-Mail"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.phone),expression:"form.phone"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Telefon"},domProps:{"value":(_vm.form.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "phone", $event.target.value)}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.city),expression:"form.city"}],staticClass:"form-input",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Şehir")]),_vm._v(" "),_vm._l((_vm.cities),function(item){return _c('option',{domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.subject),expression:"form.subject"}],staticClass:"form-input",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "subject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Konu")]),_vm._v(" "),_vm._l((_vm.subjects),function(item){return _c('option',{domProps:{"value":item.name}},[_vm._v(_vm._s(item.name))])})],2),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"}],staticClass:"form-input",attrs:{"name":"","id":"","cols":"30","rows":"10","placeholder":"Mesajınız..."},domProps:{"value":(_vm.form.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"confirm-button",on:{"click":_vm.send}},[_vm._v("Gönder")]),_vm._v(" "),_c('ol',_vm._l((_vm.errors),function(item){return _c('li',{staticStyle:{"color":"red","font-weight":"bold","font-size":"12px"}},[_vm._v(_vm._s(item))])}),0)]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2fd6d9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(473);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2fd6d9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('Header',{attrs:{"title":"Şifre Yenileme","hideMore":""}}),_vm._v(" "),_c('div',{staticClass:"body-area pt70",staticStyle:{"height":"-webkit-fill-available","display":"flex","flex":"1","align-items":"center","justify-content":"center","flex-direction":"column","padding":"0px 25px"}},[_c('h2',{staticClass:"text-center fc-1",class:_vm.status == false ? 'fc-1' : 'fc-2',staticStyle:{"margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.status != true)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"E-Posta"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.status != true)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token),expression:"token"}],staticClass:"form-input",attrs:{"type":"text","placeholder":"Kod"},domProps:{"value":(_vm.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.token=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.status != true)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-input",attrs:{"type":"password","placeholder":"Yeni Şifreniz"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.status == true)?_c('button',{staticClass:"confirm-button",on:{"click":function($event){return _vm.$router.push({name: 'Login'})}}},[_vm._v("Giriş Yap")]):_vm._e(),_vm._v(" "),(_vm.status != 200)?_c('button',{staticClass:"confirm-button",on:{"click":_vm.activate}},[_vm._v("Şifre Güncelle")]):_vm._e()]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Caylak_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c333f8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Caylak_vue__ = __webpack_require__(475);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Caylak_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c333f8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Caylak_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"content-block py-3"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 p-0 pt-3"},[_c('button',{staticClass:"confirm-button",on:{"click":function($event){return _vm.$buy('http://maps.google.com/maps?q=40.9886324,28.8517036')}}},[_vm._v("BENİ MAÇA GÖTÜR!")])])])])])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-box position-relative row",staticStyle:{"z-index":"99"}},[_c('div',{staticClass:"header-area position-absolute w-100 bg-transparent border-0 fc-5",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"#"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"-15px","margin-right":"-15px","position":"relative"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/sinanerdem.png"}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute",staticStyle:{"z-index":"9999","bottom":"20px","left":"20px"}},[_vm._v("Çaylak")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n              Metrobüsten Şirinevler durağında inip, Ataköy tarafından çıkış\n              yaparak, kısa bir yürüyüşle salona ulaşabilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Yenikapı - Atatürk Havalimanı (M1A) Metro hattında, Ataköy\n              durağında inip kısa bir yürüyüşle salona ulaşabilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Ataköy Marmaray istasyonunda inip, kısa bir yürüyüş ile\n              salona ulaşabilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Kadıköy ve Bostancı’dan Deniz Otobüsü ile Bakırköy’e\n              gelerek bu noktadan kısa bir taksi yolculuğu ile salona\n              ulaşabilirsin ya da MR20 otobüsünü kullanarak salona\n              gelebilirsin.\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Ya da;")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SosyalSorumlulukProjeleri_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3a22914_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SosyalSorumlulukProjeleri_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SosyalSorumlulukProjeleri_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3a22914_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SosyalSorumlulukProjeleri_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_02.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_03.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_04.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_05.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/pembe_top_sahada_06.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_02.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_03.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bir_kitap_sen_getir_04.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/one_team_2015_02.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/one_team_2016_02.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/one_team_2018_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/one_team_2019_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/okyanus_koleji_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/okyanus_koleji_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/zalgiris_deplasman_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/zalgiris_deplasman_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bilecikli_sporcular_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bilecikli_sporcular_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bremen_mizikacilari_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/bremen_mizikacilari_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":false,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/gaziler_macta.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-header p-0"},[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":true,"paginationSize":8,"paginationPadding":3},on:{"pageChange":_vm.pageChange}},[_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/gorme_engellilere_mac_01.jpg"}})])]),_vm._v(" "),_c('slide',[_c('div',{staticClass:"fixture-item"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/kss/600x400/gorme_engellilere_mac_02.jpg"}})])])],1)],1),_vm._v(" "),_vm._m(10)])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21)])])]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-box position-relative row",staticStyle:{"z-index":"99"}},[_c('div',{staticClass:"header-area position-absolute w-100 bg-transparent border-0 fc-5",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"#"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"-15px","margin-right":"-15px","position":"relative"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://anadoluefessk.org/assets/img/header-kss.jpg"}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute",staticStyle:{"z-index":"9999","bottom":"20px","left":"20px"}},[_vm._v("\n          Sosyal Sorumluluk\n          Projeleri\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Pembe Top Sahada")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü, her sezon Euroleague’de oynadığı ilk iç saha maçında, “Meme Kanseri Farkındalık Ayı” kapsamında Anadolu Sağlık Merkezi iş birliğiyle “Pembe Top Sahada” projesini gerçekleştirmektedir. Altı kez düzenlenen proje kapsamında Pembe Top maçlarının hava atışı, projenin gönüllü destekçileri Beren Saat, Bergüzar Korel, Sinem Kobal, Elçin Sangu, Özge Özpirinçci ve Bensu Soral tarafından pembe top ile gerçekleştirilmiştir.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Bir Kitap da Sen Getir")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü tarafından 2015 yılından bu yana düzenli bir şekilde gerçekleştirilen Bir Kitap da Sen Getir projesi, her yıl Kütüphaneler Haftası’nda düzenlenmektedir. Basketbolseverler, kampanya kapsamında seçilen maç için bilet almak yerine kitap getirerek salona giriş yapabilmektedir. Her yıl kampanya çerçevesinde basketbolseverlerden toplanan binlerce kitap, Anadolu Eğitim ve Sosyal Yardımlaşma Vakfı desteğiyle ihtiyaç sahibi okullara ulaştırılmaktadır. Anadolu Efes, Bir Kitap da Sen Getir Kampanyası’nı beşinci kez Basketbol Süper Ligi’ndeki Anadolu Efes – Bahçeşehir Koleji maçında gerçekleştirmiştir.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("EuroLeague One Team Projeleri")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Euroleague’in, Turkish Airlines EuroLeague ve EuroCup organizasyonlarına katılan 40 takımı entegre ettiği bir kurumsal sosyal sorumluluk programı olan One Team’de basketbol, toplumda gerçek bir sosyal etki elde etmek için bir araç olarak kullanılmaktadır. One Team programında “toplumsal entegrasyon” teması altında çalışmalar yapılmaktadır. Her kulüp kendi topluluğunun ihtiyaçlarına yönelik özel bir One Team projesi geliştirmektedir.")]),_vm._v(" "),_c('h4',[_vm._v("2019-2020 Beylikdüzü Belediyesi One Team Projesi:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("2018-2019 sezonundaki proje, Beylikdüzü Belediyesi’yle birlikte devam ettirilerek, katılımcıların edindikleri faydanın sürekli hale getirilmesi amaçlanmıştır.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("2018-2019 Özel Olimpiyatlar Türkiye One Team Projesi:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Bu projede hem Özel Olimpiyatlar Türkiye hem de Beylikdüzü Belediyesi ile birlikte yaptığımız iş birliği ile down sendromlu özel sporcuların kişisel gelişimlerine katkıda bulunulması amaçlanmıştır.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("2017-2018 Sezonu Okyanus Kolejleri One Team Projesi:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Projenin amacı, hızla gelişen teknolojinin hayatımızı kolaylaştırırken bir yandan da fiziksel olarak bizleri yavaşlattığı gerçeğini kabul ederek, çocuklara spor yapma alışkanlığı kazandırmaktı.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("2016-2017 Sezonu Anadolu Etap-MİÇO (Misafir İşçi Çocukları) One Team Projesi:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Projenin amacı, yaz tatillerinde aileleri ile birlikte Anadolu Etap’ın çiftliklerine gelen mevsimlik işçi çocuklarının basketbol ile tanıştırılması ve bu sayede sosyalleşmeleriydi.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("2016-2017 Sezonu Koruncuk Vakfı One Team Projesi:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Projenin temel amacı, korunma altına alınmış çocukların kaybolmuş özgüvenlerini basketbolun metaforları ile geri kazandırmak ve geleceğe umutla bakan bireyler haline getirmekti.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("2015-2016 Sezonu Tozkoparan Ortaokulu One Team projesi:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Projenin temel amacı, erken okul terkine karşı basketbolun metaforları ile çocuklara okul sevgisi kazandırmak ve geleceğe umutla bakmalarını sağlamaktı.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("2014-2015 Sezonu: Özel Sporcular Abdi İpekçi’de:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Euroleague’in sosyal sorumluluk programı “One Team” kapsamında Anadolu Efes - Sassari karşılaşması öncesinde Özel Olimpiyatlar sporcuları seyircileri selamladı. Zihinsel engelli çocukların topluma kazandırılmasını amaçlayan Özel Olimpiyatlar Hareketi’nin sporcuları Anadolu Efes ve Sassari takım oyuncuları ile birlikte sahaya girerek basketbolcu ağabeyleri ile birlikte fotoğraf çektirdi.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü, 2016 – 2017 sezonunda Anadolu Etap ve Koruncuk Vakfı, 2017-2018 sezonunda da Okyanus Kolejleri ile birlikte gerçekleştirdiği projelerle Euroleague tarafından “One Team Ödülü”ne aday gösterilmiş ve son 5 takım arasına kalmıştır.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("2018-2019 sezonunda Özel Olimpiyatlar Türkiye ile gerçekleştirilen proje ise EuroLeague ve EuroCup’ta yer alan 40’tan fazla kulübün projeleri arasından en iyi seçilerek EuroLeague Altın Ödülü’ne layık görülmüştür. Böylece altın ödül, ilk kez bir Türk kulübü tarafından kazanılmıştır.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü’nün 2019 – 2020 sezonunda gerçekleştirdiği One Team projesi de EuroLeague tarafından One Team Ödülleri’nde finale kalan projeler arasında gösterilmiştir.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Spor ile Eğitim Aynı Platformda")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü ile Okyanus Koleji arasında gerçekleştirilen iş birliği kapsamında, Anadolu Efes altyapısında oynayan sporcular, evlerine yakın okullarda eğitim alarak ulaşım stresi ve zaman kaybı yaşamayacak. Böylece altyapı oyuncuları, hem eğitim hayatlarına hem de basketbola daha kolay konsantre olabilecekler. Anadolu Efes Spor Kulübü altyapı takımlarında forma giyen 80’e yakın oyuncu, şu an Okyanus Koleji kampüslerinde eğitim hayatına devam ediyor.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Down Sendromlu Gençlerin Litvanya’ya Götürülmesi")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü, Zalgiris Kaunas ve Special Olympics’in destekleriyle “21 Mart Dünya Down Sendromu Günü kapsamında Down Sendromu Derneği’nden iki genci Zalgiris Kaunas deplasmanına götürdü. Takım uçağında Litvanya’ya seyahat eden gençler, Special Olympics Litvanya bünyesindeki altı Litvanyalı sporcu ile birlikte karşılaşmanın devre arasında seyircileri selamladı. Ayrıca Şule İnan ve Robert Cem Osborn, devre arasında Litvanyalı sporcular ile yaptıkları basketbol yarışmasında da binlerce seyircinin önünde basket attı. Tüm taraftarlar down sendromlu gençleri ve sporcuları ayakta alkışladı. Bu proje ile birlikte oluşan sinerji sonrasında Anadolu Efes Spor Kulübü ve Zalgiris Kaunas kardeş kulüp oldular.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Olympiacos karşılaşmasında Bilecikli genç basketbolcuları ağırladık")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Türk basketbolunda ilklerin öncüsü Anadolu Efes Spor Kulübü, Bilecik Bozüyük Mehmet Akif Ersoy Ortaokulu’nun kız basketbolcularına unutulmaz bir gün yaşattı. Gerçekleştirdiği sosyal sorumluluk projelerinde basketbol sevgisinin daha geniş kitlelere ulaşmasını sağlayan Anadolu Efes, Adana Vakıfbank Ortaokulu’yla karşı karşıya geldikleri maçta aldıkları farklı mağlubiyet sonrasında fazlasıyla üzülen ve kamuoyunun dikkatini çeken kız basketbolcuları, Olympiacos karşılaşmasında ağırladı. Genç basketbolcular, karşılaşma öncesinde Anadolu Efes’in başarılı oyuncuları kaptan Doğuş Balbay ve Cedi Osman’la tanışırken maç öncesinde Anadolu Efes oyuncuları için bir çıkış koridoru da oluşturdular. Ayrıca genç basketbolcuların Abdi İpekçi Spor Salonu’nda oldukları anons edildiğinde, tüm basketbolseverler Bilecikli konukları ayakta alkışladılar.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Bremen Mızıkacıları Abdi İpekçi’de")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü’nün Turkish Airlines Euroleague Top 16 E Grubu’nun 11. haftasında Hırvatistan temsilcisi Cedevita Zagreb’i ağırladığı karşılaşmanın devre arasında zihinsel engelli çocuklardan oluşan Bremen Mızıkacıları Perküsyon Grubu, mini bir konser verdi. Karşılaşmanın devre arasında benzersiz bir performans sergileyen Bremen Mızıkacıları Perküsyon Grubu, basketbolseverler tarafından dakikalarca ayakta alkışlandı.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Gazilerin Euroleague Maçında Ağırlanması")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü’nün Turkish Airlines Euroleague Top 16 E Grubu’nun 11. haftasında Hırvatistan temsilcisi Cedevita Zagreb’i ağırladığı karşılaşmanın devre arasında zihinsel engelli çocuklardan oluşan Bremen Mızıkacıları Perküsyon Grubu, mini bir konser verdi. Karşılaşmanın devre arasında benzersiz bir performans sergileyen Bremen Mızıkacıları Perküsyon Grubu, basketbolseverler tarafından dakikalarca ayakta alkışlandı.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Görme Engellilere Canlı Maç Anlatımı")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü’nün Turkish Airlines Euroleague Top 16 E Grubu’nun 11. haftasında Hırvatistan temsilcisi Cedevita Zagreb’i ağırladığı karşılaşmanın devre arasında zihinsel engelli çocuklardan oluşan Bremen Mızıkacıları Perküsyon Grubu, mini bir konser verdi. Karşılaşmanın devre arasında benzersiz bir performans sergileyen Bremen Mızıkacıları Perküsyon Grubu, basketbolseverler tarafından dakikalarca ayakta alkışlandı.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Darülaceze Ziyareti")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes’in yıldız oyuncuları Doğuş Balbay, Birkan Batuk ve Stratos Perperoglou, kulübün resmi sponsoru Sarar ile birlikte Darülaceze’yi ziyaret etti. Ziyaret, toplumda yardıma ihtiyacı olan kişilere dikkat çekmek ve sivil toplum kuruluşlarını gündeme taşıyarak toplumsal bilincin oluşmasını desteklemek amacıyla gerçekleştirildi.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Darülaceze Ziyareti")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes’in yıldız oyuncuları Doğuş Balbay, Birkan Batuk ve Stratos Perperoglou, kulübün resmi sponsoru Sarar ile birlikte Darülaceze’yi ziyaret etti. Ziyaret, toplumda yardıma ihtiyacı olan kişilere dikkat çekmek ve sivil toplum kuruluşlarını gündeme taşıyarak toplumsal bilincin oluşmasını desteklemek amacıyla gerçekleştirildi.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Doğudan Batıya Minik Yürekler")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Doğu bölgelerimizde yaşayan öğrencilerin Anadolu Efes’in bir Euroleague maçına davet edilerek İstanbul’da ağırlandı. Akvaryum, Forum İstanbul vb yerlerde gezdirilmesi ve küçük bir İstanbul gezisi organize edildi.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Mavi Buluşmalar")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü oyuncuları, Tohum Otizm Vakfı’nı ziyaret etti. Ziyaret sonrasında vakıf bünyesindeki bireyler Euroleague maçında ağırlandı.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Basketbol Topu Kumbarası Kampanyası")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü’nün 35. kuruluş yılı etkinlikleri kapsamında Herkes için Spor Federasyonu desteğiyle yapılan kampanyada, Anadolu Efes Spor Kulübü’nün 35. yılındaki resmi maçlarda attığı basket sayısı kadar top, Düzce’de bulunan 12 ortaokula bağışlandı.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("35. Yıl Etkinlikleri")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("35. yıl etkinlikleri kapsamında Siirt Mehmet Akif Ersoy İlköğretim Okulu’na basketbol sahası yapılırken, Kastamonu ve Aksaray’da da basketbol sahaları yapıldı.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Zihinsel Engelli Çocukları Ziyaret")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("İstanbul Ümraniye’deki bir merkezde bulunan zihinsel engelli çocuklar ziyaret edildi.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Böbrek Vakfı Ziyareti")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü oyuncuları, Böbrek Vakfı Hastanesi’nde tedavi gören vatandaşlarımızı ziyaret ettiler.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Hakkari’de Basketbol Başkadır")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Hakkari’de bir edebiyat öğretmeni tarafından kurulan basketbol takımının en büyük hayalleri olan Abdi İpekçi Arena’da maç seyretme hayalleri gerçekleştirildi. Kızlı –erkekli 15 kişilik takım Hakkari’den İstanbul’a davet edilerek hem Abdi İpekçi Arena’da sahaya çıktılar, hem Anadolu Efes Basketbol Takımı ile tanıştılar hem de 2 gün süresince İstanbul’u gezme fırsatı elde ettiler.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Efes ile İlk Adım Basketbol Okulları")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Edirne’den Hakkari’ye Kıbrıs’tan Giresun’a 42 farklı merkezde 9 yılda yaklaşık 22 bin çocuğa ücretsiz basketbol eğitimi verildi. Sadece çocuklara değil, aynı zamanda görevli teknik kadroya da eğitim programları düzenleyen “Efes ile İlk Adım Basketbol Okulları”, Anadolu Efes Spor Kulübü’nün uzman eğitmen kadrosu ve Gençlik ve Spor Genel Müdürlüğü’nün altyapı desteği ile Türkiye’de basketbol sporunu küçük yaştan başlayarak sevdirmeyi ve imkanı olmayan çocukların basketbol oynamalarını sağlamayı hedefledi.")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Efes İle İlk Adım projesi kapsamında basketbol ve eğlencenin buluştuğu “Anadolu Efes İğneada Kampları” ile sporun ve basketbolun felsefesini ve faydalarını anlatmak amacıyla Efes ile İlk Adım Panelleri düzenlendi.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("30.Yıl Etkinlikleri-Efes Akademi")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes Spor Kulübü’nün 30.yılında genç takım oyuncularının sosyal beceri ve motivasyon kazanması için “Efes Akademi” programı gerçekleştirildi. Sporcuların hem sosyal, hem profesyonel hayatta kişisel gelişimlerini sağlamayı hedefleyen Anadolu Efes, “Efes Akademi” programı ile bir ilke daha imza attı.")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Anadolu Efes’in genç oyuncuları için düzenlediği “Efes Akademi” ile daha iyi basketbol oynamanın yanı sıra danstan sofra adabına her türlü centilmenlik kurallarını öğretilmesi hedeflendi. Hafta içi beş gün, toplam 12 saat süren “Efes Akademi” programında yer alan dersler; diksiyon, güzel ve etkili konuşma, yaratıcı drama, İngilizce, sporcu beslenmesi, spor psikolojisi, spor sakatlıkları ve ilk yardım, doping, spor gazeteciliği, ritimdans ve satranç oldu.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuvenlikKamerasiAydinlatmaMetni_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7eee46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuvenlikKamerasiAydinlatmaMetni_vue__ = __webpack_require__(479);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuvenlikKamerasiAydinlatmaMetni_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7eee46_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuvenlikKamerasiAydinlatmaMetni_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-area"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"slider-box position-relative row",staticStyle:{"z-index":"99"}},[_c('div',{staticClass:"header-area position-absolute w-100 bg-transparent border-0 fc-5",staticStyle:{"z-index":"9"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"back-arrow mt-4"})])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('a',{attrs:{"href":"#"}})])])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"-15px","margin-right":"-15px","position":"relative"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/img/sinanerdem.png"}}),_vm._v(" "),_c('h1',{staticClass:"fs-32 fc-5 slider-title position-absolute",staticStyle:{"z-index":"9999","bottom":"20px","left":"20px"}},[_vm._v("\n          Aydınlatma Bildirimi\n        ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('div',{staticClass:"item-box"},[_c('div',{staticClass:"box-title"},[_c('h1',{staticClass:"fc-2 fs-20 pb-3"},[_vm._v("Güvenlik Kameraları ile İşlenen Görüntülerinize İlişkin Kişisel Verilerinizin Korunması Hakkında Aydınlatma Bildirimi")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("1.\tAMAÇ VE KAPSAM")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("Anadolu Efes Spor Kulübü Derneği (“Anadolu Efes Spor Kulübü”) binamız içerisinde aşağıda açıklanan belirli noktalarda; çalışanlarımızın, binada bulunan ifa yardımcılarımızın ve ziyaretçilerimizin güvenliği için CCTV (Kapalı Devre Televizyon) ile kamera kaydı alınmaktadır. İşbu Aydınlatma Bildirimi ile, bu sistemler aracılığı ile kişisel verilerinizin nasıl işlendiği konusunda sizleri 6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) uyarınca sizleri aydınlatmak isteriz.")]),_vm._v(" "),_c('h4',[_vm._v("2.\tVERİ İŞLEME FAALİYETLERİMİZ HAKKINDA BİLGİLER")]),_vm._v(" "),_c('h5',[_vm._v("2.1.\tVeri Sorumlusu’nun Kimliği")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("Aşağıda detaylıca açıklanan veri işleme faaliyetleri bakımından Veri Sorumlusu Anadolu Efes Spor Kulübü Derneği’dir.")]),_vm._v(" "),_c('h5',[_vm._v("2.2.\tHangi Kişisel Verilerinizin Hangi Amaç ve Hukuki Sebeplerle İşleneceği")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("Anadolu Efes Spor Kulübü binası içerisindeki otopark, bina dış cephesi, giriş kapıları, giriş desk ve bekleme salonu, kafeterya ve kat koridorlarında bulunan toplam 51 adet güvenlik kamerası vasıtasıyla binada can ve mal güvenliğinin sağlanması amacıyla görüntü kaydı yapılmakta ve kayıt işlemi denetlenmektedir. Kamera ile kaydedilen görüntüleriniz, Kanunun 5/2-f maddesinde yer alan “ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması” hukuki sebebine dayanarak işlenmektedir. Veri sorumlusu olarak Anadolu Efes Spor Kulübü’nün meşru menfaati, bina içerisinde derneğin ve içerisinde bulunan çalışan, ifa yardımcıları ve ziyaretçilerinin can ve mal güvenliğinin sağlanmasıdır. Güvenlik kameralarının izleme alanları, sayısı ve ne zaman izleme yapılacağı, güvenlik amacına ulaşmak için yeterli ve bu amaçla sınırlı olarak uygulamaya alınmaktadır. Kişinin mahremiyetine güvenlik amaçlarını aşan şekilde müdahale sonucu doğurabilecek alanlarda izlemeye tabi tutulmamaktadır. Dolayısıyla ilgili kişilerin temel hak ve özgürlüklerine zarar verilmemektedir.")]),_vm._v(" "),_c('h5',[_vm._v("2.3.\tKişisel Verilerinizi Hangi Üçüncü Kişilerle ve Hangi Amaçlar Doğrultusunda Paylaşırız?")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("Kamera ile kaydedilen görüntüleriniz, Kanunun 5/2-f maddesinde yer alan “ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması” hukuki sebebine dayanarak; Anadolu Efes Spor Kulübü’nün, çalışanlarımızın, binada bulunan ifa yardımcılarının ve ziyaretçilerinin can ve mal güvenliğini ilgilendiren hukuki uyuşmazlıkların giderilmesi amacıyla ve/veya 5/2-ç “veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması” hukuki sebebine dayanarak ilgili mevzuat gereği veya talep halinde adli makamlar veya ilgili kolluk kuvvetlerine aktarılabilecektir.")]),_vm._v(" "),_c('h5',[_vm._v("2.4.\t Kişisel Verilerinizi Hangi Yöntemlerle İşleriz? ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("İşbu Aydınlatma Metni’nin konusu olan kişisel verileriniz (görüntüleriniz) 2.2. paragrafta sistem, konum ve sayıları detaylıca açıklanan güvenlik kameraları sistemi vasıtasıyla otomatik yöntemlerle işlenmektedir.  ")]),_vm._v(" "),_c('h4',[_vm._v("3.\tKİŞİSEL VERİ SAHİBİ OLARAK KANUNİ HAKLARINIZ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("6698 sayılı Kanun’un “İlgili Kişinin Hakları” başlıklı 11. Maddesi kapsamındaki hak ve taleplerinizi aşağıda belirtilen yöntemlerle kullanabilirsiniz:")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("www.anadoluefessk.org adresinde bulunan Başvuru Formu’nu formda yazan talimatlara uygun olarak doldurarak, formun imzalı bir nüshasını; Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ uyarınca;")]),_vm._v(" "),_c('ul',{staticStyle:{"list-style":"disc","padding":"1em"}},[_c('li',{staticStyle:{"list-style":"disc"}},[_vm._v("Kimliğinizi tespit edici belgeler ile Mahmutbey Mahallesi Ordu Caddesi 2581 Sokak No:3 Bağcılar/İstanbul adresine bizzat başvurarak,")]),_vm._v(" "),_c('li',{staticStyle:{"list-style":"disc"}},[_vm._v("Noter kanalı ile Mahmutbey Mahallesi Ordu Caddesi 2581 Sokak No:3 Bağcılar/İstanbul adresine ileterek,")]),_vm._v(" "),_c('li',{staticStyle:{"list-style":"disc"}},[_vm._v("anadoluefessporkulubu@hs03.kep.tr adresine güvenli elektronik imzalı olarak veya bulunuyorsa AESK’da kayıtlı elektronik posta adresinizden göndermek suretiyle iletebilirsiniz.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify","padding-bottom":"0.5em","padding-top":"0.5em"}},[_vm._v("AESK; talebin niteliğine göre talebi en kısa sürede ve en geç 30 (otuz) gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyet gerektirmesi halinde, AESK tarafından Kişisel Verileri Koruma Kurulu’nca belirlenen ücret alınacaktır.  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Anadolu Efes Spor Kulübü Derneği")]),_c('br'),_vm._v("Mahmutbey Mahallesi Ordu Caddesi 2581 Sokak No:3 Bağcılar/İstanbul"),_c('br'),_vm._v("www.anadoluefessk.org"),_c('br'),_vm._v("0212 - 449 38 00")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Agile_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1f0ce51c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Agile_vue__ = __webpack_require__(499);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Agile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1f0ce51c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Agile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agile",class:{'agile--ssr': _vm.isSSR, 'agile--auto-play': _vm.settings.autoplay, 'agile--disabled': _vm.settings.unagile, 'agile--fade': _vm.settings.fade && !_vm.settings.unagile, 'agile--rtl': _vm.settings.rtl, 'agile--no-nav-buttons': !_vm.settings.navButtons},on:{"touchstart":function () {}}},[_c('div',{ref:"list",staticClass:"agile__list"},[_c('div',{ref:"track",staticClass:"agile__track",style:({transform: ("translate(" + (_vm.translateX + _vm.marginX) + "px)"), transition: ("transform " + (_vm.settings.timing) + " " + _vm.transitionDelay + "ms")}),on:{"mouseover":function($event){return _vm.handleMouseOver('track')},"mouseout":function($event){return _vm.handleMouseOut('track')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slidesCloned),expression:"slidesCloned"}],ref:"slidesClonedBefore",staticClass:"agile__slides agile__slides--cloned"},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"slides",staticClass:"agile__slides agile__slides--regular"},[_vm._t("default")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slidesCloned),expression:"slidesCloned"}],ref:"slidesClonedAfter",staticClass:"agile__slides agile__slides--cloned"},[_vm._t("default")],2)])]),_vm._v(" "),(_vm.$slots.caption)?_c('div',{staticClass:"agile__caption"},[_vm._t("caption")],2):_vm._e(),_vm._v(" "),(!_vm.settings.unagile && (_vm.settings.navButtons || _vm.settings.dots))?_c('div',{staticClass:"agile__actions"},[(_vm.settings.navButtons && !_vm.settings.unagile)?_c('button',{ref:"prevButton",staticClass:"agile__nav-button agile__nav-button--prev",attrs:{"disabled":!_vm.canGoToPrev,"type":"button"},on:{"click":function($event){_vm.goToPrev(), _vm.restartAutoPlay()}}},[_vm._t("prevButton",function(){return [_vm._v("\n\t\t\t\t←\n\t\t\t")]})],2):_vm._e(),_vm._v(" "),(_vm.settings.dots && !_vm.settings.unagile)?_c('ul',{ref:"dots",staticClass:"agile__dots"},_vm._l((_vm.countSlides),function(n){return _c('li',{key:n,staticClass:"agile__dot",class:{'agile__dot--current': n - 1 === _vm.currentSlide},on:{"mouseover":function($event){return _vm.handleMouseOver('dot')},"mouseout":function($event){return _vm.handleMouseOut('dot')}}},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.goTo(n - 1), _vm.restartAutoPlay()}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(n)+"\n\t\t\t\t")])])}),0):_vm._e(),_vm._v(" "),(_vm.settings.navButtons && !_vm.settings.unagile)?_c('button',{ref:"nextButton",staticClass:"agile__nav-button agile__nav-button--next",attrs:{"disabled":!_vm.canGoToNext,"type":"button"},on:{"click":function($event){_vm.goToNext(), _vm.restartAutoPlay()}}},[_vm._t("nextButton",function(){return [_vm._v("\n\t\t\t\t→\n\t\t\t")]})],2):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[307]);


// WEBPACK FOOTER //
// static/js/app.3fbe043c51af655af9b1.js